export const districtCourtMapping = {
  "states": {
    "1": {
      "name": "Maharashtra",
      "districts": {
        "1": {
          "name": "Nandurbar",
          "courtComplexes": {
            "1010035@1,2,3@N": {
              "name": "Nandurbar, Dist and Session Court"
            },
            "1010036@5,6,7@N": {
              "name": "Shahada, District and Session Court"
            },
            "1010037@4@N": {
              "name": "Taloda, Civil and Criminal Court"
            },
            "1010038@9@N": {
              "name": "Akkalkuwa, Civil and Criminal Court"
            },
            "1010039@8@N": {
              "name": "Nawapur, Civil and Criminal Court"
            },
            "1010040@10@N": {
              "name": "Dhadgaon, Civil and Criminal Court"
            }
          }
        },
        "2": {
          "name": "Dhule",
          "courtComplexes": {
            "1010041@4@N": {
              "name": "Dondaicha, Civil and Criminal Court"
            },
            "1010043@5@N": {
              "name": "Sakri, Civil and Criminal Court"
            },
            "1010045@1,2,3@N": {
              "name": "Dhule, District and Sessions Court"
            },
            "1010046@7@N": {
              "name": "Shirpur, Civil and Criminal Court"
            },
            "1010047@6@N": {
              "name": "Shindkheda,Civil and Criminal Court"
            }
          }
        },
        "3": {
          "name": "Jalgaon",
          "courtComplexes": {
            "1010048@18@N": {
              "name": "Yawal, Civil and Criminal Court"
            },
            "1010049@1@N": {
              "name": "Dharangaon,Civil and Criminal Court"
            },
            "1010050@10@N": {
              "name": "Bhusawal, Railway Court"
            },
            "1010051@2,3,4@N": {
              "name": "Jalgaon,District and Sessions Court"
            },
            "1010052@14@N": {
              "name": "Jamner, Civil and Criminal Court"
            },
            "1010053@22@N": {
              "name": "Chalisgaon Civil Court SD"
            },
            "1010054@11@N": {
              "name": "Chalisgaon,Civil and Criminal Court"
            },
            "1010055@5,6,7@N": {
              "name": "Amalner, District and Session Court"
            },
            "1010056@9,20,21@N": {
              "name": "Bhusawal, Dist and Session Court"
            },
            "1010057@17@N": {
              "name": "Parola, Civil and Criminal Court"
            },
            "1010058@19@N": {
              "name": "Raver, Civil and Criminal Court"
            },
            "1010059@16@N": {
              "name": "Pachora, Civil and Criminal Court"
            },
            "1010060@8@N": {
              "name": "Bhadgaon, Civil and Criminal Court"
            },
            "1010061@12@N": {
              "name": "Chopda, Civil and Criminal Court"
            },
            "1010062@15@N": {
              "name": "Muktainagar, Civil and Criminal Ct"
            },
            "1010063@13@N": {
              "name": "Erandol, Civil and Criminal Court"
            }
          }
        },
        "4": {
          "name": "Buldhana",
          "courtComplexes": {
            "1010064@1,2,3@N": {
              "name": "Buldhana,District and Session Court"
            },
            "1010065@4@N": {
              "name": "Chikhli, Civil and Criminal Court"
            },
            "1010066@9,10,11@N": {
              "name": "Khamgaon, Dist and Session court"
            },
            "1010067@22@N": {
              "name": "Lonar, Civil and Criminal Court"
            },
            "1010069@5@N": {
              "name": "Deulgaon Raja, Civil and Criminal"
            },
            "1010071@12@N": {
              "name": "Nandura, Civil and Criminal Court"
            },
            "1010072@18@N": {
              "name": "Sangrampur,Civil and Criminal Court"
            },
            "1010073@7,20,21@N": {
              "name": "Mehkar, Civil and Criminal Court"
            },
            "1010074@8,14,15@N": {
              "name": "Malkapur, Civil and Criminal Court"
            },
            "1010075@6@N": {
              "name": "Jalgaon Jamod, Civil Criminal Court"
            },
            "1010076@13@N": {
              "name": "Shegaon, Civil and Criminal Court"
            },
            "1010077@16@N": {
              "name": "Motala, Civil and Criminal Court"
            },
            "1010078@19@N": {
              "name": "Sindkhed Raja, Civil and Criminal"
            }
          }
        },
        "5": {
          "name": "Akola",
          "courtComplexes": {
            "1010079@8@N": {
              "name": "Murtizapur, Civil and Criminal Cour"
            },
            "1010080@1,2,3@N": {
              "name": "Akola, District and Sessions Court"
            },
            "1010081@4,5@N": {
              "name": "Akot, District and Sessions Court"
            },
            "1010082@7@N": {
              "name": "Barshitakli, Civil and Criminal"
            },
            "1010083@9@N": {
              "name": "Patur, Civil and Criminal Court"
            },
            "1010085@6@N": {
              "name": "Balapur, Civil and Criminal Court"
            },
            "1010086@10@N": {
              "name": "Telhara, Civil and Criminal Court"
            }
          }
        },
        "7": {
          "name": "Amravati",
          "courtComplexes": {
            "1010088@7@N": {
              "name": "Surji, Civil and Criminal Court"
            },
            "1010089@17,20@N": {
              "name": "Daryapur, Additional District Court"
            },
            "1010090@10@N": {
              "name": "Morshi, Civil and Criminal Court"
            },
            "1010091@16@N": {
              "name": "Dharni, Civil and Criminal Court"
            },
            "1010092@15@N": {
              "name": "Teosa, Civil and Criminal Court"
            },
            "1010093@1,2,3@N": {
              "name": "Amravati, District and Sessions"
            },
            "1010094@4,5,6@N": {
              "name": "Achalpur, District and ASJ Court"
            },
            "1010095@11,19@N": {
              "name": "Warud, Civil and Criminal Court"
            },
            "1010096@13@N": {
              "name": "Nandgaon Khandeshwar, Civil Court"
            },
            "1010097@14@N": {
              "name": "Bhatkuli, Civil and Criminal Court"
            },
            "1010098@8@N": {
              "name": "Chandur Bazar, Civil and Criminal C"
            },
            "1010099@12@N": {
              "name": "Chandur Railway, Civil and Criminal"
            },
            "1010100@9@N": {
              "name": "Dhamangaon, Railway Court"
            }
          }
        },
        "8": {
          "name": "Wardha",
          "courtComplexes": {
            "1010101@1@N": {
              "name": "Wardha, District and Sessions New B"
            },
            "1010102@5@N": {
              "name": "Karanaja, Gh, Civil and Criminal"
            },
            "1010103@9@N": {
              "name": "Seloo, Civil and Criminal Court"
            },
            "1010104@2,3@N": {
              "name": "Wardha, District and Sessions Old B"
            },
            "1010105@4,11,12@N": {
              "name": "Hinganghat, Civil and CriminalCourt"
            },
            "1010106@7,13@N": {
              "name": "Arvi, Civil and Criminal Court"
            },
            "1010107@10@N": {
              "name": "Samudrapur,Civil and Criminal Court"
            },
            "1010108@8@N": {
              "name": "Ashti, Civil and Criminal"
            },
            "1010109@6@N": {
              "name": "Pulgaon, Civil and Criminal Court"
            }
          }
        },
        "9": {
          "name": "Nagpur",
          "courtComplexes": {
            "1010110@15@N": {
              "name": "Hingna, Civil and Criminal Court"
            },
            "1010111@14@N": {
              "name": "Bhiwapur, Civil and Criminal Court"
            },
            "1010112@16@N": {
              "name": "Mouda, Civil and Criminal Court"
            },
            "1010113@17@N": {
              "name": "Kalmeshwar, Civil and Criminal Cour"
            },
            "1010114@13@N": {
              "name": "Narkhed, Civil and Criminal Court"
            },
            "1010115@11,19@N": {
              "name": "Katol, Civil and Criminal Court"
            },
            "1010116@12@N": {
              "name": "Kuhi, Civil and Criminal Court"
            },
            "1010117@10@N": {
              "name": "Kamptee, Civil and Criminal Court"
            },
            "1010118@18@N": {
              "name": "Paresoni, Civil and Criminal Court"
            },
            "1010119@7@N": {
              "name": "Ramtek, Civil and Criminal Court"
            },
            "1010120@9@N": {
              "name": "Saoner, Civil and Criminal Court"
            },
            "1010121@6@N": {
              "name": "Umrer, Civil and Criminal Court"
            },
            "1010122@1,3,4,5,8@N": {
              "name": "Nagpur, District Sessions Court III"
            },
            "1010123@2@N": {
              "name": "Nagpur, District and Sessions Court"
            }
          }
        },
        "10": {
          "name": "Bhandara",
          "courtComplexes": {
            "1010125@5@N": {
              "name": "Pauni, Civil and Criminal Court"
            },
            "1010126@1,2,3@N": {
              "name": "Bhandara, Dist and Sessions Court"
            },
            "1010127@4@N": {
              "name": "Mohadi, Civil and Criminal Court"
            },
            "1010128@8@N": {
              "name": "Lakhandur, Civil and Criminal Court"
            },
            "1010129@9@N": {
              "name": "Lakhani, Civil and Criminal Court"
            },
            "1010130@7@N": {
              "name": "Tumsar, Civil and Criminal Court"
            },
            "1010131@6@N": {
              "name": "Sakoli, Civil and Criminal Court"
            }
          }
        },
        "11": {
          "name": "Gondia",
          "courtComplexes": {
            "1010132@1@N": {
              "name": "Amgaon, Civil and Criminal Court"
            },
            "1010133@3,4,5@N": {
              "name": "Gondia, District and Sessions Court"
            },
            "1010134@2@N": {
              "name": "Arjuni Morgaon, Civil and Criminal"
            },
            "1010135@8@N": {
              "name": "Sadak Arjuni, Civil and Criminal"
            },
            "1010136@7@N": {
              "name": "Deori, Civil and Criminal Court"
            },
            "1010137@6@N": {
              "name": "Tirora, Civil and Criminal Court"
            }
          }
        },
        "12": {
          "name": "Gadchiroli",
          "courtComplexes": {
            "1010138@10,11@N": {
              "name": "Charmoshi, Civil and Criminal Court"
            },
            "1010139@5@N": {
              "name": "Armori, Civil and Criminal Court"
            },
            "1010140@8,12@N": {
              "name": "Kurkheda, Civil and Criminal Court"
            },
            "1010141@4,13@N": {
              "name": "Aheri, Civil and Criminal Court"
            },
            "1010142@7@N": {
              "name": "Sironcha, Civil and Criminal Court"
            },
            "1010143@6@N": {
              "name": "Desaiganj Wadsa, Civil and Cri Ct"
            },
            "1010144@9@N": {
              "name": "Dhanora, Civil and Criminal Court"
            },
            "1010145@1,2,3@N": {
              "name": "Gadchiroli, Dist and Session Court"
            }
          }
        },
        "13": {
          "name": "Chandrapur",
          "courtComplexes": {
            "1010146@16@N": {
              "name": "Gondpipari, Civil and Cri Court"
            },
            "1010147@7@N": {
              "name": "Mul, Civil and Criminal Court"
            },
            "1010148@11@N": {
              "name": "Sindewahi, Civil and Criminal Court"
            },
            "1010149@9@N": {
              "name": "Rajura, Civil and Criminal Court"
            },
            "1010150@15@N": {
              "name": "Ballarpur, Civil and Criminal Court"
            },
            "1010151@13@N": {
              "name": "Warora, District and ASJ Court"
            },
            "1010152@12,14@N": {
              "name": "Warora, Civil and Criminal Court"
            },
            "1010153@1,2,3@N": {
              "name": "Chandrapur, Dist and Session Court"
            },
            "1010154@8@N": {
              "name": "Nagbhid, Civil and Criminal Court"
            },
            "1010155@17@N": {
              "name": "Pombhurna, Civil and Criminal Court"
            },
            "1010156@10@N": {
              "name": "Saoli, Civil and Criminal Court"
            },
            "1010157@6@N": {
              "name": "Chimur, Civil and Criminal Court"
            },
            "1010158@4@N": {
              "name": "Bhadrawati,Civil and Criminal Court"
            },
            "1010159@5@N": {
              "name": "Bramhapuri, Civil and Cri Court"
            },
            "1010509@18@N": {
              "name": "Korpana, Civil and Cri. Court"
            }
          }
        },
        "14": {
          "name": "Yavatmal",
          "courtComplexes": {
            "1010160@1,2,3@N": {
              "name": "Yavatmal, District and Sessions"
            },
            "1010161@20@N": {
              "name": "Arni, Civil and Criminal Court"
            },
            "1010162@19@N": {
              "name": "Wani, Civil and Criminal Court"
            },
            "1010163@15@N": {
              "name": "Ner, Civil and Criminal Court"
            },
            "1010164@4@N": {
              "name": "Babulgaon, Civil and Criminal Court"
            },
            "1010165@8@N": {
              "name": "Ghatanji, Civil Court"
            },
            "1010166@18,23@N": {
              "name": "Umarkhed, Civil Court"
            },
            "1010167@9@N": {
              "name": "Kalamb, Civil Court"
            },
            "1010168@16,17@N": {
              "name": "Pusad, Addl Sessions Court"
            },
            "1010169@14@N": {
              "name": "Maregaon, Civil Court"
            },
            "1010170@21@N": {
              "name": "Ralegaon, Civil and Criminal Court"
            },
            "1010171@5,6@N": {
              "name": "Darwha,Addl District Sessions Court"
            },
            "1010172@7@N": {
              "name": "Digras, Civil and Criminal Court"
            },
            "1010173@22@N": {
              "name": "Jamni, Civil and Criminal Court"
            },
            "1010174@13@N": {
              "name": "Mahagaon, Civil and Criminal Court"
            },
            "1010175@10,11,12@N": {
              "name": "Kelapur, District and ASJ Court"
            },
            "1370064@19,24@N": {
              "name": "Wani, Civil Judge Senior Division"
            }
          }
        },
        "15": {
          "name": "Nanded",
          "courtComplexes": {
            "1010176@25@N": {
              "name": "Mahoor, Civil and Criminal Court"
            },
            "1010177@19,20,22@N": {
              "name": "Bhokar, Civil and Criminal Court"
            },
            "1010178@1,2,3,4@N": {
              "name": "Nanded, District and Sessions Court"
            },
            "1010179@21@N": {
              "name": "Ardhapur, Civil and Criminal Court"
            },
            "1010180@27@N": {
              "name": "Umri, Civil and Criminal Court"
            },
            "1010181@14@N": {
              "name": "Hadgaon, Civil and Criminal Court"
            },
            "1010182@16,17@N": {
              "name": "Biloli, District and Sessions Court"
            },
            "1010183@5@N": {
              "name": "Loha, CJJD and JMFC Court"
            },
            "1010184@12@N": {
              "name": "Degloor, Civil and Criminal Court"
            },
            "1010185@26@N": {
              "name": "Mudkhed, Civil and Criminal Court"
            },
            "1010186@6,7,8@N": {
              "name": "Kandhar,District and Sessions Court"
            },
            "1010187@10@N": {
              "name": "Himayatnagar, Civil and Cri Court"
            },
            "1010188@13@N": {
              "name": "Kinwat, Civil and Criminal Court"
            },
            "1010189@18@N": {
              "name": "Dharmabad, Civil and Criminal Court"
            },
            "1010190@11@N": {
              "name": "Naigaon Bazar, Civil and Cri Court"
            },
            "1010191@15,23,24@N": {
              "name": "Mukhed, Civil and Criminal Court"
            }
          }
        },
        "16": {
          "name": "Hingoli",
          "courtComplexes": {
            "1010194@8@N": {
              "name": "Aundha Nagnath, Civil and Cri Court"
            },
            "1010196@9@N": {
              "name": "Senagaon, Civil and Criminal Court"
            },
            "1010197@4@N": {
              "name": "Basmath, Dist and Sessions Court"
            },
            "1010204@7@N": {
              "name": "Kalamnuri, Civil and Criminal Court"
            },
            "1010205@1,2,3@N": {
              "name": "Hingoli, Dist and Sessions Court"
            },
            "1010206@5,6@N": {
              "name": "Basmath, Civil and Criminal Court"
            }
          }
        },
        "17": {
          "name": "Parbhani",
          "courtComplexes": {
            "1010192@15@N": {
              "name": "Pathri, Civil and Criminal Court"
            },
            "1010193@19@N": {
              "name": "Manwat, Civil and Criminal Court"
            },
            "1010195@7,8,9@N": {
              "name": "Gangakhed, Civil and Criminal Court"
            },
            "1010198@20@N": {
              "name": "Palam, Civil and Criminal Court"
            },
            "1010199@17@N": {
              "name": "Selu, Civil and Criminal Court"
            },
            "1010200@16@N": {
              "name": "Purna, Civil and Criminal Court"
            },
            "1010201@22@N": {
              "name": "Sonpeth, Civil and Criminal Court"
            },
            "1010202@13@N": {
              "name": "Jintur, Civil and Criminal Court"
            },
            "1010203@1,2,3@N": {
              "name": "Parbhani, Dist and Sessions Court"
            }
          }
        },
        "18": {
          "name": "Jalna",
          "courtComplexes": {
            "1010207@5@N": {
              "name": "Bhokardan, Civil and Criminal Court"
            },
            "1010208@8@N": {
              "name": "Ghansavangi, Civil and Cri Court"
            },
            "1010209@2@N": {
              "name": "Jalna, Criminal Court"
            },
            "1010210@9@N": {
              "name": "Mantha, Civil and Criminal Court"
            },
            "1010211@7@N": {
              "name": "Partur, Civil and Criminal Court"
            },
            "1010212@4@N": {
              "name": "Ambad, Civil and Criminal Court"
            },
            "1010213@6@N": {
              "name": "Jafrabad, Civil and Criminal Court"
            },
            "1010214@3@N": {
              "name": "Jalna, Civil Court"
            },
            "1010215@10@N": {
              "name": "Badnapur, Civil and Criminal Court"
            },
            "1010216@1@N": {
              "name": "Jalna, District and Sessions Court"
            },
            "1010511@11@N": {
              "name": "Ambad, Dist and Addl.Sessions Court"
            }
          }
        },
        "19": {
          "name": "Aurangabad",
          "courtComplexes": {
            "1010217@3,4,5@N": {
              "name": "Aurangabad, District and Sessions"
            },
            "1010219@7@N": {
              "name": "Sillod, Civil and Criminal Court"
            },
            "1010220@11@N": {
              "name": "Phulambri, Civil and Criminal Court"
            },
            "1010221@8@N": {
              "name": "Soygaon, Civil and Criminal Court"
            },
            "1010222@12@N": {
              "name": "Khultabad, Civil and Criminal Court"
            },
            "1010223@10@N": {
              "name": "Vaijapur, Civil and Criminal Court"
            },
            "1010224@1@N": {
              "name": "Kannad, Civil and Criminal Court"
            },
            "1010226@14@N": {
              "name": "Vaijapur, Dist and Sessions Court"
            },
            "1010227@2@N": {
              "name": "Gangapur, Civil and Criminal Court"
            },
            "1010228@6@N": {
              "name": "Paithan, Civil and Criminal Court"
            },
            "1010229@9,13@N": {
              "name": "Aurangabad, District and Sesion Old"
            },
            "1370038@15@N": {
              "name": "Gangapur, Dist and Sessions Court"
            },
            "1370042@16@N": {
              "name": "Paithan, Dist and Sessions Court"
            },
            "1370059@17@N": {
              "name": "Juvenile Court Aurangabad"
            }
          }
        },
        "20": {
          "name": "Nashik",
          "courtComplexes": {
            "1010230@8,27@N": {
              "name": "Igatpuri, Civil and Criminal Court"
            },
            "1010231@21@N": {
              "name": "Pimpalgaon Bs, Civ and Cri Ct"
            },
            "1010232@18@N": {
              "name": "Chandwad, Civil and Criminal Court"
            },
            "1010233@19,26@N": {
              "name": "Sinnar, Civil and Criminal Court"
            },
            "1010234@6@N": {
              "name": "Yeola, Civil and Criminal Court"
            },
            "1010235@14@N": {
              "name": "Satana, Civil and Criminal Court"
            },
            "1010237@11,23@N": {
              "name": "Kalwan, Civil and Criminal Court"
            },
            "1010238@12@N": {
              "name": "Manmad, Civil and Criminal Court"
            },
            "1010239@20@N": {
              "name": "Nandgaon, Civil and Criminal Court"
            },
            "1010240@13@N": {
              "name": "Manmad, Judicial Magistrate Railway"
            },
            "1010241@9,10@N": {
              "name": "Malegaon, Dist and Sessions Ct"
            },
            "1010243@7,16@N": {
              "name": "Niphad, Dist Judge and ASJ"
            },
            "1010244@5,17@N": {
              "name": "Dindori, Civil and Criminal Court"
            },
            "1010245@1,2,3,4,24,28@N": {
              "name": "Nashik, District and Sessions Court"
            },
            "1010529@25@N": {
              "name": "Yeola, Additional District Court"
            },
            "1370033@15,22,29,30@N": {
              "name": "Nashik Road, Additional District Court"
            }
          }
        },
        "21": {
          "name": "Thane",
          "courtComplexes": {
            "1010246@12@N": {
              "name": "Kalyan, Railway Court"
            },
            "1010247@1,2,3,4,5@N": {
              "name": "Thane, District and Sessions Court"
            },
            "1010248@17@N": {
              "name": "Shahapur, Civil and Criminal Court"
            },
            "1010250@14,15,28@N": {
              "name": "Palghar, District and Addl Session"
            },
            "1010251@19,23,24@N": {
              "name": "Vasai, District and Addl Sessions"
            },
            "1010252@6,31,32@N": {
              "name": "Bhiwandi, Civil and Criminal Court"
            },
            "1010253@7@N": {
              "name": "Dahanu, Civil and Criminal Court"
            },
            "1010254@18@N": {
              "name": "Ulhasnagar, Civil and Criminal Cour"
            },
            "1010255@9,10,25,26,27@N": {
              "name": "Kalyan, District and Addl Sessions"
            },
            "1010256@22@N": {
              "name": "Wada, Civil and Criminal Court"
            },
            "1010257@8@N": {
              "name": "Jawhar, Civil and Criminal Court"
            },
            "1010258@21@N": {
              "name": "Vasai, Railway Court"
            },
            "1010259@13@N": {
              "name": "Murbad, Civil and Criminal Court"
            },
            "1010531@20,29,30@N": {
              "name": "Belapur, Add. District Court"
            },
            "1370043@33@N": {
              "name": "Mira Bhayandar, Civil and Criminal Court"
            },
            "1370104@34@N": {
              "name": "Civil and Criminal Court Chikhloli Ambarnath"
            }
          }
        },
        "22": {
          "name": "Mumbai (Suburban)",
          "courtComplexes": {

          }
        },
        "23": {
          "name": "Mumbai CMM Courts",
          "courtComplexes": {
            "1010260@8@N": {
              "name": "Dongari, Juvenile, MM Court"
            },
            "1010261@15@N": {
              "name": "Dadar Bhoiwada, MM Court"
            },
            "1010262@5@N": {
              "name": "Borivali, MM Court"
            },
            "1010263@2@N": {
              "name": "Bandra, MM Court"
            },
            "1010264@4@N": {
              "name": "Ballard Estate Mumbai, MM Court"
            },
            "1010265@3@N": {
              "name": "Girgaon, MM Court"
            },
            "1010266@11@N": {
              "name": "Dadar Shindewadi, MM Court"
            },
            "1010267@6@N": {
              "name": "Andheri, MM Court"
            },
            "1010268@10@N": {
              "name": "Sewree, MM Court"
            },
            "1010269@7@N": {
              "name": "CST Mumbai, MM Court"
            },
            "1010270@12@N": {
              "name": "Vikhroli, MM Court"
            },
            "1010271@13@N": {
              "name": "Mumbai Central, MM Court"
            },
            "1010272@16@N": {
              "name": "Vile Parle, MM Court"
            },
            "1010273@1@N": {
              "name": "Esplanade, CMM Court"
            },
            "1010274@14@N": {
              "name": "Mulund, MM Court"
            },
            "1010275@9@N": {
              "name": "Kurla, MM Court"
            }
          }
        },
        "24": {
          "name": "Raigad",
          "courtComplexes": {
            "1010276@6,19,20,21@N": {
              "name": "Mahad, Civil and Criminal Court"
            },
            "1010277@15@N": {
              "name": "Murud, Civil and Criminal Court"
            },
            "1010278@8@N": {
              "name": "Pen, Civil and Criminal Court"
            },
            "1010279@10@N": {
              "name": "Shriwardhan, Civil and Cri Court"
            },
            "1010280@4@N": {
              "name": "Karjat, Civil and Criminal Court"
            },
            "1010281@11@N": {
              "name": "Uran, Civil and Criminal Court"
            },
            "1010282@9@N": {
              "name": "Roha, Civil and Criminal Court"
            },
            "1010283@16@N": {
              "name": "Pali, Civil and Criminal Court"
            },
            "1010284@12,13@N": {
              "name": "Panvel, Civil and Criminal Court"
            },
            "1010285@5@N": {
              "name": "Khalapur, Civil and Criminal Court"
            },
            "1010286@7,14,18@N": {
              "name": "Mangaon, Raigad, District Court"
            },
            "1010287@1,2,3@N": {
              "name": "RaigadAlibag,Dist and Session Court"
            },
            "1010514@17@N": {
              "name": "Panvel, District and Addl. Sessions"
            }
          }
        },
        "25": {
          "name": "Pune",
          "courtComplexes": {
            "1010288@15,24,25@N": {
              "name": "Khed, Civil Court"
            },
            "1010289@12@N": {
              "name": "Khadki, Criminal Court"
            },
            "1010290@20@N": {
              "name": "Shirur, Civil Court"
            },
            "1010291@10@N": {
              "name": "Pune, JMFC, Railway Court"
            },
            "1010292@9@N": {
              "name": "Daund, Railway Criminal Court"
            },
            "1010293@4,26,27@N": {
              "name": "Baramati, Dist and Session Court"
            },
            "1010294@14,33,34@N": {
              "name": "Junner, Additional District Court"
            },
            "1010295@7@N": {
              "name": "Saswad, Civil Court"
            },
            "1010296@13@N": {
              "name": "Ghodegaon, Civil Court"
            },
            "1010297@18@N": {
              "name": "Pune, Civil and Criminal Court"
            },
            "1010298@21@N": {
              "name": "Maval, Civil Court"
            },
            "1010299@8@N": {
              "name": "Bhor, Civil Court"
            },
            "1010300@5,31,32@N": {
              "name": "Indapur, Civil Court"
            },
            "1010301@6,30@N": {
              "name": "Daund, Civil Court"
            },
            "1010302@17@N": {
              "name": "Akurdi, Criminal Court"
            },
            "1010303@1,2,3,22,23@N": {
              "name": "Pune, District and Sessions Court"
            },
            "1010304@16,19@N": {
              "name": "Pimpri, Civil Court"
            },
            "1010305@11@N": {
              "name": "Pune, JMFC, Cantonment Court"
            },
            "1010521@28@N": {
              "name": "Vadgaon Civil Court Senior Division"
            },
            "1010522@29@N": {
              "name": "Vadgaon Maval Add. District Court"
            },
            "1370102@35@N": {
              "name": "Civil and Criminal Court, Paud"
            }
          }
        },
        "26": {
          "name": "Ahmednagar",
          "courtComplexes": {
            "1010306@14@N": {
              "name": "Rahuri, Civil and Criminal Court"
            },
            "1010307@2,3@N": {
              "name": "Ahmednagar, Civil Court"
            },
            "1010308@21,22,26@N": {
              "name": "Shrigonda, Civil Court"
            },
            "1010309@6@N": {
              "name": "Karjat Civil and Criminal Court"
            },
            "1010310@12@N": {
              "name": "Pathardi, Civil and Criminal Court"
            },
            "1010311@15,23@N": {
              "name": "Sangamner, Civil and Criminal Court"
            },
            "1010312@11@N": {
              "name": "Parner, Civil and Criminal Court"
            },
            "1010313@5@N": {
              "name": "Jamkhed, Civil and Criminal Court"
            },
            "1010314@16@N": {
              "name": "Sangamner, Dist and Sessions Court"
            },
            "1010315@10@N": {
              "name": "Newasa, Civil and Criminal Court"
            },
            "1010316@17@N": {
              "name": "Shevgaon, Civil and Criminal Court"
            },
            "1010317@4@N": {
              "name": "Akole, Civil and Criminal Court"
            },
            "1010318@24,25@N": {
              "name": "Newasa, Civil Court"
            },
            "1010319@7,8,9@N": {
              "name": "Kopergaon, Dist and Sessions Court"
            },
            "1010320@1@N": {
              "name": "Ahmednagar, Dist and Sessions Court"
            },
            "1010321@13,27@N": {
              "name": "Rahata, Civil and Criminal Court"
            },
            "1010322@18,19,20@N": {
              "name": "Shrirampur, Dist and Sessions Court"
            }
          }
        },
        "27": {
          "name": "Beed",
          "courtComplexes": {
            "1010323@7,8@N": {
              "name": "Ambajogai, Civil and Criminal Court"
            },
            "1010324@11,12,13@N": {
              "name": "Majalgaon, Dist and Session Court"
            },
            "1010325@9@N": {
              "name": "Ambajogai, Dist and Session Court"
            },
            "1010326@1,2,3@N": {
              "name": "Beed, Dist and Session Court"
            },
            "1010327@5@N": {
              "name": "Dharur, Civil and Criminal Court"
            },
            "1010328@14@N": {
              "name": "Parli Vaijnath, Civil and Criminal"
            },
            "1010329@17@N": {
              "name": "Wadwani, Civil and Criminal Court"
            },
            "1010330@4@N": {
              "name": "Georai, Civil and Criminal Court"
            },
            "1010331@16@N": {
              "name": "Shirur K, Civil and Criminal Court"
            },
            "1010332@15@N": {
              "name": "Patoda, Civil and Criminal Court"
            },
            "1010333@10@N": {
              "name": "Ashti, Civil and Criminal Court"
            },
            "1010334@6,18@N": {
              "name": "Kaij, Civil and Criminal Court"
            }
          }
        },
        "28": {
          "name": "Latur",
          "courtComplexes": {
            "1010335@5,6,13@N": {
              "name": "Ahmedpur, Civil Court"
            },
            "1010336@10,11,14@N": {
              "name": "Udgir, Dist and Sessions Court"
            },
            "1010337@15@N": {
              "name": "Renapur, Civil and Criminal Court"
            },
            "1010338@16@N": {
              "name": "Deoni, Civil and Criminal Court"
            },
            "1010339@8,9,12@N": {
              "name": "Nilanga, Dist and Sessions Court"
            },
            "1010340@1,2,3@N": {
              "name": "Latur, District and Sessions Court"
            },
            "1010341@4,17@N": {
              "name": "Ausa, Civil and Criminal Court"
            },
            "1010342@7@N": {
              "name": "Chakur, Civil and Criminal Court"
            }
          }
        },
        "29": {
          "name": "Osmanabad",
          "courtComplexes": {
            "1010343@10@N": {
              "name": "Tuljapur,  Civil and Criminal Court"
            },
            "1010344@11@N": {
              "name": "Washi,  Civil and Criminal Court"
            },
            "1010345@6,7,8@N": {
              "name": "Omerga, District and Sessions Court"
            },
            "1010346@13@N": {
              "name": "Lohara, Civil and Criminal Court"
            },
            "1010347@5@N": {
              "name": "Kallam, Civil and Criminal Court"
            },
            "1010348@4,14,15@N": {
              "name": "Bhoom, District and Sessions Court"
            },
            "1010349@1,2,3@N": {
              "name": "Osmanabad, Dist and Sessions Court"
            },
            "1010350@9,12,18@N": {
              "name": "Paranda, Civil and Criminal Court"
            },
            "1010526@16@N": {
              "name": "Kallam, ADJ Court"
            },
            "1010527@17@N": {
              "name": "Kallam, Civil Judge Sr. Div."
            },
            "1370032@19@N": {
              "name": "Civil Judge Senior Division, Tuljapur"
            }
          }
        },
        "30": {
          "name": "Solapur",
          "courtComplexes": {
            "1010351@10,11,12@N": {
              "name": "Malshiras, District and Session Ct"
            },
            "1010352@5@N": {
              "name": "Barshi, Civil and Criminal Court"
            },
            "1010353@16,17,18@N": {
              "name": "Pandharpur, Dist and Session Court"
            },
            "1010354@6,7,21@N": {
              "name": "Barshi, District and Sessions Court"
            },
            "1010355@1,2,3@N": {
              "name": "Solapur, Dist and Sessions Court"
            },
            "1010356@19@N": {
              "name": "Sangola, Civil Court"
            },
            "1010357@13@N": {
              "name": "Mangalweda, Civil Court"
            },
            "1010358@8,22@N": {
              "name": "Karmala, Civil Court"
            },
            "1010359@20@N": {
              "name": "Solapur, Civil and Municipal Court"
            },
            "1010360@14@N": {
              "name": "Mohol, Civil Court"
            },
            "1010361@9,23@N": {
              "name": "Madha, Civil Court"
            },
            "1010362@4@N": {
              "name": "Akkalkot, Civil Court"
            },
            "1010363@15@N": {
              "name": "Pandharpur, Civil Court"
            }
          }
        },
        "31": {
          "name": "Satara",
          "courtComplexes": {
            "1010364@8@N": {
              "name": "Khandala, Civil and Criminal Court"
            },
            "1010365@1,2,3@N": {
              "name": "Satara, District Court, New Bldg"
            },
            "1010367@11@N": {
              "name": "Medha, Civil and Criminal Court"
            },
            "1010368@14@N": {
              "name": "Phaltan, Civil and Criminal Court"
            },
            "1010369@6,7@N": {
              "name": "Karad, District Court I"
            },
            "1010370@5@N": {
              "name": "Karad, Civil and Criminal Court"
            },
            "1010371@12@N": {
              "name": "Mhaswad Man, Civil and Criminal Ct"
            },
            "1010372@16@N": {
              "name": "Wai, Civil and Criminal Court"
            },
            "1010373@10@N": {
              "name": "Mahabaleshwar, Civil and Cri Court"
            },
            "1010374@9@N": {
              "name": "Koregaon, Civil and Criminal Court"
            },
            "1010375@13@N": {
              "name": "Patan, Civil and Criminal Court"
            },
            "1010376@15@N": {
              "name": "Vaduj Khatav, Civil and Cri Court"
            },
            "1010377@4@N": {
              "name": "Dahiwadi, Man, Civil Court"
            },
            "1010378@17,18@N": {
              "name": "Vaduj Khatav,Dist and Session Court"
            },
            "1010524@19@N": {
              "name": "Wai, Additional District Court"
            },
            "1010525@20@N": {
              "name": "Wai, Civi Court Senior Division"
            },
            "1010542@21@N": {
              "name": "Phaltan, Dist. and Addl. Sessions C"
            }
          }
        },
        "32": {
          "name": "Ratnagiri",
          "courtComplexes": {
            "1010379@9@N": {
              "name": "Lanja, Civil and Criminal Court"
            },
            "1010380@6@N": {
              "name": "Deorukh, Civil and Criminal Court"
            },
            "1010381@7,8,12@N": {
              "name": "Khed, District and Sessions Court"
            },
            "1010382@1,2,3@N": {
              "name": "Ratnagiri, Dist and Sessions Court"
            },
            "1010383@4@N": {
              "name": "Chiplun, Civil and Criminal Court"
            },
            "1010384@5@N": {
              "name": "Dapoli, Civil and Criminal Court"
            },
            "1010385@11@N": {
              "name": "Guhagar, Civil and Criminal Court"
            },
            "1010386@10@N": {
              "name": "Rajapur, Civil and Criminal Court"
            },
            "1010510@13@N": {
              "name": "Chiplun District Judge 1 and Addl."
            },
            "1370044@14@N": {
              "name": "Mandangad, Civil Judge Junior Division"
            }
          }
        },
        "33": {
          "name": "Sindhudurg",
          "courtComplexes": {
            "1010387@5@N": {
              "name": "Kankavli, Civil Court"
            },
            "1010388@6@N": {
              "name": "Kudal, Civil Court"
            },
            "1010389@1,2,3@N": {
              "name": "Sindhudurg Oros, District Court"
            },
            "1010390@10@N": {
              "name": "Dodamarg, Civil Court"
            },
            "1010391@7@N": {
              "name": "Malvan, Civil Court"
            },
            "1010392@4@N": {
              "name": "Deogad, Civil Court"
            },
            "1010393@8@N": {
              "name": "Sawantwadi, Civil Court"
            },
            "1010394@9@N": {
              "name": "Vengurla, Civil Court"
            }
          }
        },
        "34": {
          "name": "Kolhapur",
          "courtComplexes": {
            "1010395@19@N": {
              "name": "Peth Vadgaon, Civil and Cri Court"
            },
            "1010396@6,8@N": {
              "name": "Gadhinglaj,Civil and Criminal Court"
            },
            "1010397@13@N": {
              "name": "Jaysingpur, Civil and Criminal Ct"
            },
            "1010398@1,2,21@N": {
              "name": "Kolhapur District and Session Court"
            },
            "1010399@9@N": {
              "name": "Gargoti, Civil and Criminal Court"
            },
            "1010400@4@N": {
              "name": "Ajara, Civil and Criminal Court"
            },
            "1010401@3@N": {
              "name": "Kolhapur, Criminal Court"
            },
            "1010402@17@N": {
              "name": "Panhala, Civil and Criminal Court"
            },
            "1010403@7@N": {
              "name": "Gadhinglaj, Dist and Sessions Court"
            },
            "1010404@12@N": {
              "name": "Jaisingpur, Dist and Sessions Ct"
            },
            "1010405@5@N": {
              "name": "Chandgad, Civil and Criminal Court"
            },
            "1010406@10,11@N": {
              "name": "Ichalkaranji, Dist and Session Ct"
            },
            "1010407@15@N": {
              "name": "Kurundwad, Civil and Criminal Court"
            },
            "1010408@20@N": {
              "name": "Civil and Cri Court Kale Kheriwade"
            },
            "1010409@14@N": {
              "name": "Kagal, Civil and Criminal Court"
            },
            "1010410@18@N": {
              "name": "Radhanagari, Civil and Criminal Ct"
            },
            "1010411@16@N": {
              "name": "Shahuwadi, Civil and Criminal Court"
            }
          }
        },
        "35": {
          "name": "Sangli",
          "courtComplexes": {
            "1010412@1@N": {
              "name": "Palus, Civil and Criminal Court"
            },
            "1010413@6@N": {
              "name": "KawatheMahakal, Civil and Criminal"
            },
            "1010414@9,10@N": {
              "name": "Islampur, District Judge and ASJ"
            },
            "1010415@14@N": {
              "name": "Kadegaon, Civil and Criminal Court"
            },
            "1010416@8@N": {
              "name": "Atpati, Civil and Criminal Court"
            },
            "1010417@4@N": {
              "name": "Shirala, Civil and Criminal Court"
            },
            "1010418@12,13@N": {
              "name": "Sangli, District and Sessions Court"
            },
            "1010419@5@N": {
              "name": "Miraj, Civil  and Criminal Court"
            },
            "1010421@11@N": {
              "name": "Sangli, Civil and Criminal Court"
            },
            "1010422@3@N": {
              "name": "Tasgaon, Civil and Criminal Court"
            },
            "1010423@2,15@N": {
              "name": "Vita, Civil  and Criminal Court"
            },
            "1010424@7,16@N": {
              "name": "Jath, Civil and Criminal Court"
            },
            "1010544@17@N": {
              "name": "Vita, Addl. Dist and Sessions Court"
            }
          }
        },
        "36": {
          "name": "Washim",
          "courtComplexes": {
            "1010425@7@N": {
              "name": "Risod, Civil and Criminal Court"
            },
            "1010426@4@N": {
              "name": "Manora, Civil and Criminal Court"
            },
            "1010427@6,8,9@N": {
              "name": "Mangrulpir,Civil and Criminal Court"
            },
            "1010428@10@N": {
              "name": "Malegaon, Civil and Criminal Court"
            },
            "1010429@5,11@N": {
              "name": "Karanaja, Civil and Criminal Court"
            },
            "1010430@1,2,3@N": {
              "name": "Washim, District and ASJ Court"
            }
          }
        },
        "37": {
          "name": "Mumbai City Civil Court",
          "courtComplexes": {
            "1010431@5@N": {
              "name": "Sewree, City Civil Court"
            },
            "1010432@2@N": {
              "name": "Mumbai City Sessions Court"
            },
            "1010433@3,4@N": {
              "name": "Dindoshi, City Civil Court"
            },
            "1010435@1@N": {
              "name": "Mumbai, City Civil Court"
            }
          }
        },
        "38": {
          "name": "Mumbai Small Causes Court",
          "courtComplexes": {
            "1010436@1,2@Y": {
              "name": "Mumbai, Small Causes Court"
            },
            "1010437@3@N": {
              "name": "Bandra, Small Causes Court"
            }
          }
        },
        "39": {
          "name": "Mumbai Motor Accident Claims T",
          "courtComplexes": {
            "1010438@1,2@N": {
              "name": "Mumbai, MotorAccidentClaimsTribunal"
            }
          }
        },
        "40": {
          "name": "Maharashtra Industrial and Lab",
          "courtComplexes": {
            "1010439@38,39@N": {
              "name": "Jalna, Industrial and Labour Court"
            },
            "1010440@13,14@N": {
              "name": "Chandrapur, Industrial and Labour"
            },
            "1010441@7,8@N": {
              "name": "Aurangabad, Industrial and Labour"
            },
            "1010442@33@N": {
              "name": "Mahad, Labour Court"
            },
            "1010443@22,23@N": {
              "name": "Akola, Industrial and Labour Court"
            },
            "1010444@28,29@N": {
              "name": "Satara, Industrial and labour Court"
            },
            "1010445@24,25@N": {
              "name": "Bhandara, Industrial and Labour"
            },
            "1010446@34,35@Y": {
              "name": "Thane, Industrial and Labour Court"
            },
            "1010447@36,37@N": {
              "name": "Pune, Industrial and Labour"
            },
            "1010448@15@N": {
              "name": "Buldhana, Labour Court"
            },
            "1010449@1,2@N": {
              "name": "Sangli, Industrial and Labour Court"
            },
            "1010450@30,31@N": {
              "name": "Solapur, Industrial and Labour Ct"
            },
            "1010451@42@N": {
              "name": "Ratnagiri, Labour Court"
            },
            "1010452@18,19@N": {
              "name": "Kolhapur Industrial andLabour Court"
            },
            "1010453@4,5@N": {
              "name": "Bandra, Industrial and Labour Court"
            },
            "1010454@16,17@N": {
              "name": "Amravati, Industrial and Labour"
            },
            "1010455@6,12@N": {
              "name": "Nashik, Indl and Labour Court"
            },
            "1010456@9,10@N": {
              "name": "Nagpur, Industrial and Labour Court"
            },
            "1010458@20,21@N": {
              "name": "Ahmednagar, IC and LC"
            },
            "1010459@44,45@N": {
              "name": "Dhule, Industrial and Labour Court"
            },
            "1010460@40,41@N": {
              "name": "Jalgaon,Industrial and Labour Court"
            },
            "1010461@46@N": {
              "name": "Wardha, Labour Court"
            },
            "1010462@26,27@N": {
              "name": "Yavatmal, Industrial and Labour"
            },
            "1010463@43@N": {
              "name": "Nanded, Labour Court"
            },
            "1010464@3,11@N": {
              "name": "Latur, Industrial and Labour Court"
            },
            "1010465@32@N": {
              "name": "Gondia, Labour Court"
            }
          }
        },
        "41": {
          "name": "Mah State Cooperative Appellat",
          "courtComplexes": {
            "1010466@15@N": {
              "name": "Thane, Coop Court"
            },
            "1010467@17@N": {
              "name": "Satara, Cooperative Court"
            },
            "1010469@18@N": {
              "name": "Kopargaon, Cooperative Court"
            },
            "1010470@16@N": {
              "name": "Shrirampur, Cooperative Court"
            },
            "1010471@4@N": {
              "name": "Solapur, Cooperative Court"
            },
            "1010473@1,2@N": {
              "name": "Aurangabad, Cooperative Appellate"
            },
            "1010474@3@N": {
              "name": "Nashik, Judge Cooperative Court"
            },
            "1010475@6@N": {
              "name": "Amravati, Cooperative Court"
            },
            "1010476@9,21@Y": {
              "name": "Nagpur, Mah State Coop App Court"
            },
            "1010477@19@N": {
              "name": "Sangli, Cooperative Court"
            },
            "1010478@14@N": {
              "name": "Ahmednagar, Cooperative Court"
            },
            "1010479@22,23@N": {
              "name": "Mumbai, MH State Coop Court"
            },
            "1010480@12@N": {
              "name": "Jalgaon, Cooperative Court"
            },
            "1010481@13@N": {
              "name": "Latur, Cooperative Court"
            },
            "1010482@7@N": {
              "name": "Alibag, Judge, Cooperative Court"
            },
            "1010483@11,10@N": {
              "name": "Swarget,Pune, Co Op Appellate Court"
            },
            "1010484@20@N": {
              "name": "Akola, Cooperative Court"
            },
            "1010485@5@N": {
              "name": "Nanded, Cooperative Court"
            },
            "1010486@8@N": {
              "name": "Ratnagiri, Cooperative Link Court"
            },
            "1010515@24@N": {
              "name": "Kolhapur, Cooperative Court"
            }
          }
        },
        "42": {
          "name": "Maharashtra Family Courts",
          "courtComplexes": {
            "1010487@11@N": {
              "name": "Bandra, Family Court"
            },
            "1010488@23@N": {
              "name": "Family Court , Osmanabad"
            },
            "1010489@17@N": {
              "name": "Nashik, Family Court"
            },
            "1010490@14@N": {
              "name": "Aurangabad, Family Court"
            },
            "1010491@12@N": {
              "name": "Akola, Family Court"
            },
            "1010492@15@N": {
              "name": "Nagpur, Family Court"
            },
            "1010493@22@N": {
              "name": "Ahmednagar Family Court"
            },
            "1010494@19@N": {
              "name": "Solapur, Family Court"
            },
            "1010495@16@N": {
              "name": "Nanded, Family Court"
            },
            "1010496@21@N": {
              "name": "Family Court, Latur"
            },
            "1010497@20@N": {
              "name": "Thane, Family Court"
            },
            "1010498@13@N": {
              "name": "Amravati, Family Court"
            },
            "1010499@6@N": {
              "name": "Kolhapur, Family Court"
            },
            "1010500@18@N": {
              "name": "Pune, Family Court"
            },
            "1010513@24@N": {
              "name": "Alibag, Family Court"
            },
            "1010516@25@N": {
              "name": "Family Court, Buldana"
            },
            "1010523@26@N": {
              "name": "Parbhani, Family Court"
            },
            "1010543@27@N": {
              "name": "Belapur, Family Court."
            },
            "1370051@28@N": {
              "name": "Beed, Family Court"
            },
            "1370052@29@N": {
              "name": "Satara, Family Court"
            },
            "1370053@30@N": {
              "name": "Family Court, Sangli."
            },
            "1370070@31@N": {
              "name": "Jalna Family Court"
            }
          }
        },
        "43": {
          "name": "Maharashtra School Tribunals",
          "courtComplexes": {
            "1010501@7@N": {
              "name": "Amravati, School Tribunal"
            },
            "1010502@2@N": {
              "name": "Aurangabad, School Tribunal"
            },
            "1010503@3@N": {
              "name": "Nashik, School Tribunal"
            },
            "1010504@1@N": {
              "name": "Solapur, School Tribunal"
            },
            "1010506@6@N": {
              "name": "Latur, School Tribunal"
            },
            "1010507@4@N": {
              "name": "Navi Mumbai, School Tribunal"
            },
            "1010517@8@N": {
              "name": "Chandrapur, School Tribunal"
            },
            "1010518@9@N": {
              "name": "Nagpur, School Tribunal"
            },
            "1010519@10@N": {
              "name": "Pune, School Tribunal"
            },
            "1010520@11@N": {
              "name": "Kolhapur, School Tribunal"
            }
          }
        }
      }
    },
    "2": {
      "name": "Andhra Pradesh",
      "districts": {
        "2": {
          "name": "Ananthapur",
          "courtComplexes": {
            "1020002@11,12@N": {
              "name": "Court of Senior Civil Judge,, Penukonda (Taluka)"
            },
            "1020003@16,17,19@N": {
              "name": "II Addl. District Court, Hindupur (Taluka)"
            },
            "1020004@20@N": {
              "name": "Court of Junior Civil Judge,, Guntakal (Taluka)"
            },
            "1020005@6@N": {
              "name": "Court of Junior Civil Judge,, Uravakonda (Taluka)"
            },
            "1020006@27@N": {
              "name": "Junior Civil Court, Puttaparthy"
            },
            "1020007@14,15@N": {
              "name": "Court of Senior Civil Judge,, Dharmavaram (Taluka)"
            },
            "1020008@21,22@N": {
              "name": "Court of Senior Civil Judge,, Kadiri (Taluka)"
            },
            "1020009@8@N": {
              "name": "Court of Spl. Judl. Magistrate of I Class for Railways, Guntakal (Taluka)"
            },
            "1020010@13@N": {
              "name": "Court of Junior Civil Judge,, Kalyandurg (Taluka)"
            },
            "1020011@10@N": {
              "name": "Court of Junior Civil Judge,, Madakasira (Taluka)"
            },
            "1020012@24,25,26@N": {
              "name": "VI Addl. District Judge (FTC) Anantapur at Gooty, Gooty (Taluka)"
            },
            "1020013@3,2,1,4,5@N": {
              "name": "Prl. District & Sessions Court, ANANTHAPURAMU (District)"
            },
            "1020014@9@N": {
              "name": "Court of Junior Civil Judge,, Rayadurg (Taluka)"
            },
            "1020015@7@N": {
              "name": "Court of Junior Civil Judge,, Tadipatri (Taluka)"
            }
          }
        },
        "3": {
          "name": "Chittoor",
          "courtComplexes": {
            "1020016@14@N": {
              "name": "Court of Senior Civil Judge,, Punganur (Taluka)"
            },
            "1020017@10,11@N": {
              "name": "Court of Senior Civil Judge,, Puttur (Taluka)"
            },
            "1020018@7,6,5@N": {
              "name": "III Addl. District Court,, Tirupathi (Taluka)"
            },
            "1020019@18,19,20@N": {
              "name": "II Addl District Court Madanapalle"
            },
            "1020021@17@N": {
              "name": "Court of Junior Civil Judge,, Pakala (Taluka)"
            },
            "1020022@15@N": {
              "name": "Court of Junior Civil Judge,, Kuppam (Taluka)"
            },
            "1020023@24,25@N": {
              "name": "Court of Senior Civil Judge Piler"
            },
            "1020024@26,27,29@N": {
              "name": "Court of Senior Civil Judge,, Srikalahasti (Taluka)"
            },
            "1020025@1,3,4,30@N": {
              "name": "Prl District Courts, Chittoor"
            },
            "1020027@16@N": {
              "name": "Court of Junior Civil Judge,, Vayalpadu (Taluka)"
            },
            "1020028@8@N": {
              "name": "Court of Junior Civil Judge,, Nagari (Taluka)"
            },
            "1020030@21@N": {
              "name": "Court of Junior Civil Judge,, Satyavedu (Taluka)"
            },
            "1020031@9@N": {
              "name": "Court of Junior Civil Judge,, Palamaner (Taluka)"
            },
            "1020032@23@N": {
              "name": "XI Additional District Court, Piler"
            },
            "1020033@12@N": {
              "name": "Court of Junior Civil Judge,, Thamballapalle (Taluka)"
            },
            "1020034@22@N": {
              "name": "Senior Civil Court, Palamaner"
            },
            "1020035@28@N": {
              "name": "VI Junior Civil Court, Tirupathi"
            },
            "1020036@13@N": {
              "name": "Court of Prl. Junior Civil Judge,, Punganur (Taluka)"
            }
          }
        },
        "4": {
          "name": "East Godavari",
          "courtComplexes": {
            "1020038@1,2@N": {
              "name": "PDJ Court Complex ,Rajahmundry"
            },
            "1020039@32@N": {
              "name": "JFCM Addateegala"
            },
            "1020040@3,4,5,38@N": {
              "name": "III Addl District Court Kakinada"
            },
            "1020041@6,7,8@N": {
              "name": "II Addl District Court Amalapuram"
            },
            "1020042@16,17@N": {
              "name": "Court of Senior Civil Judge,, Razole (Taluka)"
            },
            "1020043@20,21,22@N": {
              "name": "Senior Civil Courts,  Pithapuram"
            },
            "1020044@31,36@N": {
              "name": "III AJFCM Rajamahendravaram"
            },
            "1020047@23,25,37@N": {
              "name": "Court of Senior Civil Judge, Ramachandrapuram"
            },
            "1020048@18,19,34@N": {
              "name": "Court of Senior Civil Judge,, Peddapuram (Taluka)"
            },
            "1020049@9,10@N": {
              "name": "Court of Prl. Junior Civil Judge,, Kothapet (Taluka)"
            },
            "1020050@15@N": {
              "name": "Court of Junior Civil Judge,, Tuni (Taluka)"
            },
            "1020051@13@N": {
              "name": "Court of Junior Civil Judge,, Mummidivaram (Taluka)"
            },
            "1020052@12@N": {
              "name": "Court of Junior Civil Judge, Anaparthy (Taluka)"
            },
            "1020053@11@N": {
              "name": "Court of Junior Civil Judge,, Alamuru (Taluka)"
            },
            "1020054@14@N": {
              "name": "Court of Judicial Magistrate of First Class, Rampachodavaram (Taluka)"
            },
            "1020055@33@N": {
              "name": "Spl JFCM Kakinada"
            },
            "1020056@27@N": {
              "name": "Court of Addl. Junior Civil Judge (new), Tuni (Taluka)"
            },
            "1020057@29@N": {
              "name": "Munsif Magistrate Courts,Rajamundry"
            },
            "1020058@26,28@N": {
              "name": "Junior Civil Courts, Prathipadu"
            },
            "1020203@35@N": {
              "name": "ACB Court at Rajamahedravaram"
            }
          }
        },
        "5": {
          "name": "Guntur",
          "courtComplexes": {
            "1020059@10@N": {
              "name": "Court of Junior Civil Judge, Piduguralla (Taluka)"
            },
            "1020060@37,38@N": {
              "name": "II Addl JCJ Court, Sattenapalli"
            },
            "1020061@7,8,9,23@N": {
              "name": "X Addl District Court Narasaraopet"
            },
            "1020062@24,33,34@N": {
              "name": "Court of Senior Civil Judge, Mangalagiri (Taluka)"
            },
            "1020063@31@N": {
              "name": "Court of Addl. Junior Civil Judge, (Formerly II AJCJ, Bapatla), Chilakaluripet (Taluka)"
            },
            "1020064@1,2,3,4,5,45@N": {
              "name": "PDJ Court Complex, Guntur"
            },
            "1020065@28,29,43,44@N": {
              "name": "Court of Senior Civil Judge,, Bapatla (Taluka)"
            },
            "1020066@26,32,35,36@N": {
              "name": "Court of Senior Civil Judge,, Gurazala (Taluka)"
            },
            "1020067@27@N": {
              "name": "Junior Civil Courts, Macherla"
            },
            "1020068@15,42@N": {
              "name": "Court of Prl. Junior Civil Judge,, Sattenapalli (Taluka)"
            },
            "1020069@17,18,19@N": {
              "name": "XI Addl. District Court (FTC), Tenali (Taluka)"
            },
            "1020070@39@N": {
              "name": "Spl JFCM for Railways Guntur"
            },
            "1020071@21@N": {
              "name": "Court of II Addl. Junior Civil Judge, Tenali (Taluka)"
            },
            "1020072@12,13,14@N": {
              "name": "Court of Senior Civil Judge, Repalle (Taluka)"
            },
            "1020073@41@N": {
              "name": "Court of Addl. Junior Civil Judge,, Ponnur (Taluka)"
            },
            "1020074@11@N": {
              "name": "Court of Prl. Junior Civil Judge,, Ponnur (Taluka)"
            },
            "1020075@25@N": {
              "name": "Court of Prl. Junior Civil Judge,, Chilakaluripet (Taluka)"
            },
            "1020076@22@N": {
              "name": "Court of Junior Civil Judge, Vinukonda (Taluka)"
            }
          }
        },
        "7": {
          "name": "Kadapa",
          "courtComplexes": {
            "1020077@19@N": {
              "name": "Court of Junior Civil Judge, Lakkireddipalli (Taluka)"
            },
            "1020078@13@N": {
              "name": "Court of Junior Civil Judge, Sidhout (Taluka)"
            },
            "1020079@12@N": {
              "name": "Court of Junior Civil Judge, Nandalur (Taluka)"
            },
            "1020080@1,3,4,30,32@N": {
              "name": "District Court Complex Kadapa"
            },
            "1020081@21,22@N": {
              "name": "Addl SCJ Court Complex Badvel"
            },
            "1020082@27,28,29@N": {
              "name": "III Add Dist Court Complex Rajampet"
            },
            "1020083@11@N": {
              "name": "Court of Junior Civil Judge, Kamalapuram (Taluka)"
            },
            "1020084@20@N": {
              "name": "Court of Junior Civil Judge, Jammalamadugu (Taluka)"
            },
            "1020085@31@N": {
              "name": "Junior Civil Judge Court, Mydukur"
            },
            "1020086@15,16,17,26@N": {
              "name": "II Additional District Judge Court, Proddatur (Taluka)"
            },
            "1020087@10@N": {
              "name": "Court of Junior Civil Judge, Railway Kodur (Taluka)"
            },
            "1020088@7,8,14@N": {
              "name": "V Addl Dist Court Complex Rayachoty"
            },
            "1020089@18@N": {
              "name": "Junior Civil Judge Pulivendula"
            }
          }
        },
        "10": {
          "name": "Kurnool",
          "courtComplexes": {
            "1020090@20,21,30@N": {
              "name": "V Add District Complex, Allagadda"
            },
            "1020091@11@N": {
              "name": "Prl JCJ  Court Dhone"
            },
            "1020092@28@N": {
              "name": "II Additional JCJ Court, Adoni"
            },
            "1020093@1,2,3@N": {
              "name": "PDJ Court Complex, Kurnool"
            },
            "1020094@13,14@N": {
              "name": "Senior Civil Judge`s Court, Atmakur (Taluka)"
            },
            "1020095@25,26@N": {
              "name": "Senior Civil Judge`s Court, Nandikotkur (Taluka)"
            },
            "1020098@5,29,31@N": {
              "name": "PJCJ court complex Kurnool"
            },
            "1020099@9@N": {
              "name": "Junior Civil Judge`s Court, Pattikonda (Taluka)"
            },
            "1020100@6,7,8@N": {
              "name": "II Addl District Court Adoni"
            },
            "1020101@12@N": {
              "name": "Junior Civil Judge`s Court, Yemmiganur (Taluka)"
            },
            "1020102@27@N": {
              "name": "Junior Civil Judge`s Court, Banaganapalli (Taluka)"
            },
            "1020103@19@N": {
              "name": "Junior Civil Judge`s Court, Koilkuntla (Taluka)"
            },
            "1020104@10@N": {
              "name": "Junior Civil Judge`s Court, Alur (Taluka)"
            },
            "1020105@15,16,18@N": {
              "name": "III Addl District Complex, Nandyal"
            }
          }
        },
        "11": {
          "name": "Krishna",
          "courtComplexes": {
            "1020106@27@N": {
              "name": "Junior Civil Courts, Vuyyuru"
            },
            "1020107@22@N": {
              "name": "Prl  JCJ Court Gannavaram"
            },
            "1020108@1,3,4,5,35,36,38,39,41@N": {
              "name": "II Addl DJ Court Vijayawada"
            },
            "1020109@31@N": {
              "name": "Addl Junior Civil Court Gannavaram"
            },
            "1020110@32@N": {
              "name": "JCJ Court Complex,Movva"
            },
            "1020111@14@N": {
              "name": "II Metropolitan Magistrate, Vijayawada (Taluka)"
            },
            "1020112@30@N": {
              "name": "Junior Civil Courts Mylavaram"
            },
            "1020113@15@N": {
              "name": "III Metropolitan Magistrate, Vijayawada (Taluka)"
            },
            "1020114@13@N": {
              "name": "I Metropolitan Magistrate, Vijayawada (Taluka)"
            },
            "1020115@29@N": {
              "name": "Junior Civil Courts  Kaikaluru"
            },
            "1020116@18,23,24@N": {
              "name": "XV-ADJ Court Complex Nuzvid"
            },
            "1020117@11,12@N": {
              "name": "Senior Civil Judge Court, Nandigama (Taluka)"
            },
            "1020118@6,7,8,37@N": {
              "name": "Prl District Courts, Machilipatnam"
            },
            "1020119@25,26,40@N": {
              "name": "Senior Civil Judge Court, Avanigadda"
            },
            "1020120@16@N": {
              "name": "Prl. Junior Civil Judge Court, Tiruvur"
            },
            "1020121@17@N": {
              "name": "Junior Civil Judge Court, Bantumilli (Taluka)"
            },
            "1020122@10@N": {
              "name": "Prl. Junior Civil Judge Court, Jaggaiahpet"
            },
            "1020123@19,20,21@N": {
              "name": "XI-ADJ Court Complex Gudivada"
            },
            "1020124@28@N": {
              "name": "XVI Addl District Courts, Nandigama"
            },
            "1020200@33@N": {
              "name": "Senior Civil Judges Court Kaikaluru"
            },
            "1020202@34@N": {
              "name": "Senior Civil Judge Court Gannavaram"
            }
          }
        },
        "15": {
          "name": "Nellore",
          "courtComplexes": {
            "1020125@19@N": {
              "name": "Junior Civil Judge`s Court, Venkatagiri (Taluka)"
            },
            "1020126@15@N": {
              "name": "Prl.Junior Civil Judge`s Court, Kavali (Taluka)"
            },
            "1020127@1,2,3,4,20,21@N": {
              "name": "Principal District and Sessions Court, Nellore"
            },
            "1020128@9,10,13@N": {
              "name": "Addl Dist Court Complex Gudur"
            },
            "1020129@11,12@N": {
              "name": "Senior Civil Judge`s Court, Kovur (Taluka)"
            },
            "1020130@16@N": {
              "name": "Senior Civil Judge`s Court, Kavali (Taluka)"
            },
            "1020131@14@N": {
              "name": "Junior Civil Judge`s Court, Udayagiri (Taluka)"
            },
            "1020132@5@N": {
              "name": "Junior Civil Judges Court Sullurpet"
            },
            "1020133@7@N": {
              "name": "Junior Civil Judge`s Court, Kota (Taluka)"
            },
            "1020134@6@N": {
              "name": "Junior Civil Judge`s Court, Atmakur (Taluka)"
            },
            "1020135@17@N": {
              "name": "JMFC for Railways, Nellore (District)"
            },
            "1020136@18@N": {
              "name": "JCJ Naidupeta"
            }
          }
        },
        "17": {
          "name": "Prakasham",
          "courtComplexes": {
            "1020137@11@N": {
              "name": "Junior Civil Judge's Court, Podili (Taluka)"
            },
            "1020138@5@N": {
              "name": "Junior Civil Judge's Court, Kanigiri (Taluka)"
            },
            "1020139@1,2,3,4,28,29@N": {
              "name": "Prl District Court  Ongole"
            },
            "1020141@12,13@N": {
              "name": "Senior Civil Judge, Darsi (Taluka)"
            },
            "1020142@17,18@N": {
              "name": "Senior Civil Judge, Parchur (Taluka)"
            },
            "1020143@27@N": {
              "name": "JCJ Court Complex, Giddalur"
            },
            "1020144@19,20,21@N": {
              "name": "Senior Civil Judge, Chirala (Taluka)"
            },
            "1020145@25,26@N": {
              "name": "SCJ Court Complex, Kandukur"
            },
            "1020146@6,7@N": {
              "name": "Senior Civil Judge, Addanki (Taluka)"
            },
            "1020147@22,23,24@N": {
              "name": "VI Addl District Court, Markapur"
            }
          }
        },
        "19": {
          "name": "Srikakulam",
          "courtComplexes": {
            "1020148@21@N": {
              "name": "Court of Junior Civil Judge,, Palasa (Taluka)"
            },
            "1020149@10@N": {
              "name": "Court of Senior Civil Judge,, Rajam (Taluka)"
            },
            "1020150@1,3,4,5,28@N": {
              "name": "Prl. District and Sessions Court, Srikakulam"
            },
            "1020151@22,27@N": {
              "name": "Court of Senior Civil Judge,Tekkali"
            },
            "1020153@9,12,13@N": {
              "name": "VI Addl District Court Sompeta"
            },
            "1020154@15@N": {
              "name": "Court of Junior Civil Judge,, Amadalavalasa (Taluka)"
            },
            "1020155@20@N": {
              "name": "Court of Junior Civil Judge,, Ichapuram (Taluka)"
            },
            "1020156@19@N": {
              "name": "Court of Junior Civil Judge,, Kotabommali (Taluka)"
            },
            "1020157@23@N": {
              "name": "Junior Civil Judge Court, Ponduru"
            },
            "1020158@25@N": {
              "name": "Junior Civil Judge Court Palakonda"
            },
            "1020159@26@N": {
              "name": "Junior Civil Judge Court,kothuru"
            },
            "1020160@16@N": {
              "name": "JCJ Court, Narasannapeta"
            },
            "1020161@24@N": {
              "name": "JCJ Court, Pathapatnam"
            }
          }
        },
        "20": {
          "name": "Visakapatnam",
          "courtComplexes": {
            "1020162@18@N": {
              "name": "Court of Judicial Magistrate of First Class, Araku (Taluka)"
            },
            "1020163@6,7,8@N": {
              "name": "X Addl District Court Anakapalle"
            },
            "1020165@27,28@N": {
              "name": "SCJ Narsipatnam"
            },
            "1020166@21@N": {
              "name": "IIMM Railways VSKP"
            },
            "1020167@14@N": {
              "name": "Court of Judicial Magistrate of First Class, Chintapalli (Taluka)"
            },
            "1020168@1,2,3,4,5,16,29@N": {
              "name": "Prl District Court Complex, Visakhapatnam"
            },
            "1020169@22@N": {
              "name": "CBI Court, Visakhapatnam"
            },
            "1020170@15@N": {
              "name": "Court of Judicial Magistrate of First Class, Paderu (Taluka)"
            },
            "1020171@23@N": {
              "name": "Court of Junior Civil Judge,, Madugula (Taluka)"
            },
            "1020172@24,25,26@N": {
              "name": "Senior Civil Judge Chodavaram"
            },
            "1020173@19,20@N": {
              "name": "Court of Senior Civil Judge,, Yellamanchili (Taluka)"
            },
            "1020174@10,11,12,13@N": {
              "name": "Gajuwaka Court Complex Gajuwaka"
            },
            "1020175@9,17@N": {
              "name": "JCJ Bheemunipatnam"
            }
          }
        },
        "21": {
          "name": "Vizianagaram",
          "courtComplexes": {
            "1020176@14@N": {
              "name": "Court of Judicial Magistrate of First Class, Kurupam (Taluka)"
            },
            "1020177@7@N": {
              "name": "Court of Junior Civil Judge,, Cheepurupalli (Taluka)"
            },
            "1020178@12,13@N": {
              "name": "Court of Senior Civil Judge,, Bobbili (Taluka)"
            },
            "1020179@8@N": {
              "name": "Court of Junior Civil Judge,, Srungavarapukota (Taluka)"
            },
            "1020180@6@N": {
              "name": "Court of Junior Civil Judge,, GajapathiNogaram (Taluka)"
            },
            "1020181@5@N": {
              "name": "Court of Junior Civil Judge,, Kothavalasa (Taluka)"
            },
            "1020182@9@N": {
              "name": "Court of Junior Civil Judge,, Salur (Taluka)"
            },
            "1020183@15,16,17@N": {
              "name": "II Additional District Court,PVP"
            },
            "1020184@1,2,3,4,18,19@N": {
              "name": "PDJ Court VIZIANAGARAM"
            }
          }
        },
        "23": {
          "name": "West Godavari",
          "courtComplexes": {
            "1020185@9,10,29@N": {
              "name": "XI ADJ Court Complex Tadepalligudem"
            },
            "1020186@23,24,25@N": {
              "name": "IV ADJ Court Complex, Tanuku"
            },
            "1020187@19@N": {
              "name": "JCJ Court, Chintalapudi"
            },
            "1020188@1,2,3,4,5@N": {
              "name": "PDJ Court Complex  Eluru"
            },
            "1020189@27@N": {
              "name": "Junior Civil Courts, Nidadavole"
            },
            "1020190@28@N": {
              "name": "Junior Civil Courts Jangareddigudem"
            },
            "1020191@26@N": {
              "name": "Junior Civil Court, Bhimadole"
            },
            "1020192@6,7,8@N": {
              "name": "III ADJ Court Complex, Bhimavaram"
            },
            "1020193@12@N": {
              "name": "II AJFCM Court, Bhimavaram"
            },
            "1020194@20,21,22@N": {
              "name": "SCJ Court Complex Kovvur"
            },
            "1020195@11@N": {
              "name": "I AJCJ Court, Bhimavaram"
            },
            "1020196@13,14,15,16@N": {
              "name": "X ADJ Court Complex, Narsapur"
            },
            "1020197@17,18@N": {
              "name": "JCJ Court Complex, Palakol"
            }
          }
        }
      }
    },
    "3": {
      "name": "Karnataka",
      "districts": {
        "1": {
          "name": "BELAGAVI",
          "courtComplexes": {
            "1030001@1,2,28,32,33@Y": {
              "name": "District (Old) Court Complex-Belagavi"
            },
            "1030002@11,12@Y": {
              "name": "Court Complex- Raibag"
            },
            "1030003@7,8,37@Y": {
              "name": "Court Complex- Gokak"
            },
            "1030004@3,4,5,6,27,29,30,31@Y": {
              "name": "New Court Complex-Belagavi"
            },
            "1030005@23,34@Y": {
              "name": "Court Complex- Nipani"
            },
            "1030006@13,14@Y": {
              "name": "Court Complex- Saundatti"
            },
            "1030007@15@Y": {
              "name": "Court Complex- sankeshwar"
            },
            "1030008@24,25,39,40@Y": {
              "name": "Court Complex-Athani"
            },
            "1030009@16,17@Y": {
              "name": "Court Complex- Hukkeri"
            },
            "1030010@22,26@Y": {
              "name": "Court Complex- Khanapur"
            },
            "1030011@9,10,38@Y": {
              "name": "Court Complex- Chikodi"
            },
            "1030012@20,21@Y": {
              "name": "Court Complex- Ramdurga"
            },
            "1030013@18,19@Y": {
              "name": "Court Complex-Bailhongal"
            },
            "1030014@36@Y": {
              "name": "Court Complex Mudalgi"
            },
            "1030015@35@Y": {
              "name": "Court Complex Kittur"
            }
          }
        },
        "2": {
          "name": "BAGALKOT",
          "courtComplexes": {
            "1030016@7,8@N": {
              "name": "Court Complex- Hungund"
            },
            "1030017@13,14,18@Y": {
              "name": "Court Complex Jamkhandi"
            },
            "1030018@9,10,19@Y": {
              "name": "Court Complex Mudhol"
            },
            "1030019@6,16@Y": {
              "name": "Court Complex Banhatti"
            },
            "1030020@1,2,3,15,17@Y": {
              "name": "District Court Complex Bagalkot"
            },
            "1030021@11,12@Y": {
              "name": "Court Complex Badami"
            },
            "1030022@4,5@N": {
              "name": "Court Complex-Bilagi"
            }
          }
        },
        "3": {
          "name": "VIJAYAPURA",
          "courtComplexes": {
            "1030023@8,9@Y": {
              "name": "Court Complex- Indi"
            },
            "1030024@12,13,16@Y": {
              "name": "Court complex muddebihal"
            },
            "1030025@1,2,3,5,10,11@Y": {
              "name": "District Court Complex-Vijayapur"
            },
            "1030026@14,15@Y": {
              "name": "Court Complex Bagewadi"
            },
            "1030027@6,7@Y": {
              "name": "Court Complex- Sindagi"
            }
          }
        },
        "4": {
          "name": "KALABURAGI",
          "courtComplexes": {
            "1030028@12,13@Y": {
              "name": "Court Complex-Aland"
            },
            "1030029@1,2,3,4,15,18@Y": {
              "name": "District Court Complex-Kalaburagi"
            },
            "1030030@10,11@Y": {
              "name": "Court Complex-Chincholi"
            },
            "1030031@8,9@Y": {
              "name": "Court Complex-Sedam"
            },
            "1030032@5,6@Y": {
              "name": "Court Complex-Chittapur"
            },
            "1030033@7,16@Y": {
              "name": "Court Complex-Jevargi"
            },
            "1030034@14,17@Y": {
              "name": "Court Complex- Afzalpur"
            },
            "1030035@19@Y": {
              "name": "Court Complex Shahabad"
            }
          }
        },
        "5": {
          "name": "BIDAR",
          "courtComplexes": {
            "1030036@6,12@Y": {
              "name": "Court Complex-Aurad"
            },
            "1030037@1,2,3,11,13@Y": {
              "name": "District Court Complex-Bidar"
            },
            "1030038@4,5@Y": {
              "name": "Court Complex-Bhalki"
            },
            "1030039@7,8,14@Y": {
              "name": "Court Complex-Basavakalyan"
            },
            "1030040@9,10@Y": {
              "name": "Court Complex-Humnabad"
            }
          }
        },
        "6": {
          "name": "RAICHUR",
          "courtComplexes": {
            "1030041@5,13@Y": {
              "name": "Court Complex-Manvi"
            },
            "1030042@6,12@Y": {
              "name": "Court Complex-Devadurga"
            },
            "1030043@4,9,14@Y": {
              "name": "Court Complex-Sindhanur"
            },
            "1030044@7,8@Y": {
              "name": "Court Complex-Lingasugur"
            },
            "1030045@1,2,3,10,11@Y": {
              "name": "District Court Complex-Raichur"
            }
          }
        },
        "7": {
          "name": "KOPPAL",
          "courtComplexes": {
            "1030046@4,5@Y": {
              "name": "Court Complex-Yelbarga"
            },
            "1030047@1,2,3,9,12@Y": {
              "name": "District Court Complex-Koppal"
            },
            "1030048@6,10@Y": {
              "name": "Court Complex-Kushtagi"
            },
            "1030049@7,8,11@Y": {
              "name": "Court Complex-Gangavathi"
            }
          }
        },
        "8": {
          "name": "GADAG",
          "courtComplexes": {
            "1030050@7@Y": {
              "name": "Court Complex- Nargund"
            },
            "1030051@1,2,3,4,5,11,12@Y": {
              "name": "District Court Complex-Gadag"
            },
            "1030052@14@Y": {
              "name": "Court Complex  mundargi"
            },
            "1030053@8,13@Y": {
              "name": "Court Complex-Lakshmeshwar"
            },
            "1030054@9,10@Y": {
              "name": "Court Complex-Ron"
            }
          }
        },
        "9": {
          "name": "DHARWAD",
          "courtComplexes": {
            "1030055@1,3,16,17,19@Y": {
              "name": "District Court Complex-Dharwad"
            },
            "1030056@7,8,9,10,11,12,13,15,23,24@Y": {
              "name": "Court Complex-Hubli"
            },
            "1030057@2,4@Y": {
              "name": "City Court Complex-Dharawd"
            },
            "1030058@14,21@Y": {
              "name": "Court Complex- Kundgol"
            },
            "1030059@6,22@Y": {
              "name": "Court Complex- Navalgund"
            },
            "1030060@5,20@Y": {
              "name": "Court Complex- Kalaghatgi"
            }
          }
        },
        "10": {
          "name": "UTTARA KANNADA",
          "courtComplexes": {
            "1030061@4,5@Y": {
              "name": "Court Complex- Honnavar"
            },
            "1030062@17@Y": {
              "name": "Court Complex- Dandeli"
            },
            "1030063@8@Y": {
              "name": "Court Complex- Siddapur"
            },
            "1030064@6,22@Y": {
              "name": "Court Complex- Haliyal"
            },
            "1030065@9,10@Y": {
              "name": "Court Complex- Kumta"
            },
            "1030066@13@Y": {
              "name": "Court Complex- Mundgod"
            },
            "1030067@14,15,18@Y": {
              "name": "Court Complex- Sirsi"
            },
            "1030068@11,12@Y": {
              "name": "Court Complex- Yellapur"
            },
            "1030069@16,21@Y": {
              "name": "Court Complex- Bhatkal"
            },
            "1030070@3@Y": {
              "name": "JMFC Court Complex-Karwar"
            },
            "1030071@7,20@Y": {
              "name": "Court Complex- Ankola"
            },
            "1030072@1,2,19@Y": {
              "name": "District Court Complex-Karwar"
            }
          }
        },
        "11": {
          "name": "HAVERI",
          "courtComplexes": {
            "1030074@6,7@Y": {
              "name": "Court Complex- Hanagal"
            },
            "1030075@1,2,3,14,17@Y": {
              "name": "District Court Complex-Haveri"
            },
            "1030076@5@Y": {
              "name": "Court Complex- Savanur"
            },
            "1030077@10,16@Y": {
              "name": "Court Complex- Shiggaon"
            },
            "1030078@11,12,13@Y": {
              "name": "Court Complex- Ranebennur"
            },
            "1030079@8,9@Y": {
              "name": "Court Complex- Hirekerur"
            },
            "1030080@4,15@Y": {
              "name": "Court Complex- Byadgi"
            }
          }
        },
        "12": {
          "name": "BALLARI",
          "courtComplexes": {
            "1030081@10@Y": {
              "name": "Court Complex- Huvina Hadagali"
            },
            "1030082@8,9@Y": {
              "name": "Court Complex- Kudligi"
            },
            "1030083@12,13,14,15,16@Y": {
              "name": "Court Complex- Hospet"
            },
            "1030084@17@Y": {
              "name": "Court Complex- Siruguppa"
            },
            "1030085@23,24@Y": {
              "name": "Court Complex Harapanahalli"
            },
            "1030086@7@Y": {
              "name": "Court Complex- Sandur"
            },
            "1030087@1,2,3,4,5,6,18,19,21,22,25@Y": {
              "name": "District Court Complex-Ballari"
            },
            "1030088@11,20@Y": {
              "name": "Court Complex- Hagaribommanahalli"
            }
          }
        },
        "13": {
          "name": "CHITRADURGA",
          "courtComplexes": {
            "1030090@6,7@Y": {
              "name": "Court Complex-Hiriyur"
            },
            "1030091@5@Y": {
              "name": "Court Complex-Molakalmuru"
            },
            "1030092@9,10@Y": {
              "name": "Court Complex-Challakere"
            },
            "1030093@8,12@Y": {
              "name": "Court Complex-Hosadurga"
            },
            "1030094@13,14@Y": {
              "name": "Court Complex Holalkere"
            },
            "1030095@1,2,3,4,11@Y": {
              "name": "District Court Complex-Chitradurga"
            }
          }
        },
        "14": {
          "name": "DAVANGERE",
          "courtComplexes": {
            "1030096@11,12@Y": {
              "name": "Court Complex- Channagiri"
            },
            "1030097@7,17@Y": {
              "name": "Court Complex- Harihara"
            },
            "1030098@10@Y": {
              "name": "Court Complex- Jagalur"
            },
            "1030099@1,2,3,5,6,14,15,16@Y": {
              "name": "District Court Complex-Davanagere"
            },
            "1030100@13@Y": {
              "name": "Court Complex-Honnali"
            }
          }
        },
        "15": {
          "name": "SHIVAMOGGA",
          "courtComplexes": {
            "1030101@5,23@Y": {
              "name": "Court Complex-Hosanagar"
            },
            "1030102@7,8@Y": {
              "name": "Court Complex- Sorab"
            },
            "1030103@10,11,12,13@Y": {
              "name": "Court Complex-Sagar"
            },
            "1030104@14,15,18@Y": {
              "name": "Court Complex-Bhadravati"
            },
            "1030105@9,20@Y": {
              "name": "Court Complex- Thirthahalli"
            },
            "1030106@6,22@Y": {
              "name": "Court Complex- Shikaripura"
            },
            "1030107@1,2,3,4,17,19,21@Y": {
              "name": "District Court Complex-Shimoga"
            }
          }
        },
        "16": {
          "name": "UDUPI",
          "courtComplexes": {
            "1030108@1,2,3,4,11,12@Y": {
              "name": "District Court Complex-Udupi"
            },
            "1030109@5,6@Y": {
              "name": "Court Complex- Karkala"
            },
            "1030110@7,8,9,10@Y": {
              "name": "Court Complex- Kundapur"
            },
            "1030211@13@Y": {
              "name": "COURT COMPLEX -BAINDURU"
            }
          }
        },
        "17": {
          "name": "CHIKKAMAGALURU",
          "courtComplexes": {
            "1030111@6,16@Y": {
              "name": "Court Complex-N.R.Pura"
            },
            "1030112@7,8@Y": {
              "name": "Court Complex-Kadur"
            },
            "1030113@9,10@Y": {
              "name": "Court Complex-Tarikere"
            },
            "1030114@1,2,3,4,13,14@Y": {
              "name": "District Court Complex-Chikkamagalur"
            },
            "1030115@12,15@Y": {
              "name": "Court Complex-Mudigere"
            },
            "1030116@5@Y": {
              "name": "Court Complex-Sringeri"
            },
            "1030117@11@Y": {
              "name": "Court Complex-Koppa"
            }
          }
        },
        "18": {
          "name": "TUMAKURU",
          "courtComplexes": {
            "1030118@5,6@Y": {
              "name": "Court Complex- Gubbi"
            },
            "1030119@4@Y": {
              "name": "Court Complex- Koratagere"
            },
            "1030120@1,2,3,13,17@Y": {
              "name": "District Court Complex-Tumakuru"
            },
            "1030121@23,24,25,26@Y": {
              "name": "Court Complex- Madhugiri"
            },
            "1030122@12,19@Y": {
              "name": "Court Complex- C.N.Halli"
            },
            "1030123@10,11@Y": {
              "name": "Court Complex- Kunigal"
            },
            "1030124@14,15@Y": {
              "name": "Court Complex- Turuvekere"
            },
            "1030125@9,18@Y": {
              "name": "Court Complex- Pavagada"
            },
            "1030126@7,8@Y": {
              "name": "Court Complex- Sira"
            },
            "1030127@20,21,22@Y": {
              "name": "Court Complex Tiptur"
            }
          }
        },
        "19": {
          "name": "KOLAR",
          "courtComplexes": {
            "1030128@6@Y": {
              "name": "Court Complex-Bangarpet"
            },
            "1030129@4,13@Y": {
              "name": "Court Complex-Mulbagal"
            },
            "1030130@9,10@Y": {
              "name": "Court Complex-KGF"
            },
            "1030131@7,8@Y": {
              "name": "Court Complex-Malur"
            },
            "1030132@5@Y": {
              "name": "Court Complex-Srinivaspur"
            },
            "1030133@1,2,3,11,12@Y": {
              "name": "District Court Complex-Kolar"
            }
          }
        },
        "20": {
          "name": "BENGALURU",
          "courtComplexes": {
            "1030134@2,5,10,11,12,13,14@Y": {
              "name": "CMM Court Complex, Bangalore"
            },
            "1030135@3@Y": {
              "name": "City Civil Court Complex, Bangalore"
            },
            "1030136@15,16,17,18,19,20,21,23@Y": {
              "name": "NyayaDegula Court Complex Bangalore"
            },
            "1030137@1@Y": {
              "name": "SmallCauses Court Complex,Bangalore"
            },
            "1030138@6,7,8,9@Y": {
              "name": "Mayo Hall Court Complex, Bangalore"
            },
            "1030210@22@Y": {
              "name": "COMMERCIAL COURT COMPLEX"
            }
          }
        },
        "21": {
          "name": "BENGALURU RURAL",
          "courtComplexes": {
            "1030140@8,20@Y": {
              "name": "Court Complex- Hosakote"
            },
            "1030141@1,2,3,14,15,19,22@Y": {
              "name": "City Civil Court Complex Bengalurur Rual"
            },
            "1030142@11,12,13@Y": {
              "name": "Court Complex- Anekal"
            },
            "1030143@16,17,18@Y": {
              "name": "Court Complex- Devanahalli"
            },
            "1030144@5,6,7@Y": {
              "name": "Court Complex- Doddaballapur"
            },
            "1030145@9,10@Y": {
              "name": "Court Complex- Nelamangala"
            },
            "1370058@21@Y": {
              "name": "KR Puram Court Complex"
            }
          }
        },
        "22": {
          "name": "MANDYA",
          "courtComplexes": {
            "1030146@9,10@Y": {
              "name": "Court Complex- Nagamangala"
            },
            "1030147@1,2,3,4,19,20@Y": {
              "name": "District Court Complex-Mandya"
            },
            "1030148@5,6@Y": {
              "name": "Court Complex- Maddur"
            },
            "1030149@11,12@Y": {
              "name": "Court Complex-Pandavapura"
            },
            "1030150@16,17@Y": {
              "name": "Court Complex-Malavalli"
            },
            "1030151@13,14,15,18@Y": {
              "name": "Court Complex- Srirangapatna"
            },
            "1030152@7,8@Y": {
              "name": "Court Complex- Krishnarajapet"
            }
          }
        },
        "23": {
          "name": "HASSAN",
          "courtComplexes": {
            "1030153@8,9@Y": {
              "name": "Court Complex-Belur"
            },
            "1030154@7,19@Y": {
              "name": "Court Complex-Channarayapatna"
            },
            "1030155@14,15@Y": {
              "name": "Court Complex-Holenarasipura"
            },
            "1030156@12,13@Y": {
              "name": "Court Complex-Arakalagudu"
            },
            "1030157@1,2,3,4,5,6,20,21@Y": {
              "name": "District Court Complex-Hassan"
            },
            "1030158@16@Y": {
              "name": "Court Complex-Alur"
            },
            "1030159@10,11@Y": {
              "name": "Court Complex-Arasikere"
            },
            "1030160@17,18@Y": {
              "name": "Court Complex- Sakaleshpur"
            }
          }
        },
        "24": {
          "name": "DAKSHINA KANNADA",
          "courtComplexes": {
            "1030161@23,32@Y": {
              "name": "Court complex - Mudbidri"
            },
            "1030162@5,6@Y": {
              "name": "Court Complex-Belthanagady"
            },
            "1030163@17,18,19,20,21,22,24,25,26,28,29,30,31@Y": {
              "name": "District Court Complex-Dakshina Kannada"
            },
            "1030164@1,2,4@Y": {
              "name": "Court Complex- Bantwal"
            },
            "1030165@7,8,9,16@Y": {
              "name": "Court Complex-Puttur"
            },
            "1030166@3,27@Y": {
              "name": "Court Complex-Sullia"
            }
          }
        },
        "25": {
          "name": "KODAGU",
          "courtComplexes": {
            "1030167@12@Y": {
              "name": "COURT COMPLEX KUSHALNAGAR"
            },
            "1030168@11@Y": {
              "name": "Court Complex  Ponnampet"
            },
            "1030169@6,7,8@Y": {
              "name": "Court Complex- Virajpet"
            },
            "1030170@1,2,3,4,9,13@Y": {
              "name": "District Court Complex-Kodagu"
            },
            "1030171@5,10@Y": {
              "name": "Court Complex- Somwarpet"
            }
          }
        },
        "26": {
          "name": "MYSURU",
          "courtComplexes": {
            "1030172@11,12@Y": {
              "name": "Court Complex- Nanjangud"
            },
            "1030173@3,4,5,6,8,18,19@Y": {
              "name": "Law Court Complex, Mysuru"
            },
            "1030174@13,14@Y": {
              "name": "Court Complex- KrishnarajaNagar"
            },
            "1030175@15,16@Y": {
              "name": "Court Complex- T.Narasipura"
            },
            "1030176@20,21,28@Y": {
              "name": "Court Complex- Hunsur"
            },
            "1030177@1,2@Y": {
              "name": "Double Road Court Complex, Mysuru"
            },
            "1030178@7,26@Y": {
              "name": "Court Complex- Heggadadevankote"
            },
            "1030179@9,10,22,24,25,27@Y": {
              "name": "ADR COURT COMPLEX, MYSURU"
            },
            "1030180@17,23@Y": {
              "name": "Court Complex- Periyapatna"
            }
          }
        },
        "27": {
          "name": "CHAMRAJNAGAR",
          "courtComplexes": {
            "1030181@5@Y": {
              "name": "Court Complex- Yelandur"
            },
            "1030182@6,7,8@Y": {
              "name": "Court Complex- Kollegal"
            },
            "1030183@4,10@Y": {
              "name": "Court Complex- Gundlupet"
            },
            "1030184@1,2,3,9@Y": {
              "name": "District Court Complex-Chamarajanagar"
            }
          }
        },
        "28": {
          "name": "RAMANAGARA",
          "courtComplexes": {
            "1030185@5,8@Y": {
              "name": "Court Complex- Chennapatna"
            },
            "1030186@1,2,3,11,12@Y": {
              "name": "District Court Complex Ramanagar"
            },
            "1030187@6,7,10@Y": {
              "name": "Court Complex- Kanakapura"
            },
            "1030188@4,9@Y": {
              "name": "Court Complex- Magadi"
            }
          }
        },
        "29": {
          "name": "CHIKKABALLAPUR",
          "courtComplexes": {
            "1030189@8,9,15@Y": {
              "name": "JMFC Court Complex-Chintamani"
            },
            "1030190@4,13@Y": {
              "name": "Court Complex- Sidlaghatta"
            },
            "1030191@5@Y": {
              "name": "Court Complex-Bagepalli"
            },
            "1030192@1,2,3,10,14@Y": {
              "name": "District Court Complex-Chikkaballapur"
            },
            "1030193@6,11@Y": {
              "name": "Court Complex- Gowribidanur"
            },
            "1030194@12@Y": {
              "name": "COURT COMPLEX - GUDIBANDA"
            }
          }
        },
        "30": {
          "name": "YADGIR",
          "courtComplexes": {
            "1030195@1,2,3,5@Y": {
              "name": "District Court Complex-Yadgir"
            },
            "1030196@4,6@Y": {
              "name": "Court Complex-Shahapur"
            },
            "1030197@7,8,9@Y": {
              "name": "Court Complex  Shorapur"
            }
          }
        },
        "31": {
          "name": "VIJAYANAGAR",
          "courtComplexes": {

          }
        }
      }
    },
    "4": {
      "name": "Kerala",
      "districts": {
        "1": {
          "name": "Kasaragod",
          "courtComplexes": {
            "1040005@1,2,3,4,5,6,11,12,14,18@N": {
              "name": "DISTRICT COURT KASARGOD"
            },
            "1040006@13@N": {
              "name": "Family Court Kasargod"
            },
            "1040007@7,8,9,10,16,17@N": {
              "name": "Court Complex, Hosdurg"
            },
            "1040166@15@N": {
              "name": "Gramnyayalaya Parappa"
            }
          }
        },
        "2": {
          "name": "Ernakulam",
          "courtComplexes": {
            "1040008@19,20,58@N": {
              "name": "COURT COMPLEX,KOLENCHERRY"
            },
            "1040009@26,27,28,29,30,65,66,78,84@N": {
              "name": "COURT COMPLEX,PERUMBAVOOR"
            },
            "1040010@69@N": {
              "name": "JFCM Njarakal"
            },
            "1040011@33,34,35,36,60@N": {
              "name": "DISTRICT COURT ANNEX, KALOOR,"
            },
            "1040012@61@N": {
              "name": "Chottanikara Court Complex"
            },
            "1040013@62@N": {
              "name": "JFCM Court,Kakkanad"
            },
            "1040014@64@N": {
              "name": "JFCM, Angamaly"
            },
            "1040015@74@N": {
              "name": "Court complex Tripunithura"
            },
            "1040016@70@N": {
              "name": "Court complex, Mattanchery"
            },
            "1040017@67@N": {
              "name": "JFCM Court Piravom"
            },
            "1040018@1,2,3,4,5,6,7,8,9,10,11,12,25,31,37,53,54,55,56,57,79,88,90@N": {
              "name": "DISTRICT COURT ERNAKULAM"
            },
            "1040019@38,39,40,41,42,43,59,83@N": {
              "name": "COURT COMPLEX NORTH PARAVUR"
            },
            "1040021@52@N": {
              "name": "Atrocities Trial Court"
            },
            "1040022@46,47,48,49,50,51,71,75,81,85@N": {
              "name": "COURT COMPLEX MUVATTUPUZHA"
            },
            "1040023@32@N": {
              "name": "COURT COMPLEX,PANAMPILLY NAGAR"
            },
            "1040024@13,14,15,16,17,18,82@N": {
              "name": "COURT COMPLEX ,KOCHI"
            },
            "1040025@44,45,76@N": {
              "name": "COURT COMPLEX KOTHAMANGALAM"
            },
            "1040026@21,22,23,24,80@N": {
              "name": "COURT COMPLEX ,ALUVA"
            },
            "1040185@63@N": {
              "name": "JFCM Court Complex, Kalamassery"
            },
            "1040186@68@N": {
              "name": "JFCM3 Court Complex, North Paravur"
            },
            "1040189@86@N": {
              "name": "Family Court, North Paravur Complex"
            },
            "1040190@87@N": {
              "name": "FTSC,North Paravur Complex"
            },
            "1040199@89@N": {
              "name": "Family Court, Aluva Complex"
            }
          }
        },
        "3": {
          "name": "Kannur",
          "courtComplexes": {
            "1040027@25@N": {
              "name": "Gramnyayalaya Irikkur"
            },
            "1040028@21,35@N": {
              "name": "JFCM, FTSC Mattannur"
            },
            "1040029@1,2,3,4,5,6,7,26,29,34@N": {
              "name": "DISTRICT COURT THALASSERRY, Kannur"
            },
            "1040030@18,19,22,30@N": {
              "name": "Court Complex Thaliparambu"
            },
            "1040031@8,9,10,11,12,20,23,31,33@N": {
              "name": "COURT COMPLEX KANNUR"
            },
            "1040032@15,16,17,32@N": {
              "name": "Court Complex, Sub Court, Payyannur"
            },
            "1040033@24@N": {
              "name": "Family court, Thalassery"
            },
            "1040034@13,14@N": {
              "name": "Court Complex Kuthuparambu"
            },
            "1040170@27@N": {
              "name": "Gramanyayalaya , Payam"
            },
            "1040182@28@N": {
              "name": "Gramanyayalaya , Chokli"
            }
          }
        },
        "4": {
          "name": "Thrissur",
          "courtComplexes": {
            "1040036@10,11,12,26,28,31,39@N": {
              "name": "COURT COMPLEX, MACT, IRINJALAKKUDA"
            },
            "1040038@16,17,22,38@N": {
              "name": "COURT COMPLEX ,CHAVAKKAD"
            },
            "1040039@18,19,27@N": {
              "name": "COURT COMPLEX.KODUNGALLUR"
            },
            "1040040@15,21@N": {
              "name": "Court complex  Chalakudy"
            },
            "1040041@1,2,3,4,5,6,7,8,23,24,25,29,32@N": {
              "name": "DISTRICT COURT THRISSUR"
            },
            "1040042@9,35,40@N": {
              "name": "Court Complex, Kunnamkulam"
            },
            "1040043@20@N": {
              "name": "JFCM, Irinijalakuda, thrissur"
            },
            "1040044@13,14@N": {
              "name": "COURT COMPLEX , Munsiff Court, WADAKKANCHERY"
            },
            "1040045@30,33,34,41@N": {
              "name": "Family Court Complex, Thrissur"
            },
            "1040172@36@N": {
              "name": "Gramanyayalaya, Pazhayannur"
            },
            "1040173@37@N": {
              "name": "Gramanyayalaya, Mathilakam"
            }
          }
        },
        "5": {
          "name": "Kozhikode",
          "courtComplexes": {
            "1040046@23@N": {
              "name": "Court Complex, JFCMC, Kunnamangalam"
            },
            "1040047@1,2,3,4,7,8,9,10,11,19,20,24,38,39,43,44,45,46,47,48@N": {
              "name": "DISTRICT COURT, KOZHIKODE"
            },
            "1040048@40@N": {
              "name": "Family Court, Vatakara"
            },
            "1040049@30,31,32,42,51@N": {
              "name": "COURT COMPLEX KOYILANDY"
            },
            "1040050@37@N": {
              "name": "FAMILY COURT KOZHIKODE"
            },
            "1040051@27,28,29@N": {
              "name": "MUSIFF COURT, JFCM I & II Perambara, Kozhikode"
            },
            "1040052@35,36@N": {
              "name": "MUNSIFF-MAGISTRATE COURT, Payoli, Kozhikode"
            },
            "1040053@33,34,53@N": {
              "name": "MUNSIFF-MAGISTRATE COURT, Nadapuram, Kozhikode"
            },
            "1040054@25,26,41@N": {
              "name": "Court complex Thamarassery"
            },
            "1040055@21,22@N": {
              "name": "COURT FOR THE Trial OF MARAD CA"
            },
            "1040057@12,13,14,15,16,17,18,52@N": {
              "name": "COURT COMPLEX, Addl DC, VATAKARA"
            },
            "1040179@49@N": {
              "name": "Grama Nyayalaya Kunnummal"
            },
            "1040180@50@N": {
              "name": "Grama Nyayalaya Koduvally"
            }
          }
        },
        "6": {
          "name": "Alappuzha",
          "courtComplexes": {
            "1040058@19@N": {
              "name": "COURT COMPLEX,RAMANKARI"
            },
            "1040059@35@N": {
              "name": "Family Court, Alappuzha"
            },
            "1040060@7,8,27@N": {
              "name": "Court Complex, Kayamkulam"
            },
            "1040061@12,13,14,15,30,31,42,45,46@N": {
              "name": "Court Complex, CHERTHALA"
            },
            "1040062@21,22,23,24,25,33,34,41@N": {
              "name": "Court Complex, MAVELIKARA"
            },
            "1040063@37@N": {
              "name": "Gram Nyayalaya, Ambalappuzha"
            },
            "1040064@6,20@N": {
              "name": "JUDICIAL FIRST CLASS MAGISTRATE, Alappuzha"
            },
            "1040065@36@N": {
              "name": "Family Court, Mavelikkara"
            },
            "1040066@1,2,3,4,29,32,40,47@N": {
              "name": "DISTRICT COURT, Alappuzha"
            },
            "1040067@5@N": {
              "name": "COURT of THE CHIEF JUDICIAL MAGiSTRATE, Alapuzhha"
            },
            "1040068@9,10,28,39@N": {
              "name": "Court Complex, Haripad"
            },
            "1040069@11@N": {
              "name": "JFCM, Ambalappuzha"
            },
            "1040070@38@N": {
              "name": "Gram Nyayalaya, Kanjikuzhi"
            },
            "1040071@16,17,18,26,43,44@N": {
              "name": "Court Complex, Chengannur"
            }
          }
        },
        "7": {
          "name": "Idukki",
          "courtComplexes": {
            "1040072@14,15,16,24,32,34,37@N": {
              "name": "COURT COMPLEX KATTAPPANA"
            },
            "1040073@1,2,3,4,5,6,7,8,31@N": {
              "name": "DISTRICT COURT MUTTAM, Idukki, Thoduphuzha"
            },
            "1040074@19,20,25,35,36@N": {
              "name": "COURT COMPLEX DEVIKULAM"
            },
            "1040075@29@N": {
              "name": "Nyayalaya Nedumkandam"
            },
            "1040076@21,22,23@N": {
              "name": "COURT COMPLEX, PEERUMEDU"
            },
            "1040077@9,10,11,33@N": {
              "name": "COURT COMPLEX IDUKKI"
            },
            "1040078@26@N": {
              "name": "FAMILY COURT THODUPUZHA"
            },
            "1040079@28@N": {
              "name": "Nyayalaya Azhutha, Peermade"
            },
            "1040080@30@N": {
              "name": "Family Court  Kattappana"
            },
            "1040081@13,27@N": {
              "name": "COURT COMPLEX ADIMALY"
            },
            "1040082@12@N": {
              "name": "COURT COMPLEX, NEDUMKANDAM"
            }
          }
        },
        "8": {
          "name": "Palakkad",
          "courtComplexes": {
            "1040083@11,12,24,36@N": {
              "name": "COURT COMPLEX ,ALATHUR"
            },
            "1040084@31@N": {
              "name": "Gram Nyayalaya Thenkurissi"
            },
            "1040085@30@N": {
              "name": "Gram Nyayalaya Pudupariyaram"
            },
            "1040086@29@N": {
              "name": "FAMILY COURT OTTAPALAM"
            },
            "1040087@13,14,28@N": {
              "name": "COURT COMPLEX,CHITTUR"
            },
            "1040088@20@N": {
              "name": "JUDICIAL First CLASS MAGISTRATE, Ottapalam"
            },
            "1040089@15,16,33@N": {
              "name": "MUNSIFF MAGISTRATE COURT ,PATTAMBI"
            },
            "1040090@9,10,22@N": {
              "name": "MUNSIFF MAGISTRATE COURT,MANNARKKAD"
            },
            "1040091@23@N": {
              "name": "FAMILY COURT,PALAKKAD"
            },
            "1040092@17,18,19,27,35@N": {
              "name": "COURT COMPLEX, MACT, OTTAPALAM"
            },
            "1040093@1,2,3,4,5,6,7,8,21,25,26,32@N": {
              "name": "DISTRICT COURT PALAKKAD"
            },
            "1040164@34@N": {
              "name": "Gram Nyayalaya Sreekrishnapuram"
            },
            "1040196@37,38@N": {
              "name": "Court Complex, Attappadi at Agali"
            }
          }
        },
        "9": {
          "name": "Thiruvananthapuram",
          "courtComplexes": {
            "1040094@1,2,3,4,5,6,7,8,9,10,11,32,33,34,35,36,42,43,46,47,48,59,60@N": {
              "name": "COURT COMPLEX VANCHIYOOR"
            },
            "1040095@20@N": {
              "name": "JFMC KATTAKKADA"
            },
            "1040096@29,30,31@N": {
              "name": "COURT COMPLEX, VARKALA"
            },
            "1040097@16,17,18,19,37,38,44,54,57@N": {
              "name": "COURT COMPLEX NEDUMANGAD"
            },
            "1040098@12,13,14,15,21,45,49,52,56,61@N": {
              "name": "COURT COMPLEX ATTINGAL"
            },
            "1040099@22,23,24,25,26,27,28,39,40,41,53,55,58@N": {
              "name": "COURT COMPLEX NEYYATTINKARA"
            },
            "1040171@50@N": {
              "name": "Grama Nyayalaya Parasala"
            },
            "1040181@51@N": {
              "name": "JFMC (FOREST) Nedumangad"
            },
            "1040188@62@N": {
              "name": "Special Court for SC/ST PoA Cases"
            },
            "1040191@63,68@N": {
              "name": "Court Centre FTSC Neyyattinkara"
            },
            "1040192@64@N": {
              "name": "Fast Track Special Court,Nedumangad"
            },
            "1040193@65@N": {
              "name": "Fast Track Special Court,Kattakkada"
            },
            "1040194@66@N": {
              "name": "Fast Track Special Court , Varkala"
            },
            "1040195@67@N": {
              "name": "Fast Track Special Court,Trivandrum"
            }
          }
        },
        "10": {
          "name": "Kottayam",
          "courtComplexes": {
            "1040100@22,23,24@N": {
              "name": "COURT COMPLEX KANJIRAPPALLY"
            },
            "1040101@13,14,15,19,33@N": {
              "name": "COURT COMPLEX, PALA"
            },
            "1040103@1,2,3,4,5,6,7,8,30,32@N": {
              "name": "DISTRICT COURT KOTTAYAM"
            },
            "1040104@28@N": {
              "name": "Gram Nyayalaya Pampady"
            },
            "1040105@9,10,35@N": {
              "name": "COURT COMPLEX ETTUMANOOR"
            },
            "1040106@11,12@N": {
              "name": "MUNSIFF COURT CHANGANASSERY"
            },
            "1040107@26@N": {
              "name": "FAMILY COURT,ETTUMANOOR"
            },
            "1040108@16,31@N": {
              "name": "JFCM COURT CHANGANASSERRY"
            },
            "1040109@20,21,25@N": {
              "name": "COURT COMPLEX VAIKOM"
            },
            "1040110@17,18,34@N": {
              "name": "MUNSIFF MAGISTRATE ERATTUPETTA"
            },
            "1040111@29@N": {
              "name": "Gram Nyayalaya Vaikom"
            },
            "1040112@27@N": {
              "name": "FAMILY COURT,PALA"
            }
          }
        },
        "11": {
          "name": "Malappuram",
          "courtComplexes": {
            "1040113@8,9,10,24,29,33@N": {
              "name": "Court complex, Sub Court, Tirur"
            },
            "1040114@25@N": {
              "name": "Family Court, manjeri Malappuram"
            },
            "1040115@11@N": {
              "name": "MOTOR ACCIDENT CLAIMS TRIBUNAL, Tirur"
            },
            "1040116@12@N": {
              "name": "JFCMC-Forest, Manjeri"
            },
            "1040117@20@N": {
              "name": "JUDICIAL First CLASS MAGISTRATE, Mallapuram"
            },
            "1040118@16,37@N": {
              "name": "Court Complex, Nilambur"
            },
            "1040119@17,18,19,36@N": {
              "name": "Court complex, Parappanangadi"
            },
            "1040120@13,14,15,28,35@N": {
              "name": "Court Complex, perinthalmanna"
            },
            "1040121@26@N": {
              "name": "SCST Court,Manjeri"
            },
            "1040122@22,23@N": {
              "name": "MUNSIFF MAGISTRATE COURT PONNANI, manjeri"
            },
            "1040123@1,2,3,4,5,6,7,27,32,34@N": {
              "name": "DISTRICT COURT MANJERI"
            },
            "1040167@30@N": {
              "name": "Grama Nyayalaya Ponnani Edappal"
            },
            "1040168@31@N": {
              "name": "Grama Nyayalaya Pulamanthole"
            },
            "1040197@38@N": {
              "name": "Fast Track Special Court, Nilambur"
            },
            "1040198@39@N": {
              "name": "Fast Track Special Court, Ponnani"
            }
          }
        },
        "12": {
          "name": "Pathanamthitta",
          "courtComplexes": {
            "1040124@16@N": {
              "name": "FAMILY COURT THIRUVALLA"
            },
            "1040125@17@N": {
              "name": "Family Court  Pathanamthitta"
            },
            "1040126@1,2,3,4,5,6,15,18,19,22,28@N": {
              "name": "DISTRICT COURT PATHANAMTHITTA"
            },
            "1040127@10,14,23,27,29@N": {
              "name": "COURT COMPLEX, Munsiff Court, ADOOR"
            },
            "1040128@11,12,13,24,26@Y": {
              "name": "COURT COMPLEX, THIRUVALLA"
            },
            "1040129@8@N": {
              "name": "Judicial First Class Magistrate Court Ranni"
            },
            "1040130@7,25@N": {
              "name": "MUNSIFF COURT RANNI"
            },
            "1040163@20@N": {
              "name": "GRAM NYAYALAYA PANDALAM"
            },
            "1040165@21@N": {
              "name": "Gramnyayalaya Ranni"
            }
          }
        },
        "15": {
          "name": "Kollam",
          "courtComplexes": {
            "1040133@40@N": {
              "name": "JFMC Temp Kadakkal"
            },
            "1040134@45,55@N": {
              "name": "Court Center ,Paravur"
            },
            "1040136@42@N": {
              "name": "Court Centre JFMC Temp  Chavara"
            },
            "1040139@48@N": {
              "name": "JFMC Temp Kollam"
            },
            "1040140@1,29,30,31,43,49,51,57,59@N": {
              "name": "Court Complex Punalur"
            },
            "1040142@44@N": {
              "name": "Gram Nyayalaya, Chittumala"
            },
            "1040143@39@N": {
              "name": "Spl Court for SC ST POA Act cases"
            },
            "1040144@20@N": {
              "name": "MACT, Kollam"
            },
            "1040145@18,33@N": {
              "name": "Munsiff Magistrate Court  Paravoor"
            },
            "1040147@10,11,34,52,56@N": {
              "name": "Court Complex, Karunagapally"
            },
            "1040148@2,4,5,6,14,19,46,58@N": {
              "name": "DISTRICT COURT KOLLAM"
            },
            "1040150@21,36@Y": {
              "name": "WAKF TRIBUNAL   Family Court KOLLAM"
            },
            "1040153@22,23,38@N": {
              "name": "Munsiff Magistrate  Sasthamkotta"
            },
            "1040154@41@N": {
              "name": "Court Centre, Chadayamangalam"
            },
            "1040169@32@N": {
              "name": "Court Centre, Pathanapuram"
            },
            "1040175@24,25,26,27,28,35,50,54@N": {
              "name": "Court complex,Kottarakkara"
            },
            "1040178@37,47@N": {
              "name": "Court Centre, Chavara"
            },
            "1040184@9,53@N": {
              "name": "FTSC Centre Kollam"
            }
          }
        },
        "16": {
          "name": "Wayanad",
          "courtComplexes": {
            "1040157@1,2,3,4,5,17@N": {
              "name": "DISTRICT COURT KALPETTA"
            },
            "1040158@16@N": {
              "name": "Gram Nyayalaya, Kalpetta"
            },
            "1040159@10,11,12,13,14@N": {
              "name": "COURT COMPLEX MANANTHAVADY"
            },
            "1040160@15@N": {
              "name": "FAMILY COURT KALPETTA"
            },
            "1040161@6,7,8,9,18,19@N": {
              "name": "SUB COURT SULTHAN BATHERY"
            }
          }
        }
      }
    },
    "5": {
      "name": "Himachal Pradesh",
      "districts": {
        "1": {
          "name": "Hamirpur",
          "courtComplexes": {
            "1050005@2,5@N": {
              "name": "Badsar"
            },
            "1050006@1,3,4@N": {
              "name": "Hamirpur"
            },
            "1050007@6,7@N": {
              "name": "Nadaun"
            },
            "1370054@8,9@N": {
              "name": "Bhoranj"
            }
          }
        },
        "2": {
          "name": "Kangra",
          "courtComplexes": {
            "1050008@5,12,21@N": {
              "name": "Dehra"
            },
            "1050009@2,14,20@N": {
              "name": "Palampur"
            },
            "1050010@16,17,22@N": {
              "name": "Nurpur"
            },
            "1050011@4,10@N": {
              "name": "Kangra"
            },
            "1050012@3,13@N": {
              "name": "Baijnath"
            },
            "1050013@7,15@N": {
              "name": "Indora"
            },
            "1050014@1,8,9@N": {
              "name": "Dharamshala"
            },
            "1050015@6,11@N": {
              "name": "Jawali"
            },
            "1050048@18,19@N": {
              "name": "Jaisinghpur"
            }
          }
        },
        "3": {
          "name": "Sirmaur",
          "courtComplexes": {
            "1050016@1,4,5@N": {
              "name": "Nahan"
            },
            "1050017@2,6,10@N": {
              "name": "Paonta Sahib"
            },
            "1050018@3,7@N": {
              "name": "Rajgarh"
            },
            "1050054@8,9@N": {
              "name": "Shillai"
            }
          }
        },
        "4": {
          "name": "Una",
          "courtComplexes": {
            "1050019@2,5@N": {
              "name": "Amb"
            },
            "1050020@1,3,4@N": {
              "name": "Una"
            }
          }
        },
        "5": {
          "name": "Solan",
          "courtComplexes": {
            "1050021@3,8@N": {
              "name": "Arki"
            },
            "1050022@5,10,11@N": {
              "name": "Nalagarh"
            },
            "1050023@2,12,14@N": {
              "name": "Kasauli"
            },
            "1050024@4,9,13@N": {
              "name": "Kandaghat"
            },
            "1050025@1,6,7@N": {
              "name": "Solan"
            }
          }
        },
        "6": {
          "name": "Mandi",
          "courtComplexes": {
            "1050026@17,18,19@N": {
              "name": "Mandi"
            },
            "1050027@3,9,27@N": {
              "name": "Joginder Nagar"
            },
            "1050028@5,11,26@N": {
              "name": "Karsog"
            },
            "1050029@6,7,23@N": {
              "name": "Sundernagar"
            },
            "1050030@2,10,20@N": {
              "name": "Sarkaghat"
            },
            "1050031@4,8@N": {
              "name": "Gohar"
            },
            "1050052@21,22@N": {
              "name": "Thunag"
            },
            "1050055@24,25@N": {
              "name": "Padhar"
            },
            "1370007@28,29@N": {
              "name": "Dharampur"
            }
          }
        },
        "7": {
          "name": "Bilaspur",
          "courtComplexes": {
            "1050032@2,5,6@N": {
              "name": "Ghumarwin"
            },
            "1050033@1,3,4@N": {
              "name": "Bilaspur"
            },
            "1050046@7,8@N": {
              "name": "Jhanduta"
            }
          }
        },
        "8": {
          "name": "Chamba",
          "courtComplexes": {
            "1050034@2,5@N": {
              "name": "Dalhousie"
            },
            "1050035@1,3,4@N": {
              "name": "Chamba"
            },
            "1050047@6,7@N": {
              "name": "Tissa"
            }
          }
        },
        "9": {
          "name": "Kinnaur",
          "courtComplexes": {
            "1050036@1,6@N": {
              "name": "Anni"
            },
            "1050037@3,7,8@N": {
              "name": "Reckong Peo"
            },
            "1050038@2,4,5@N": {
              "name": "Rampur Bushehr"
            }
          }
        },
        "10": {
          "name": "Kullu",
          "courtComplexes": {
            "1050039@2,5@N": {
              "name": "Manali"
            },
            "1050040@1,3,4@N": {
              "name": "Kullu"
            },
            "1050050@6,7@N": {
              "name": "Banjar"
            }
          }
        },
        "11": {
          "name": "Shimla",
          "courtComplexes": {
            "1050041@10,11,12@N": {
              "name": "Shimla"
            },
            "1050042@2,8,9@N": {
              "name": "Rohru"
            },
            "1050043@3,7@N": {
              "name": "Jubbal"
            },
            "1050044@1,4,13@N": {
              "name": "Theog"
            },
            "1050045@5,6@N": {
              "name": "Chopal"
            }
          }
        },
        "103": {
          "name": "Lahaul And Spiti",
          "courtComplexes": {

          }
        }
      }
    },
    "6": {
      "name": "Assam",
      "districts": {
        "1": {
          "name": "Kamrup Metro",
          "courtComplexes": {
            "1060008@10@N": {
              "name": "MAC Tribunal"
            },
            "1060009@13@N": {
              "name": "Railway Magistrate Court Complex"
            },
            "1060010@15@Y": {
              "name": "Family Court"
            },
            "1060011@8@N": {
              "name": "Chief Judicial Magistrate's Complex"
            },
            "1060012@11@N": {
              "name": "Industrial Tribunal"
            },
            "1060013@4,5,6,7@N": {
              "name": "District Judge's Court Complex"
            },
            "1060014@14@N": {
              "name": "Additional CBI Court, Chandmari"
            },
            "1060015@9@N": {
              "name": "Labour Court"
            },
            "1060081@12@N": {
              "name": "MACT No 2 and 3"
            }
          }
        },
        "2": {
          "name": "Tinsukia",
          "courtComplexes": {
            "1060016@2,3,4,5,6@Y": {
              "name": "District Court Complex"
            },
            "1060017@10@Y": {
              "name": "SDJM (M) Court , Chapakhowa"
            },
            "1060018@7,8,9@Y": {
              "name": "SDJM (M) Court Complex, Margherita"
            },
            "1370018@11@N": {
              "name": "Railway Magistrate Court Complex"
            }
          }
        },
        "3": {
          "name": "Sivasagar",
          "courtComplexes": {
            "1060019@2,3,5@Y": {
              "name": "District Judge Court Complex"
            },
            "1060020@9,10@Y": {
              "name": "SDJM Nazira"
            },
            "1060021@4@Y": {
              "name": "Chief Judicial Magistrate's Complex"
            }
          }
        },
        "4": {
          "name": "Morigaon",
          "courtComplexes": {
            "1060023@2,3,4,5,6@Y": {
              "name": "District Court Complex"
            }
          }
        },
        "5": {
          "name": "Lakhimpur",
          "courtComplexes": {
            "1060024@2,3,4,5@Y": {
              "name": "District Court Complex"
            },
            "1060025@6,7@Y": {
              "name": "SDJM (M) Court Compex, Dhakuakhana"
            }
          }
        },
        "6": {
          "name": "Sonitpur",
          "courtComplexes": {
            "1060027@2,3,4,5,6@N": {
              "name": "District Judge's Court, Sonitpur"
            }
          }
        },
        "7": {
          "name": "Dibrugarh",
          "courtComplexes": {
            "1060029@8@Y": {
              "name": "Industrial Tribunal Dibrugarh"
            },
            "1060030@2,3,4,5,6@Y": {
              "name": "District Court Complex"
            },
            "1060031@7@N": {
              "name": "Labour Court"
            },
            "1060082@9,10@Y": {
              "name": "SDJM Court Complex, Naharkatia"
            }
          }
        },
        "8": {
          "name": "Darrang",
          "courtComplexes": {
            "1060032@2,3,4,5@N": {
              "name": "District Court Complex"
            }
          }
        },
        "9": {
          "name": "Bongaigaon",
          "courtComplexes": {
            "1060033@10,11,12@Y": {
              "name": "SDJM (M) Court Complex, Abhayapuri"
            },
            "1060034@3,5,6,7,8@Y": {
              "name": "District Court Complex"
            }
          }
        },
        "10": {
          "name": "Nagaon",
          "courtComplexes": {
            "1060036@2,3,4,5,11@Y": {
              "name": "District Court Complex"
            },
            "1060037@6,7@Y": {
              "name": "SDJM Court Complex Koliabor"
            }
          }
        },
        "11": {
          "name": "Jorhat",
          "courtComplexes": {
            "1060039@2,3,4,5,6@Y": {
              "name": "District Court Complex"
            },
            "1060040@8,9@Y": {
              "name": "SDJM Court Complex, Titabar"
            }
          }
        },
        "12": {
          "name": "Sribhumi",
          "courtComplexes": {
            "1060041@4@N": {
              "name": "Chief Judicial Magistrate's Complex"
            },
            "1060042@1,2,3@N": {
              "name": "District Judge's Court"
            }
          }
        },
        "13": {
          "name": "Cachar",
          "courtComplexes": {
            "1060043@6@N": {
              "name": "Industrial Tribunal"
            },
            "1060044@8@N": {
              "name": "Family Court"
            },
            "1060045@7@N": {
              "name": "SDJM Lakhipur"
            },
            "1060046@1,2,3,4,5@Y": {
              "name": "District Court Complex"
            }
          }
        },
        "15": {
          "name": "Nalbari",
          "courtComplexes": {
            "1060047@3@N": {
              "name": "Chief Judicial Magistrate's Complex"
            },
            "1060048@1,2,4,5@N": {
              "name": "District Judge's Court Complex"
            },
            "1060049@6@N": {
              "name": "JMFC Court Complex, Tihu"
            },
            "1060078@7@N": {
              "name": "Family Court Complex"
            }
          }
        },
        "16": {
          "name": "Dhubri",
          "courtComplexes": {
            "1060051@11@Y": {
              "name": "Family Court Complex"
            },
            "1060052@1,2,3,4,5@Y": {
              "name": "District Court Complex"
            },
            "1060053@6,7,8@Y": {
              "name": "SDJM (M) Court Complex, Bilasipara"
            }
          }
        },
        "17": {
          "name": "Dhemaji",
          "courtComplexes": {
            "1060054@1,2,3,6@N": {
              "name": "District Court Complex"
            },
            "1060055@4,5@N": {
              "name": "SDJM (M) Court Complex, Jonai"
            }
          }
        },
        "18": {
          "name": "Goalpara",
          "courtComplexes": {
            "1060056@1,2,3,4@N": {
              "name": "District Court Complex"
            }
          }
        },
        "19": {
          "name": "Golaghat",
          "courtComplexes": {
            "1060057@6,7@N": {
              "name": "SDJM Court Complex , Bokakhat"
            },
            "1060058@8,9@N": {
              "name": "SDJM Court Complex, Dhansiri, Sarupathar"
            },
            "1060059@1,2,3,4,5@N": {
              "name": "District Court Complex"
            }
          }
        },
        "20": {
          "name": "Barpeta",
          "courtComplexes": {
            "1060061@1,2,4,5@Y": {
              "name": "District Judge's Court Complex"
            },
            "1060062@3@N": {
              "name": "CJM Complex"
            },
            "1060083@9@N": {
              "name": "Family Court"
            }
          }
        },
        "21": {
          "name": "Hailakandi",
          "courtComplexes": {
            "1060063@1,2,3,4@N": {
              "name": "District Court Complex"
            }
          }
        },
        "22": {
          "name": "Kokrajhar",
          "courtComplexes": {
            "1060064@5@Y": {
              "name": "SDJM,Gossaigaon"
            },
            "1060065@1,2,3,4@Y": {
              "name": "District Court Complex"
            }
          }
        },
        "23": {
          "name": "Kamrup",
          "courtComplexes": {
            "1060066@8@Y": {
              "name": "JMFC Court Complex Hajo"
            },
            "1060067@2,3,4,5,9@Y": {
              "name": "District Sessions Judge, Amingaon"
            },
            "1060068@1,6,7@N": {
              "name": "SDJM  Court Complex, Rangia"
            }
          }
        },
        "24": {
          "name": "Udalguri",
          "courtComplexes": {
            "1060070@1,2,3,4,5@Y": {
              "name": "District Court Complex Udalguri"
            }
          }
        },
        "25": {
          "name": "Chirang",
          "courtComplexes": {
            "1060071@4,5,6@N": {
              "name": "SDJM Court Complex, Bijni"
            },
            "1060072@1,2,3,7@N": {
              "name": "District Court Complex Chirang"
            }
          }
        },
        "26": {
          "name": "Karbi Anglong",
          "courtComplexes": {
            "1060073@1,2,3,4@N": {
              "name": "District Court Complex"
            },
            "1060080@5@Y": {
              "name": "SDJM Court Complex, Bokajan"
            }
          }
        },
        "27": {
          "name": "Baksa",
          "courtComplexes": {
            "1060074@1,2,3,4@Y": {
              "name": "District Court Complex"
            }
          }
        },
        "28": {
          "name": "Dima Hasao",
          "courtComplexes": {
            "1060075@1,2,3,4@N": {
              "name": "District Court Complex"
            }
          }
        },
        "29": {
          "name": "Charaideo",
          "courtComplexes": {
            "1060076@1,2,3,4@Y": {
              "name": "District Court Complex"
            }
          }
        },
        "30": {
          "name": "Hojai",
          "courtComplexes": {
            "1060077@1,2,3,4@Y": {
              "name": "District Court Complex"
            }
          }
        },
        "31": {
          "name": "South Salmara",
          "courtComplexes": {
            "1060079@1,2,3,4@Y": {
              "name": "District Court Complex"
            }
          }
        },
        "32": {
          "name": "Bajali",
          "courtComplexes": {
            "1060085@1,2,3,4@Y": {
              "name": "District Court Complex"
            }
          }
        },
        "33": {
          "name": "Biswanath",
          "courtComplexes": {
            "1060086@1,2,3,6@Y": {
              "name": "District Court Complex"
            },
            "1060087@4,5@Y": {
              "name": "SDJM Court Complex,Gohpur"
            }
          }
        },
        "34": {
          "name": "Majuli",
          "courtComplexes": {
            "1060084@2,3,4,5,6@Y": {
              "name": "District Court Complex"
            }
          }
        },
        "35": {
          "name": "West Karbi Anglong",
          "courtComplexes": {

          }
        }
      }
    },
    "7": {
      "name": "Jharkhand",
      "districts": {
        "1": {
          "name": "Bokaro",
          "courtComplexes": {
            "1070001@2,3,4,5,6,7,8,9,10,11@Y": {
              "name": "2) Ten Court Building Complex -2"
            }
          }
        },
        "2": {
          "name": "Dumka",
          "courtComplexes": {
            "1070002@2,3,4,5@N": {
              "name": "1) D.J. Court Building Complex-1"
            }
          }
        },
        "3": {
          "name": "Koderma",
          "courtComplexes": {
            "1070003@1,2,3,4,5@N": {
              "name": "1) District & Sessions Judge's Building Complex-1"
            }
          }
        },
        "4": {
          "name": "West Singhbhum at Chaibasa",
          "courtComplexes": {
            "1070004@2,3,4,5,6@N": {
              "name": "1) District Courts Complex-1"
            }
          }
        },
        "5": {
          "name": "Gumla",
          "courtComplexes": {
            "1070005@1,2,3,4,5@N": {
              "name": "1) Main Civil Court Complex-1"
            }
          }
        },
        "6": {
          "name": "Godda",
          "courtComplexes": {
            "1070006@2,3,4,5@Y": {
              "name": "2) New Four Court Building Comlplex-2"
            }
          }
        },
        "7": {
          "name": "Hazaribagh",
          "courtComplexes": {
            "1070007@2,3,4,5,6@N": {
              "name": "1) Annexy Building"
            }
          }
        },
        "8": {
          "name": "Lohardaga",
          "courtComplexes": {
            "1070008@4,5,6,7,8@N": {
              "name": "1)District Court Complex-1"
            }
          }
        },
        "9": {
          "name": "Dhanbad",
          "courtComplexes": {
            "1070009@2,3,4,5,6@N": {
              "name": "4) District Court 28 Courts Building"
            }
          }
        },
        "10": {
          "name": "Giridih",
          "courtComplexes": {
            "1070010@1,2,3,4,5@N": {
              "name": "1) Court Complex-1"
            }
          }
        },
        "11": {
          "name": "East Singhbhum at Jamshedpur",
          "courtComplexes": {
            "1070011@1,2,3,4,5,6,7,8,9,10@Y": {
              "name": "1) District Civil Court Complex-1"
            }
          }
        },
        "12": {
          "name": "Jamtara",
          "courtComplexes": {
            "1070012@1,2,3,4@N": {
              "name": "1) District Court Complex-1"
            }
          }
        },
        "13": {
          "name": "Chatra",
          "courtComplexes": {
            "1070013@1,2,3,4@N": {
              "name": "1) Court Complex-1"
            }
          }
        },
        "14": {
          "name": "Pakur",
          "courtComplexes": {
            "1070014@1,2,3,4@N": {
              "name": "1) D.J. Court Building Complex-1"
            }
          }
        },
        "15": {
          "name": "Seraikella",
          "courtComplexes": {
            "1070015@1,2,3,4,5@N": {
              "name": "1)District Court Complex-1"
            }
          }
        },
        "16": {
          "name": "Deoghar",
          "courtComplexes": {
            "1070016@1,2,3,4,5,6,7@Y": {
              "name": "1) Old Building Comlplex-1"
            }
          }
        },
        "17": {
          "name": "Daltonganj",
          "courtComplexes": {
            "1070017@1,2,3,4,5@N": {
              "name": "1) District Court Complex-1"
            }
          }
        },
        "18": {
          "name": "Simdega",
          "courtComplexes": {
            "1070018@1,2,3,4@N": {
              "name": "1) Court Complex-1"
            }
          }
        },
        "19": {
          "name": "Latehar",
          "courtComplexes": {
            "1070019@1,2,3,4,5@N": {
              "name": "1) District & Sessions Judge's Building Complex-1"
            }
          }
        },
        "20": {
          "name": "Garhwa",
          "courtComplexes": {
            "1070020@1,2,3,4,5,6,7,8,9@Y": {
              "name": "1)  District Judges Court Complex-1"
            }
          }
        },
        "21": {
          "name": "Sahibganj",
          "courtComplexes": {
            "1070021@1,2,3,4,5,6,7,8@Y": {
              "name": "1) District Court Complex-1"
            }
          }
        },
        "22": {
          "name": "Ranchi",
          "courtComplexes": {
            "1070022@1,2,3,4,5@N": {
              "name": "1) Main Building"
            }
          }
        },
        "23": {
          "name": "RAMGARH",
          "courtComplexes": {
            "1070023@1,2,3,4,5@Y": {
              "name": "CIVIL COURT RAMGARH"
            }
          }
        },
        "24": {
          "name": "KHUNTI",
          "courtComplexes": {
            "1070024@1,2,3,4@Y": {
              "name": "KHUNTI CIVIL COURT"
            }
          }
        }
      }
    },
    "8": {
      "name": "Bihar",
      "districts": {
        "1": {
          "name": "Patna",
          "courtComplexes": {
            "1080004@8,9,10,19@Y": {
              "name": "Civil Court, Patna City"
            },
            "1080005@11,12,13@Y": {
              "name": "Barh Court"
            },
            "1080006@16,17,18@Y": {
              "name": "Paliganj Sub Division"
            },
            "1080008@1,14,15@Y": {
              "name": "Masaurhi Court"
            },
            "1080009@5,6,7@Y": {
              "name": "Civil Court, Danapur"
            },
            "1080010@2,3,4@Y": {
              "name": "Civil Court, Patna Sadar"
            }
          }
        },
        "2": {
          "name": "Kaimur at Bhabhua",
          "courtComplexes": {
            "1080011@2,3,4,7@Y": {
              "name": "District Judge's Building"
            },
            "1080087@5,6@Y": {
              "name": "Mohaniya"
            }
          }
        },
        "3": {
          "name": "Samastipur",
          "courtComplexes": {
            "1080012@5,6,7@N": {
              "name": "Civil Court, Dalsingsarai"
            },
            "1080013@8,9,10@N": {
              "name": "Civil Court, Rosera"
            },
            "1080014@11,12,13@Y": {
              "name": "Sahpur Patori Civil Court"
            },
            "1080015@2,3,4,14@Y": {
              "name": "Main Building, Samastipur"
            }
          }
        },
        "4": {
          "name": "Saran at Chapra",
          "courtComplexes": {
            "1080016@5,6,7@Y": {
              "name": "Sonepur Civil Court"
            },
            "1080017@2,3,4,8@Y": {
              "name": "Main Building, Saran"
            }
          }
        },
        "5": {
          "name": "Katihar",
          "courtComplexes": {
            "1080018@3,4,5,7@Y": {
              "name": "Civil Court Complex, Katihar"
            },
            "1080019@1,2,6@Y": {
              "name": "Barsoi Sub Division"
            }
          }
        },
        "6": {
          "name": "Begusarai",
          "courtComplexes": {
            "1080020@5,6,7@N": {
              "name": "Subordinate Court Manjhaul"
            },
            "1080021@1,8,9@N": {
              "name": "Bakhri Court"
            },
            "1080023@10,11,12@Y": {
              "name": "Balia Sub DIvision"
            },
            "1080024@2,3,4,15@Y": {
              "name": "DJ Building"
            },
            "1080025@13,14@N": {
              "name": "Teghra Sub Division"
            }
          }
        },
        "7": {
          "name": "Banka",
          "courtComplexes": {
            "1080026@2,3,4,8@Y": {
              "name": "Civil Court Complex, Banka"
            }
          }
        },
        "9": {
          "name": "Purnea",
          "courtComplexes": {
            "1080027@8,9@N": {
              "name": "Banmankhi Court"
            },
            "1080028@6,7@N": {
              "name": "Dhamdaha Sub Division"
            },
            "1080029@1,5@N": {
              "name": "Baisi Sub Division"
            },
            "1080030@2,3,4,10@Y": {
              "name": "Civil Court Purnea"
            }
          }
        },
        "10": {
          "name": "Motihari",
          "courtComplexes": {
            "1080031@5,6@Y": {
              "name": "Areraj Sub Division"
            },
            "1080032@1,2,3,9@Y": {
              "name": "Civil Court Complex, Motihari"
            },
            "1080033@4,7@Y": {
              "name": "Sikrahna Sub Division"
            }
          }
        },
        "11": {
          "name": "Munger",
          "courtComplexes": {
            "1080034@1,2,3,4@Y": {
              "name": "Civil Court Munger"
            }
          }
        },
        "12": {
          "name": "Madhepura",
          "courtComplexes": {
            "1080035@2,3,4,7@Y": {
              "name": "Civil Court, Madhepura"
            },
            "1080036@1,5,6@Y": {
              "name": "Uda Kishunganj  Court"
            }
          }
        },
        "13": {
          "name": "Rohtas Sasaram",
          "courtComplexes": {
            "1080037@1,3,4,10@Y": {
              "name": "Main Building, Rohtas"
            },
            "1080039@2,8,9@N": {
              "name": "Dehri Court"
            },
            "1080040@5,6,7@Y": {
              "name": "Main Building, Bikramganj"
            }
          }
        },
        "14": {
          "name": "Khagaria",
          "courtComplexes": {
            "1080041@4,5,6@Y": {
              "name": "Gogri Sub Division"
            },
            "1080042@1,2,3,7@Y": {
              "name": "Civil Court, Khagaria"
            }
          }
        },
        "15": {
          "name": "Jamui",
          "courtComplexes": {
            "1080043@3,4,5,6@Y": {
              "name": "Civil Court Complex, Jamui"
            }
          }
        },
        "16": {
          "name": "Aurangabad",
          "courtComplexes": {
            "1080044@4,5@Y": {
              "name": "Sub divisional judicial court, Daudnagar"
            },
            "1080045@1,2,3,6@Y": {
              "name": "Civil Court Complex, Aurangabad"
            }
          }
        },
        "17": {
          "name": "Darbhanga",
          "courtComplexes": {
            "1080046@2,3,4,11@Y": {
              "name": "Civil Court Darbhanga"
            },
            "1080047@8,9,10@N": {
              "name": "Biraul Court"
            },
            "1080048@5,6,7@N": {
              "name": "Civil Court, Benipur"
            }
          }
        },
        "18": {
          "name": "Madhubani",
          "courtComplexes": {
            "1080049@1,5,6,10@Y": {
              "name": "Civil Court Jhanjharpur"
            },
            "1080050@7,8,9@Y": {
              "name": "Benipatti Court"
            },
            "1080051@2,3,4,11@Y": {
              "name": "Civil Court Madhubani (Server Room 1)"
            }
          }
        },
        "19": {
          "name": "Lakhisarai",
          "courtComplexes": {
            "1080052@1,2,3,4@Y": {
              "name": "Civil Court Lakhisarai"
            }
          }
        },
        "20": {
          "name": "Sheikhpura",
          "courtComplexes": {
            "1080054@1,2,3,4@Y": {
              "name": "Sheikhpura Civil Court"
            }
          }
        },
        "21": {
          "name": "Saharsa",
          "courtComplexes": {
            "1080055@2,3,4,5,6@Y": {
              "name": "Civil Court, Saharsa"
            }
          }
        },
        "22": {
          "name": "Supaul",
          "courtComplexes": {
            "1080056@2,3,4,7@Y": {
              "name": "Supaul Civil Court"
            },
            "1080057@1,5,6@Y": {
              "name": "Birpur Court"
            }
          }
        },
        "23": {
          "name": "Gopalganj",
          "courtComplexes": {
            "1080059@2,3,4,5@Y": {
              "name": "Civil Court, Gopalganj"
            },
            "1080089@6,7@Y": {
              "name": "Hathua Civil Court"
            }
          }
        },
        "24": {
          "name": "Araria",
          "courtComplexes": {
            "1080060@1,2,3,4@Y": {
              "name": "Civil Court, Araria"
            }
          }
        },
        "25": {
          "name": "Kishanganj",
          "courtComplexes": {
            "1080061@1,2,3,4@Y": {
              "name": "Civil Court, Kishanganj"
            }
          }
        },
        "26": {
          "name": "Buxar",
          "courtComplexes": {
            "1080062@1,2,3,5@Y": {
              "name": "Civil court complex, Buxar"
            },
            "1080063@4@Y": {
              "name": "Dumraon Sub Division"
            }
          }
        },
        "27": {
          "name": "Nawada",
          "courtComplexes": {
            "1080064@1,2,3,4@Y": {
              "name": "Main Complex, Nawadah"
            }
          }
        },
        "28": {
          "name": "Bettiah",
          "courtComplexes": {
            "1080065@1,2,3,6@Y": {
              "name": "Civil Court, Bettiah"
            },
            "1080066@4@N": {
              "name": "Civil Court, Bagha"
            },
            "1080067@5@N": {
              "name": "Narkatiaganj Sub Division"
            }
          }
        },
        "29": {
          "name": "Siwan",
          "courtComplexes": {
            "1080068@1,2,3,4@Y": {
              "name": "Civil Court, Siwan"
            },
            "1370057@5@Y": {
              "name": "Maharajganj"
            }
          }
        },
        "30": {
          "name": "Nalanda",
          "courtComplexes": {
            "1080069@1,2,3,8@Y": {
              "name": "Civil Court, Hilsa"
            },
            "1080070@4,5,6,7,9@Y": {
              "name": "Nalanda Civil Court"
            }
          }
        },
        "31": {
          "name": "Sitamarhi",
          "courtComplexes": {
            "1080071@1,2,3,7@Y": {
              "name": "New building, Sitamarhi"
            },
            "1080072@4,5,6@Y": {
              "name": "Pupri Sub Division"
            }
          }
        },
        "33": {
          "name": "Bhojpur",
          "courtComplexes": {
            "1080073@4@N": {
              "name": "Piro Court"
            },
            "1080074@1,2,3,6@Y": {
              "name": "Bhojpur Civil Court"
            },
            "1080075@5@N": {
              "name": "Jagdishpur Court"
            }
          }
        },
        "34": {
          "name": "Bhagalpur",
          "courtComplexes": {
            "1080076@4,5,6,7,12@Y": {
              "name": "Bhagalpur Civil Court"
            },
            "1080077@8,9,10@N": {
              "name": "Khalgaon Civil Court"
            },
            "1080078@1,2,3@N": {
              "name": "Civil Court Complex, Naugachia"
            }
          }
        },
        "35": {
          "name": "Gaya",
          "courtComplexes": {
            "1080079@1,2,3,7@Y": {
              "name": "Gaya Civil Court"
            },
            "1080080@4,5,6@Y": {
              "name": "Subordinate Court, Sherghati"
            }
          }
        },
        "36": {
          "name": "Jehanabad",
          "courtComplexes": {
            "1080081@1,2,3,7@Y": {
              "name": "Jehanabad Civil Court"
            },
            "1080082@4,5,6@Y": {
              "name": "Civil Court Arwal"
            }
          }
        },
        "37": {
          "name": "Sheohar",
          "courtComplexes": {
            "1080083@1,2,3,4,5@Y": {
              "name": "Sheohar Civil Court"
            }
          }
        },
        "38": {
          "name": "Muzaffarpur",
          "courtComplexes": {
            "1080084@1,2,3,4,8@Y": {
              "name": "Muzaffarpur Civil Court"
            },
            "1080085@5,6,7@N": {
              "name": "West Civil Court"
            }
          }
        },
        "39": {
          "name": "Vaishali",
          "courtComplexes": {
            "1080086@1,2,3,4,5@Y": {
              "name": "Civil Court Vaishali"
            }
          }
        },
        "86": {
          "name": "ARWAL",
          "courtComplexes": {

          }
        }
      }
    },
    "9": {
      "name": "Rajasthan",
      "districts": {
        "1": {
          "name": "Rajsamand",
          "courtComplexes": {
            "1090002@33@N": {
              "name": "Family Court Complex Rajsamand"
            },
            "1090003@34@N": {
              "name": "JJB Court Complex Rajsamand"
            },
            "1090004@22,23@N": {
              "name": "Bhim Court Complex"
            },
            "1090005@24,25@N": {
              "name": "Kumbhalgarh Court Complex"
            },
            "1090006@26,27,28,29@N": {
              "name": "Nathdwara Court Complex"
            },
            "1090007@16,17,35@N": {
              "name": "Railmagra Court Complex"
            },
            "1090008@11,12,13,14,15,32,36@N": {
              "name": "Rajsamand Court Complex"
            },
            "1090009@30,31@N": {
              "name": "Deogarh Court Complex"
            },
            "1090010@18,19@N": {
              "name": "Amet Court Complex"
            }
          }
        },
        "2": {
          "name": "Alwar",
          "courtComplexes": {
            "1090011@58,59@N": {
              "name": "Neemrana Court Complex"
            },
            "1090012@38,39,40,41@N": {
              "name": "Kishangarh Bas Court Complex"
            },
            "1090013@60@N": {
              "name": "JJB Court Complex Alwar"
            },
            "1090014@36,37,65,72@N": {
              "name": "Thangazi Court Complex"
            },
            "1090015@26,27,28,29@N": {
              "name": "Behror Court Complex"
            },
            "1090016@42,43,50,66@N": {
              "name": "Bansur Court Complex"
            },
            "1090017@62,63@N": {
              "name": "Kherli Mandi Court Complex"
            },
            "1090018@54,55,68,71@N": {
              "name": "Bhiwadi Court Complex"
            },
            "1090019@49,51@N": {
              "name": "Malakhera Court Complex"
            },
            "1090020@20,21,22,23@N": {
              "name": "Laxmangarh Court Complex"
            },
            "1090021@56,57@N": {
              "name": "Kotkasim Court Complex"
            },
            "1090022@34,35,61,70@N": {
              "name": "Mundawar Court Complex"
            },
            "1090023@24,25,67@N": {
              "name": "Kathumar Court Complex"
            },
            "1090024@44,45,46,47@N": {
              "name": "Rajgarh Court Complex"
            },
            "1090025@11,12,13,14,15,16,17,18,19,48,64@N": {
              "name": "Alwar Court Complex"
            },
            "1090026@30,31,32,33@N": {
              "name": "Tijara Court Complex"
            },
            "1090027@52,53,69@N": {
              "name": "Ramgarh Court Complex"
            }
          }
        },
        "3": {
          "name": "Dausa",
          "courtComplexes": {
            "1090028@21,22,23,24@N": {
              "name": "Mahwa Court Complex"
            },
            "1090029@25@N": {
              "name": "JJB Court Complex"
            },
            "1090030@9,10,11,27@Y": {
              "name": "Sikrai Court Complex"
            },
            "1090031@12,13,14,15@N": {
              "name": "Bandikui Court Complex"
            },
            "1090032@4,5,6,7,8,20,26@N": {
              "name": "Dausa District Court \nComplex"
            },
            "1090033@16,17,18,19@N": {
              "name": "Lalsot Court Complex"
            }
          }
        },
        "4": {
          "name": "Jaipur Metro I",
          "courtComplexes": {
            "1090034@53,54,55,56@N": {
              "name": "Sanganer Court Complex"
            },
            "1090035@38@N": {
              "name": "Jaipur Waqf Board Court Complex"
            },
            "1090036@46,47,57,59@N": {
              "name": "Chaksu court Complex"
            },
            "1090037@31@N": {
              "name": "Jaipur Nagar Nigam Court Complex"
            },
            "1090038@28,29,30@N": {
              "name": "Mini Sectt. Complex"
            },
            "1090039@37@N": {
              "name": "Family Court Complex Jaipur"
            },
            "1090040@32,33,34,58@N": {
              "name": "Bassi Court Complex"
            },
            "1090041@48@N": {
              "name": "JJB Court Complex"
            },
            "1090042@14,15,16,17,18,19,20,21,22,23,40,41,42@N": {
              "name": "JAIPUR METRO COURT COMPLEX I"
            }
          }
        },
        "5": {
          "name": "Tonk",
          "courtComplexes": {
            "1090043@7,8,9,10,11,12,28,38@N": {
              "name": "Tonk District Court Complex"
            },
            "1090044@31@N": {
              "name": "Family Court Complex Tonk"
            },
            "1090045@32@N": {
              "name": "JJB Court Complex Tonk"
            },
            "1090046@21,22,23,37@N": {
              "name": "Uniara Court Complex"
            },
            "1090047@24,25@N": {
              "name": "Deoli Court Complex"
            },
            "1090048@14,15,16,17@N": {
              "name": "Malpura Court Complex"
            },
            "1090049@18,19,20,33@N": {
              "name": "Niwai Court Complex"
            },
            "1090050@26,27,34@N": {
              "name": "Todaraisingh Court Complex"
            },
            "1090051@29,30@N": {
              "name": "Dooni Court Complex"
            },
            "1090328@35,36@N": {
              "name": "Peeplu Court Complex"
            }
          }
        },
        "6": {
          "name": "Bikaner",
          "courtComplexes": {
            "1090052@14@N": {
              "name": "Bikaner Rly Court  Complex"
            },
            "1090053@15,16,29@N": {
              "name": "Kolayat Court Complex"
            },
            "1090054@19,20,28@N": {
              "name": "Sridungargarh Court Complex"
            },
            "1090055@17,18,31,33@N": {
              "name": "Nokha Court Complex"
            },
            "1090056@8,9,10,11,12,13,25,27,32@N": {
              "name": "Bikaner District Court Complex"
            },
            "1090057@21,22@N": {
              "name": "Loonkaransar Court Complex"
            },
            "1090058@26@N": {
              "name": "JJB Court Complex Bikaner"
            },
            "1090059@23,24,30,34@N": {
              "name": "Khajuwala Court Complex"
            }
          }
        },
        "7": {
          "name": "Ganganagar",
          "courtComplexes": {
            "1090060@20,42,43,50@N": {
              "name": "Sadulshahar Court Complex"
            },
            "1090061@11,12,13,14,15,16,48,51,54@N": {
              "name": "Sriganganagar District Court Complex"
            },
            "1090062@32,33,34,35@N": {
              "name": "Anupgarh Court Complex"
            },
            "1090063@30,31,47,52@N": {
              "name": "Gharsana Court Complex"
            },
            "1090064@23,24,25,53@N": {
              "name": "Karanpur Court Complex"
            },
            "1090065@44,45@N": {
              "name": "Padampur Court Complex"
            },
            "1090066@17,18,46,49@N": {
              "name": "Sriganganagar Labour Court Premises"
            },
            "1090067@36,37@N": {
              "name": "Vijaynagar Court Complex"
            },
            "1090068@38,39,40,41@N": {
              "name": "Suratgarh Court Complex"
            },
            "1090069@26,27,28,29@N": {
              "name": "Raisinghnagar Court Complex"
            }
          }
        },
        "8": {
          "name": "Merta Nagaur",
          "courtComplexes": {
            "1090070@26,27,28,29@N": {
              "name": "Didwana Court Complex"
            },
            "1090071@35,36@N": {
              "name": "Nawa Court Complex"
            },
            "1090072@30,31,46@N": {
              "name": "Ladnun Court Complex"
            },
            "1090073@22,23@N": {
              "name": "Degana Court Complex"
            },
            "1090074@24,25,48@N": {
              "name": "Jayal Court Complex"
            },
            "1090075@18,19,20,21,43,47@N": {
              "name": "Nagaur Court Complex"
            },
            "1090076@39,40,41@N": {
              "name": "Parbatsar Court Complex"
            },
            "1090077@37,38,45@N": {
              "name": "Kuchamancity Court Complex"
            },
            "1090078@11,12,13,14,15,16,17,42@N": {
              "name": "Mertacity District Court Complex"
            },
            "1090079@32,33,34,44@N": {
              "name": "Makrana Court Complex"
            }
          }
        },
        "9": {
          "name": "Udaipur",
          "courtComplexes": {
            "1090080@51@N": {
              "name": "JJB Court Complex"
            },
            "1090081@12,13,14,15,16,17,18,19,20,21,22,49,50@N": {
              "name": "Udaipur District Court Complex"
            },
            "1090082@38,39@N": {
              "name": "Bhindar Court Complex"
            },
            "1090083@28,29@N": {
              "name": "Sarada Court Complex"
            },
            "1090084@34,35@N": {
              "name": "Vallabhnagar Court Complex"
            },
            "1090085@25,26,27,55@N": {
              "name": "Salumbar Court Complex"
            },
            "1090086@30,31,32,33,54@N": {
              "name": "Mavli Court Complex"
            },
            "1090087@40,41,42,43,48@N": {
              "name": "Kherwara Court Complex"
            },
            "1090088@44,45@N": {
              "name": "Jhadol Court Complex"
            },
            "1090089@23,24,52,53@N": {
              "name": "Gogunda Court Complex"
            },
            "1090090@36,37@N": {
              "name": "KaNore Court Complex"
            },
            "1090091@46,47@N": {
              "name": "Kotra Court Complex"
            }
          }
        },
        "10": {
          "name": "Bundi",
          "courtComplexes": {
            "1090092@13,14,15,30@N": {
              "name": "Keshorapatan Court Complex"
            },
            "1090093@5,6,7,8,9,10,25@N": {
              "name": "Bundi Court Complex"
            },
            "1090094@23,24@N": {
              "name": "Indergarh Court Complex"
            },
            "1090095@11,12@N": {
              "name": "Talera Court Complex"
            },
            "1090096@27@N": {
              "name": "JJB Court Complex Bundi"
            },
            "1090097@19,20@N": {
              "name": "Lakheri Court Complex"
            },
            "1090098@16,17,18,28@N": {
              "name": "Nainwa Court Complex"
            },
            "1090099@26@N": {
              "name": "Family Court Complex Bundi"
            },
            "1090100@21,22,29@N": {
              "name": "Hindoli Court Complex"
            }
          }
        },
        "11": {
          "name": "Hanumangarh",
          "courtComplexes": {
            "1090101@11,12,33,34@N": {
              "name": "Rawatsar Court Complex"
            },
            "1090102@2,3,5,6,7,8,26,29@N": {
              "name": "Hanumangarh District Court Complex"
            },
            "1090103@16,17,31@N": {
              "name": "Pilibanga Court Complex"
            },
            "1090104@27,28@N": {
              "name": "Gram Nyayalaya Hanumangarh Court Co"
            },
            "1090105@13,14,15,32@N": {
              "name": "Sangaria Court Complex"
            },
            "1090106@9,10@N": {
              "name": "Tibbi Court Complex"
            },
            "1090107@22,23,24,25@N": {
              "name": "Nohar Court Complex"
            },
            "1090108@30@N": {
              "name": "JJB Court Complex Hanumangarh"
            },
            "1090109@18,19,20,21@N": {
              "name": "Bhadra Court Complex"
            }
          }
        },
        "12": {
          "name": "Baran",
          "courtComplexes": {
            "1090110@29@N": {
              "name": "JJB Court Complex"
            },
            "1090111@17,18@N": {
              "name": "Shahbad Court Complex"
            },
            "1090112@15,16@N": {
              "name": "Kishanganj Court Complex"
            },
            "1090113@8,9,10,11,12,28,32@N": {
              "name": "Baran Court Complex"
            },
            "1090114@25,26,27@N": {
              "name": "Chhabra Court Complex"
            },
            "1090115@23,24@N": {
              "name": "Anta Court Complex"
            },
            "1090116@19,20@N": {
              "name": "Chhipabarod Court Complex"
            },
            "1090117@13,14@N": {
              "name": "Mangrol Court Complex"
            },
            "1090118@21,22,31@N": {
              "name": "Atru Court Complex"
            },
            "1090336@30@N": {
              "name": "Family Court Complex Baran"
            }
          }
        },
        "13": {
          "name": "Bharatpur",
          "courtComplexes": {
            "1090119@34@N": {
              "name": "JJB Court Complex"
            },
            "1090120@23,24,42,43@N": {
              "name": "COURT COMPLEX, KAMAN"
            },
            "1090121@9,10,11,12@N": {
              "name": "Bayana ADJ Court Complex"
            },
            "1090122@19,20,25,44@N": {
              "name": "Weir Court Complex"
            },
            "1090123@30,31,45,50@N": {
              "name": "COURT COMPLEX, NAGAR"
            },
            "1090124@21,22@N": {
              "name": "Roopbas Court Complex"
            },
            "1090125@18@N": {
              "name": "COLLECTORATE CAMPUS, BHARATPUR"
            },
            "1090126@35,36,48@N": {
              "name": "Kumher Court Complex"
            },
            "1090127@33@N": {
              "name": "Bharatpur Railway Court Complex"
            },
            "1090128@40,41@N": {
              "name": "Bhusawar Court Complex"
            },
            "1090129@37,38@N": {
              "name": "Gram Nyayalaya Roopwas Court Comple"
            },
            "1090130@26,27,28,29@N": {
              "name": "Deeg Court Complex"
            },
            "1090131@13,14,15,16,17,32,39,49@N": {
              "name": "Bharatpur Court Complex"
            },
            "1090132@7,8,53@N": {
              "name": "TEHSIL COMPLEX, NADBAI"
            },
            "1090330@46,47@N": {
              "name": "Ucchain Court Complex"
            },
            "1090340@51,52@N": {
              "name": "Sikri Court Complex"
            }
          }
        },
        "14": {
          "name": "Ajmer",
          "courtComplexes": {
            "1090133@31,32,33,34,35,43@N": {
              "name": "Old R.P.S.C. Building Ajmer"
            },
            "1090134@47,48@N": {
              "name": "Gram Nyayalay Pisangan CourtComplex"
            },
            "1090135@20,21,22,23@N": {
              "name": "Kekri Court Complex"
            },
            "1090136@26@N": {
              "name": "Ajmer Railway Court Complex"
            },
            "1090137@9,10,11,12,13,18,19,44,45,46@N": {
              "name": "Ajmer District Court Complex"
            },
            "1090138@39,40@N": {
              "name": "Sarwar Court Complex"
            },
            "1090139@24,25,50@N": {
              "name": "Pushkar Court Complex"
            },
            "1090140@36,37,38,49@N": {
              "name": "Nasirabad Court Complex"
            },
            "1090141@41,42@N": {
              "name": "Bijay Nagar Court Compex"
            },
            "1090142@14,15,16,17@N": {
              "name": "Beawar Court Complex"
            },
            "1090143@27,28,29,30@N": {
              "name": "Kishangarh Court Complex"
            }
          }
        },
        "18": {
          "name": "Jhunjhunu",
          "courtComplexes": {
            "1090145@25@N": {
              "name": "Buhana Court Complex"
            },
            "1090146@27@N": {
              "name": "JJB Court Complex Jhunjhunu"
            },
            "1090147@7,8,19,30@N": {
              "name": "Chirawa Court Complex"
            },
            "1090148@2,3,4,5,6,23,24,26,31@N": {
              "name": "Jhunjhunu District Court Complex"
            },
            "1090149@17,18,22@N": {
              "name": "Pilani Court Complex"
            },
            "1090150@11,12,21@N": {
              "name": "Nawalgarh Court Complex"
            },
            "1090151@9,10,20@N": {
              "name": "Udaipurwati Court Complex"
            },
            "1090152@13,14,15,16@N": {
              "name": "Khetri Court Complex"
            },
            "1090323@28,29@N": {
              "name": "Surajgarh Court Complex"
            }
          }
        },
        "19": {
          "name": "Pali",
          "courtComplexes": {
            "1090153@9,10,11,12,29,30,31,38,39,42@N": {
              "name": "Pali District Court Complex"
            },
            "1090154@44@Y": {
              "name": "JJB Court Complex Pali"
            },
            "1090155@17,18,19,20@N": {
              "name": "Sumerpur Court Complex"
            },
            "1090156@40@N": {
              "name": "Raipur Court Complex"
            },
            "1090157@41,43@N": {
              "name": "Sadri Court Complex"
            },
            "1090158@21,22,23,24@N": {
              "name": "Bali Court Complex"
            },
            "1090159@27,28@N": {
              "name": "Bar Court Complex"
            },
            "1090160@25,26,45@N": {
              "name": "Desuri Court Complex"
            },
            "1090161@13,14,15,16@N": {
              "name": "Sojat Court Complex"
            },
            "1090162@34,35,36,37@N": {
              "name": "Jaitaran Court Complex"
            },
            "1090163@32,33,48@N": {
              "name": "Marwar Jn. Court Complex"
            },
            "1090325@46,47@N": {
              "name": "Rani Court Complex"
            }
          }
        },
        "20": {
          "name": "Kota",
          "courtComplexes": {
            "1090165@31,32@N": {
              "name": "Itawa Court Complex"
            },
            "1090166@35,36,39@N": {
              "name": "Sangod Court Complex"
            },
            "1090167@19,20@N": {
              "name": "Kanwas Court Complex"
            },
            "1090168@8,9,10,11,12,13,14,15,16,17,18,33,34@N": {
              "name": "Kota District Court Complex"
            },
            "1090169@22@N": {
              "name": "Kota MACT Court Complex"
            },
            "1090170@37@N": {
              "name": "JJB Court Complex"
            },
            "1090171@27,28,29,30@N": {
              "name": "Ramganjmandi Court Complex"
            },
            "1090172@25,26,38@N": {
              "name": "Digod Court Complex"
            },
            "1090173@21@N": {
              "name": "Family Court Complex Kota"
            },
            "1090174@23,24@N": {
              "name": "Kota Railway Court Complex"
            }
          }
        },
        "21": {
          "name": "Jalore",
          "courtComplexes": {
            "1090176@6,7,8,14@N": {
              "name": "Bhinmal Court Complex"
            },
            "1090177@9,10,13,18@N": {
              "name": "Sanchore Court Complex"
            },
            "1090178@11,12@N": {
              "name": "Raniwara Court Complex"
            },
            "1090179@2,3,4,5,15,16,17@N": {
              "name": "Jalore District Court Complex"
            },
            "1090338@19,20@N": {
              "name": "AHORE Court Complex"
            }
          }
        },
        "22": {
          "name": "Jhalawar",
          "courtComplexes": {
            "1090180@31,32@N": {
              "name": "Manoharthana Court Complex"
            },
            "1090181@15,16@N": {
              "name": "Khanpur Court Complex"
            },
            "1090182@17,18,19,20@N": {
              "name": "Aklera Court Complex"
            },
            "1090183@27,28@N": {
              "name": "Choumehla Court Complex"
            },
            "1090184@7,8,9,10,11,12,29,30,36@N": {
              "name": "Jhalawar District Court Complex"
            },
            "1090185@23,24,25,26@N": {
              "name": "Bhawani Mandi Court Complex"
            },
            "1090186@21,22@N": {
              "name": "Pirawa Court Complex"
            },
            "1090187@33,34,35@N": {
              "name": "Jhalarapatan Court Complex"
            }
          }
        },
        "23": {
          "name": "Pratapgarh",
          "courtComplexes": {
            "1090188@3,4,5,6,7,8,13,14,15,20@N": {
              "name": "Pratapgarh District Court Complex"
            },
            "1090189@9,10@N": {
              "name": "Dhariyawad Court Complex"
            },
            "1090190@16@N": {
              "name": "JJB Pratapgarh District HQ"
            },
            "1090191@11,12,19@N": {
              "name": "Chhoti Sadri Court Complex"
            },
            "1090322@17,18@N": {
              "name": "Arnod Court Complex"
            }
          }
        },
        "24": {
          "name": "Dungarpur",
          "courtComplexes": {
            "1090192@15,16@N": {
              "name": "Simalwara Court Complex"
            },
            "1090193@20,21@N": {
              "name": "Gram Nyayalaya Bichhiwara Complex"
            },
            "1090194@19@N": {
              "name": "JJB Court Complex Dungarpur"
            },
            "1090195@11,12@N": {
              "name": "Aaspur Court Complex"
            },
            "1090196@13,14,18@N": {
              "name": "Sagwara Court Complex"
            },
            "1090197@5,6,7,8,9,10,17@N": {
              "name": "Dungarpur Court Complex"
            }
          }
        },
        "25": {
          "name": "Banswara",
          "courtComplexes": {
            "1090199@16,17,27@N": {
              "name": "Bagidora Court Complex"
            },
            "1090200@14,15@N": {
              "name": "Ghatol Court Complex"
            },
            "1090201@23@N": {
              "name": "JJB Court Complex Banswara"
            },
            "1090202@6,7,8,9,10,11,20@N": {
              "name": "Banswara Court Complex"
            },
            "1090203@12,13@N": {
              "name": "Garhi Court Complex"
            },
            "1090204@18,19,24@N": {
              "name": "Kushalgarh Court Complex"
            },
            "1090205@21,22@N": {
              "name": "Gram Nyayalaya Talwara Court Comple"
            },
            "1090331@25,26@N": {
              "name": "Aanandpuri Court Complex"
            }
          }
        },
        "26": {
          "name": "Sirohi",
          "courtComplexes": {
            "1090206@17,18@N": {
              "name": "Reodar Court Complex"
            },
            "1090207@15,16@N": {
              "name": "Mt. Abu Court Complex"
            },
            "1090208@7,8,9,10,11,25,26,27@N": {
              "name": "Sirohi District Court Complex"
            },
            "1090209@23,24@N": {
              "name": "Sheoganj Court Complex"
            },
            "1090210@12,13,14,29@N": {
              "name": "Abu Road Court Complex"
            },
            "1090211@19,20,28@N": {
              "name": "Pindwara Court Complex"
            }
          }
        },
        "27": {
          "name": "BARMER",
          "courtComplexes": {
            "1090212@4,5,6,7,15,22@N": {
              "name": "Balotra Court Complex"
            },
            "1090213@8,9,10,11,12,16,17@N": {
              "name": "Barmer Court Complex"
            },
            "1090214@13,14@N": {
              "name": "Siwana Court Complex"
            },
            "1090215@20,21,26@N": {
              "name": "Chouthan Court Complex"
            },
            "1090216@18,19@N": {
              "name": "Pachpadra Court Complex"
            },
            "1090324@23,24,25@N": {
              "name": "Gudamalani Court Complex"
            }
          }
        },
        "28": {
          "name": "Jodhpur Metro",
          "courtComplexes": {
            "1090217@21@N": {
              "name": "Labour Court Complex Jodhpur Metro"
            },
            "1090218@25@N": {
              "name": "JJB Court Complex Jodhpur Metro"
            },
            "1090219@26,27@N": {
              "name": "Mandore Court Complex Jodhpur Metro"
            },
            "1090220@24@N": {
              "name": "Family Court Complex Jodhpur Metro"
            },
            "1090221@20@N": {
              "name": "Railway Court Complex Jodhpur Metro"
            },
            "1090222@10,11,12,13,14,15,16,17,18,19,22,23@N": {
              "name": "Jodhpur Metro Court Complex"
            }
          }
        },
        "29": {
          "name": "Karauli",
          "courtComplexes": {
            "1090223@22,23@N": {
              "name": "Sapotra Court Complex"
            },
            "1090224@21@N": {
              "name": "JJB Court Complex Karauli"
            },
            "1090225@20@N": {
              "name": "MACT Court Complex Karauli"
            },
            "1090226@14,15@N": {
              "name": "Srimahaveerji Court Complex"
            },
            "1090227@5,6,7,8,9,18,19@N": {
              "name": "Karauli District Court Complex"
            },
            "1090228@16,17,24@N": {
              "name": "Todabhim Court Complex"
            },
            "1090229@10,11,12,13@N": {
              "name": "Hindauncity Court Complex"
            },
            "1090332@25,26@N": {
              "name": "Nadauti Court Complex"
            }
          }
        },
        "30": {
          "name": "Chittorgarh",
          "courtComplexes": {
            "1090230@6,7,8,9,10,11,12,38,45@N": {
              "name": "Chittorgarh District Court Complex"
            },
            "1090231@16,17@N": {
              "name": "Mandphiya Court Complex"
            },
            "1090232@18,19,20,21@N": {
              "name": "Nimbahera Court Complex"
            },
            "1090233@35,37@N": {
              "name": "Rawatbhata Court Complex"
            },
            "1090234@27,28,36@N": {
              "name": "Bari Sadri Court Complex"
            },
            "1090235@22,23@N": {
              "name": "Rashmi Court Complex"
            },
            "1090236@13,14,15,43@N": {
              "name": "Kapasan Court Complex"
            },
            "1090237@39,40@N": {
              "name": "Bhadesar Court Complex"
            },
            "1090238@33,34@N": {
              "name": "Gangrar Court Complex"
            },
            "1090239@31,32@N": {
              "name": "Dungla Court Complex"
            },
            "1090240@24,25,26,42@N": {
              "name": "Begu Court Complex"
            },
            "1090241@41@N": {
              "name": "JJB Court Complex Chittorgarh"
            },
            "1370073@27,28,36,44@N": {
              "name": "Badisadri court complex"
            }
          }
        },
        "31": {
          "name": "Bhilwara",
          "courtComplexes": {
            "1090242@43,44@N": {
              "name": "Gram Nyayalaya Suwana Court Complex"
            },
            "1090243@17@N": {
              "name": "Labour Court Complex"
            },
            "1090244@46,47@N": {
              "name": "Gram Nyayalaya Mandal Court Complex"
            },
            "1090245@22,23,24@N": {
              "name": "Mandal Court Complex"
            },
            "1090246@45@N": {
              "name": "JJB Court Complex Bhilwara"
            },
            "1090247@29,30,31,49@N": {
              "name": "Gangapur Court Complex"
            },
            "1090248@35,36@N": {
              "name": "Jahazpur Court Complex"
            },
            "1090249@37,38,39,40@N": {
              "name": "Shahpura Court Complex"
            },
            "1090250@32,33@N": {
              "name": "Gulabpura Court Complex"
            },
            "1090251@21@N": {
              "name": "Kotari Court Complex"
            },
            "1090252@25@N": {
              "name": "Asind Court Complex"
            },
            "1090253@26,27,28@N": {
              "name": "Mandalgarh Court Complex"
            },
            "1090254@34@N": {
              "name": "Bijolian Court Complex"
            },
            "1090255@11,12,13,14,15,16,18,19,20,41,42,48@N": {
              "name": "Bhilwara District Court Complex"
            },
            "1090327@50,51@N": {
              "name": "Raipur Court Complex"
            }
          }
        },
        "32": {
          "name": "Jaisalmer",
          "courtComplexes": {
            "1090257@4,5,6,9,10,11,17@N": {
              "name": "Jaisalmer District Court Complex"
            },
            "1090258@7,8,12@N": {
              "name": "Pokran Court Complex"
            },
            "1090260@16@N": {
              "name": "JJB Court Complex Jaisalmer"
            },
            "1090261@14,15@N": {
              "name": "Gram Nyayalya Sankra Court Complex"
            },
            "1370029@13@N": {
              "name": "POCSO COURT COMPLEX JAISALMER"
            }
          }
        },
        "33": {
          "name": "Churu",
          "courtComplexes": {
            "1090262@7,8,9,10@N": {
              "name": "Rajgarh Court Complex"
            },
            "1090263@22,23,24,25,26,27@N": {
              "name": "Churu District Court Complex"
            },
            "1090264@16,17,18,19@N": {
              "name": "Sujangarh Court Complex"
            },
            "1090265@29@N": {
              "name": "JJB Court Complex"
            },
            "1090266@11,12,13@N": {
              "name": "Ratangarh Court Complex"
            },
            "1090267@20,21,28,30@N": {
              "name": "Sardarshahar Court Complex"
            },
            "1090268@14,15,31@N": {
              "name": "Taranagar Court Complex"
            },
            "1090326@32,33@N": {
              "name": "Bidasar Court Complex"
            }
          }
        },
        "34": {
          "name": "Dholpur",
          "courtComplexes": {
            "1090269@12,13@N": {
              "name": "Baseri Court Complex"
            },
            "1090270@22,23@N": {
              "name": "Rajakhera Court Complex"
            },
            "1090271@15@N": {
              "name": "ADJ Bari Court Complex"
            },
            "1090272@2,3,4,5,6,16,17,18,19,20,21@N": {
              "name": "Dholpur District Court Complex"
            },
            "1090273@7,8,9@N": {
              "name": "Bari Court Complex"
            },
            "1090274@14@N": {
              "name": "JJB Court Complex Dholpur"
            },
            "1090329@24,25@N": {
              "name": "Saipau Court Complex"
            },
            "1090337@26,27@N": {
              "name": "Sarmathura Court Complex"
            }
          }
        },
        "35": {
          "name": "Sikar",
          "courtComplexes": {
            "1090275@17,28,29,40@N": {
              "name": "Laxmangarh Court Complex"
            },
            "1090276@1,36@N": {
              "name": "Gram Nyayalaya Kudli Court Complex"
            },
            "1090277@24,25,26,27@N": {
              "name": "Srimadhopur Court Complex"
            },
            "1090278@39@N": {
              "name": "JJB Court Complex Sikar"
            },
            "1090279@18,19,32,33@N": {
              "name": "Fatehpur Court Complex"
            },
            "1090280@30,31@N": {
              "name": "Reengus Court Complex"
            },
            "1090281@22,23,41@N": {
              "name": "Danta Court Complex"
            },
            "1090282@12,13,14,15@N": {
              "name": "Neemkathana Court Complex"
            },
            "1090283@8,9,10,11,34,35,38,46@N": {
              "name": "Sikar District Court Complex"
            },
            "1090321@42,43@N": {
              "name": "Khandela Court Complex"
            },
            "1090339@44,45@N": {
              "name": "DHOD Court Complex"
            }
          }
        },
        "36": {
          "name": "Sawai Madhopur",
          "courtComplexes": {
            "1090284@22,23,24@N": {
              "name": "Family court complex"
            },
            "1090285@11,12,13,14@N": {
              "name": "Gangapurcity Court Complex"
            },
            "1090286@6,7,8,9,10,17@N": {
              "name": "Sawaimadhopur District Court Complex"
            },
            "1090287@20,21@N": {
              "name": "Bonli Court Complex"
            },
            "1090288@15,16@N": {
              "name": "Khandar Court Complex"
            },
            "1090289@18,19@N": {
              "name": "Bamanwas Court Complex"
            },
            "1090290@25@N": {
              "name": "JJB court complex Sawaimadhopur"
            },
            "1090341@26,27@N": {
              "name": "JM  Chauth Ka Barwara"
            }
          }
        },
        "38": {
          "name": "Jaipur District",
          "courtComplexes": {
            "1090291@28,29,47@Y": {
              "name": "Phagi Court Complex"
            },
            "1090292@14,15,16,17@N": {
              "name": "Sambhar Court Complex"
            },
            "1090293@18,19,27,46@N": {
              "name": "Dudu Court Complex"
            },
            "1090294@34,35,36,37@N": {
              "name": "Kotputli Court Complex"
            },
            "1090295@24,25@N": {
              "name": "Virat Nagar Court Complex"
            },
            "1090296@30,31@N": {
              "name": "Jamwaramgarh Court Complex"
            },
            "1090297@9,10,11,12,13,26,45@N": {
              "name": "Jaipur District Court Complex"
            },
            "1090298@44@N": {
              "name": "JJB Court Complex Jaipur District"
            },
            "1090299@32,33@N": {
              "name": "Kishangarh Renwal Court Complex"
            },
            "1090300@42,43@N": {
              "name": "Gram Nayalaya Sambhar"
            },
            "1090301@20,21,22,23@N": {
              "name": "Shahpura Court Complex"
            },
            "1090302@38,39,40,41@N": {
              "name": "Chomu Court Complex"
            }
          }
        },
        "39": {
          "name": "Jodhpur District",
          "courtComplexes": {
            "1090303@19,20,24@N": {
              "name": "Piparcity Court Complex"
            },
            "1090304@14,15,16,23@N": {
              "name": "Phalodi Court Complex"
            },
            "1090305@1,2,21,22,25@N": {
              "name": "Jodhpur District Court Complex"
            },
            "1090306@12,13,27,35@N": {
              "name": "Balesar Court Complex"
            },
            "1090307@10,11,26,28@N": {
              "name": "Bilara Court Complex"
            },
            "1090308@17,18@N": {
              "name": "Osian Court Complex"
            },
            "1090333@29,30@N": {
              "name": "Lohawat Court Complex"
            },
            "1090334@31,32@N": {
              "name": "Bap Court Complex"
            },
            "1090335@33,34@N": {
              "name": "Bhopalgarh Court Complex"
            }
          }
        },
        "40": {
          "name": "Jaipur Metro II",
          "courtComplexes": {
            "1090309@1,2,3,4@N": {
              "name": "Chomu Court Complex Jaipur Metro"
            },
            "1090310@5@N": {
              "name": "Commercial Court Complex Jaipur Met"
            },
            "1090311@20,21,22,23@N": {
              "name": "Mini Sectt Jaipur Metro II"
            },
            "1090312@14,15@N": {
              "name": "JDA PREMISSES"
            },
            "1090313@6,7,8,9,10,11,12,13,24,25@N": {
              "name": "JAIPUR METRO COURT COMPLEX II"
            },
            "1090314@19@N": {
              "name": "Jaipur Railway Court Complex"
            },
            "1090315@16,17,18@N": {
              "name": "Amer Court Complex"
            }
          }
        },
        "106": {
          "name": "BEAWER",
          "courtComplexes": {

          }
        },
        "107": {
          "name": "BALOTRA",
          "courtComplexes": {

          }
        },
        "108": {
          "name": "DEEG",
          "courtComplexes": {

          }
        },
        "109": {
          "name": "KOTPUTLI BEHROR",
          "courtComplexes": {

          }
        },
        "110": {
          "name": "PHALODI",
          "courtComplexes": {

          }
        },
        "111": {
          "name": "SALUMBER",
          "courtComplexes": {

          }
        },
        "112": {
          "name": "DIDWANA KUCHAMAN",
          "courtComplexes": {

          }
        },
        "113": {
          "name": "KHAIRTAL TIJARA",
          "courtComplexes": {

          }
        }
      }
    },
    "10": {
      "name": "Tamil Nadu",
      "districts": {
        "1": {
          "name": "Dharmapuri",
          "courtComplexes": {
            "1100015@4@N": {
              "name": "Magistrate Court, Harur"
            },
            "1100016@6,7,8,9,12,13,14,15,16,17,21@N": {
              "name": "Combined Courts, Dharmapuri"
            },
            "1100017@19,20@N": {
              "name": "Sub Court, Harur"
            },
            "1100018@3,18@N": {
              "name": "DM and JM Courts, Pappireddipatti"
            },
            "1100019@2@N": {
              "name": "DM cum JM Court, Pennagaram"
            },
            "1100020@5,10,11@N": {
              "name": "Combined Courts, Palacode"
            },
            "1100391@22@N": {
              "name": "Sub Court, Pappireddipatty"
            },
            "1100396@23@N": {
              "name": "DM cum JM Court, Karimangalam"
            }
          }
        },
        "2": {
          "name": "Pudukkottai",
          "courtComplexes": {
            "1100021@9@N": {
              "name": "Magistrate Court, Keeranur"
            },
            "1100023@13,23@N": {
              "name": "Combined Courts, Thirumayam"
            },
            "1100024@14,19@N": {
              "name": "Munsif Court, Keeranur"
            },
            "1100026@2,5,6,7,8,15,16,17,18,20,25@N": {
              "name": "District Court Complex, Pudukkottai"
            },
            "1100027@10,11,12@N": {
              "name": "Combined Courts, Aranthangi"
            },
            "1100028@4@N": {
              "name": "DM cum JM Court, Alangudi"
            },
            "1100333@21@N": {
              "name": "DM cum JM Court, Illuppur"
            },
            "1100334@22@N": {
              "name": "DM cum JM Court, Gandarvakkottai"
            },
            "1100357@24@N": {
              "name": "DM cum JM Court, Ponnamaravathi"
            },
            "1370008@26@N": {
              "name": "DM cum JM Court, Karambakkudi"
            },
            "1370009@27@N": {
              "name": "DM cum JM Court, Viralimalai"
            },
            "1370010@28@N": {
              "name": "DM cum JM Court, Avudaiyarkoil"
            },
            "1370013@29@N": {
              "name": "DM cum JM Court, Manalmelkudi"
            }
          }
        },
        "3": {
          "name": "Tirunelveli",
          "courtComplexes": {
            "1100029@32,33,37@N": {
              "name": "Combined Courts, Nanguneri"
            },
            "1100031@11,12,13,14,15,16,23,24,25,34,36@N": {
              "name": "Combined Courts, Tirunelveli"
            },
            "1100032@35@N": {
              "name": "DM cum JM court, Rathapuram"
            },
            "1100038@7,8,17@N": {
              "name": "Combined Courts, Ambasamaduram"
            },
            "1100040@3@N": {
              "name": "DM cum JM Court, Cheranmahadevi"
            },
            "1100041@18,19,20@N": {
              "name": "Combined Courts, Valliyoor"
            }
          }
        },
        "4": {
          "name": "Theni",
          "courtComplexes": {
            "1100043@7,8,9,10,11,12,19,25,26,27,28@N": {
              "name": "Combined Courts, Theni"
            },
            "1100044@4,13,14,15@N": {
              "name": "Combined Courts, Periyakulam"
            },
            "1100045@2,16,17,18@N": {
              "name": "Combined Courts, Uthamapalayam"
            },
            "1100047@22,23@N": {
              "name": "Combined Courts,  Aundipatti"
            },
            "1100049@20,21,29@N": {
              "name": "Combined Courts, Bodinayakkanur"
            }
          }
        },
        "5": {
          "name": "Namakkal",
          "courtComplexes": {
            "1100051@4,5,6,7,14,15,18,19,26@N": {
              "name": "Combined Courts, Namakkal"
            },
            "1100053@2,8,9@N": {
              "name": "Combined Courts, Rasipuram"
            },
            "1100054@10,11,12,16,25@N": {
              "name": "Combined Courts, Tiruchengode"
            },
            "1100324@23,24@N": {
              "name": "Combined Courts, Kumarapalayam"
            },
            "1100325@21,22@N": {
              "name": "Combined Courts, Sendamangalam"
            },
            "1100348@3,17,20@N": {
              "name": "Combined Courts, Paramathy"
            }
          }
        },
        "6": {
          "name": "Nagapattinam",
          "courtComplexes": {
            "1100060@4@N": {
              "name": "DM cum JM Court, Vedaranyam"
            },
            "1100063@5,6,7,8,9,15,17,18,19,23@N": {
              "name": "Combined Courts, Nagapattinam"
            },
            "1100345@22@N": {
              "name": "DM cum JM Court, Kilvelur"
            }
          }
        },
        "7": {
          "name": "Kanniyakumari",
          "courtComplexes": {
            "1100064@6,13,14,26@N": {
              "name": "Combined Courts, Kuzhithurai"
            },
            "1100065@10,11,12,22,29@N": {
              "name": "Combined Courts, Padmanabhapuram"
            },
            "1100066@2,5,7,8,9,15,16,18,19,25,27,28@N": {
              "name": "Combined Courts, Nagercoil"
            },
            "1100068@20,21,23,24@N": {
              "name": "Combined Courts, Eraniel"
            },
            "1100069@3@N": {
              "name": "DM cum JM Court, Boothapandy"
            }
          }
        },
        "8": {
          "name": "Tiruchirappalli",
          "courtComplexes": {
            "1100072@21,22,23@N": {
              "name": "Combined Courts, Lalgudi"
            },
            "1100073@9,10,11,12,14,15,16,17,18,19,25,28@N": {
              "name": "Combined Courts, Tiruchirappalli"
            },
            "1100074@4,7,24@N": {
              "name": "Combined Courts, Manapparai"
            },
            "1100075@5,6@N": {
              "name": "Combined Courts, Musiri"
            },
            "1100076@2,13,20@N": {
              "name": "Combined Courts, Thuraiyur"
            },
            "1100323@26@N": {
              "name": "DM cum JM Court, Srirangam"
            },
            "1100338@27@N": {
              "name": "DM cum JM Court, Thottiyam"
            },
            "1100394@29@N": {
              "name": "Sub Court, Musiri"
            }
          }
        },
        "9": {
          "name": "Thoothukudi",
          "courtComplexes": {
            "1100078@2@N": {
              "name": "DM cum JM Court, Vilathikulam"
            },
            "1100079@19,20,21@N": {
              "name": "Combined Courts, Tiruchendur"
            },
            "1100080@3,13,26@N": {
              "name": "Combined Courts, Srivaikuntam"
            },
            "1100081@5,6,7,8,14,15,22,23,24@N": {
              "name": "Combined Courts, Thoothukudi"
            },
            "1100082@4,11,12,16@N": {
              "name": "Sub Court Complex, Kovilpatti"
            },
            "1100083@17,18@N": {
              "name": "Combined Courts, Sathankulam"
            },
            "1100339@25@N": {
              "name": "DM cum JM Court, Ottapidaram"
            }
          }
        },
        "10": {
          "name": "Viluppuram",
          "courtComplexes": {
            "1100086@12,45,46@N": {
              "name": "Combined Courts, Vanur"
            },
            "1100093@17,18,19,20,21,22,23,24,25,32,33,38,39,41,43@N": {
              "name": "Combined Courts, Viluppuram"
            },
            "1100094@6,7,15,27,28,29,37@N": {
              "name": "Combined Courts, Tindivanam"
            },
            "1100096@2,3,8@N": {
              "name": "Combined Courts, Gingee"
            },
            "1100316@40@N": {
              "name": "DM cum JM Court, Vikravandi"
            },
            "1100395@44@N": {
              "name": "DM cum JM Court, Thiruvennainallur"
            }
          }
        },
        "11": {
          "name": "Vellore",
          "courtComplexes": {
            "1100100@12,13,14,15,16,17,18,31,32,39,40,45@N": {
              "name": "Combined Courts, Vellore"
            },
            "1100101@36,37,43@N": {
              "name": "Combined Courts, Katpadi"
            },
            "1100112@9,19,20@N": {
              "name": "Combined Courts, Gudiyatham"
            }
          }
        },
        "12": {
          "name": "Salem",
          "courtComplexes": {
            "1100113@18,19,20,21@N": {
              "name": "Combined Courts, Mettur"
            },
            "1100114@25,26,27,28,38@N": {
              "name": "Sub Court Complex, Attur"
            },
            "1100115@8,9,10@N": {
              "name": "Combined Courts, Sankari"
            },
            "1100117@12,22,23,24@N": {
              "name": "Combined Courts, Omalur"
            },
            "1100118@31@N": {
              "name": "DM cum JM Court, Vazhapadi"
            },
            "1100119@2,3,4,5,6,7,13,14,15,16,17,29,30,32,35,36,37@N": {
              "name": "Combined Courts, Salem"
            },
            "1100319@33@N": {
              "name": "DM cum JM Court, Edappadi"
            },
            "1100332@34@N": {
              "name": "DM cum JM Court, Yercaud"
            }
          }
        },
        "13": {
          "name": "Chennai",
          "courtComplexes": {
            "1100120@10,11,12@N": {
              "name": "Singaravelar Maaligai Complex"
            },
            "1100121@17,18,19@N": {
              "name": "C M M Court, Egmore"
            },
            "1100122@7@N": {
              "name": "M M Courts, George Town"
            },
            "1100123@6@N": {
              "name": "M M Courts, Saidapet"
            },
            "1100124@1,3,4,5,9,14,15,16,24,26@N": {
              "name": "City Civil Court Complex, Chennai"
            },
            "1100125@2@N": {
              "name": "Court of Small Causes, Chennai"
            },
            "1100127@8@N": {
              "name": "Bomb Blast Court, Poonamallee"
            },
            "1100130@21,22,23@N": {
              "name": "M M Courts, Egmore at Allikulam"
            }
          }
        },
        "14": {
          "name": "Virudhunagar",
          "courtComplexes": {
            "1100131@6,15,16,23@N": {
              "name": "Combined Courts, Sivakasi"
            },
            "1100132@5,12,13,14,22@N": {
              "name": "Combined Courts, Virudhunagar"
            },
            "1100133@3,4,28@N": {
              "name": "Combined Courts, Sattur"
            },
            "1100135@8,9,10,11,20,21,24,26,27@N": {
              "name": "Combined Courts, Srivilliputtur"
            },
            "1100136@17,18,19,30@N": {
              "name": "Combined Courts, Aruppukkottai"
            },
            "1100137@2,25,31@N": {
              "name": "Combined Courts, Rajapalayam"
            },
            "1100344@29@N": {
              "name": "DM cum JM Court, Tiruchuli"
            },
            "1370026@32@N": {
              "name": "DM cum JM Court, Watrap"
            },
            "1370030@33@N": {
              "name": "DM cum JM Court, Kariapatti"
            }
          }
        },
        "15": {
          "name": "Madurai",
          "courtComplexes": {
            "1100138@28@N": {
              "name": "DM cum JM Court, Peraiyur"
            },
            "1100139@19,27@N": {
              "name": "Combined Courts, Vadipatti"
            },
            "1100140@2@N": {
              "name": "Magistrate Court, Thirumangalam"
            },
            "1100141@14@N": {
              "name": "Munsif Court, Thirumangalam"
            },
            "1100142@29@N": {
              "name": "Sub Court, Thirumangalam"
            },
            "1100143@15,30@N": {
              "name": "Munsif Court, Melur"
            },
            "1100144@16@N": {
              "name": "Magistrate Court, Melur"
            },
            "1100145@17,18,31@N": {
              "name": "Combined Courts, Usilampatti"
            },
            "1100146@3,4,5,6,7,8,9,10,11,12,13,20,21,22,23,24,25,26,32,33,34@N": {
              "name": "Combined Courts, Madurai"
            }
          }
        },
        "16": {
          "name": "The Nilgiris",
          "courtComplexes": {
            "1100149@7@N": {
              "name": "DM cum JM Court, Kotagiri"
            },
            "1100151@8@N": {
              "name": "Magistrate Court, Panthalur"
            },
            "1100152@17@N": {
              "name": "Labour Court Complex, The Nilgiris"
            },
            "1100153@4@N": {
              "name": "Magistrate Court, Coonoor"
            },
            "1100155@1,2,5,9,12,18@N": {
              "name": "Combined Court Complex, The Nilgiris"
            },
            "1100156@6,13@N": {
              "name": "Combined Courts, Gudalur"
            },
            "1100350@10,11,15@N": {
              "name": "Combined Courts, Coonoor"
            }
          }
        },
        "17": {
          "name": "Thanjavur",
          "courtComplexes": {
            "1100157@23,24@N": {
              "name": "Combined Courts, Thiruvaiyaru"
            },
            "1100158@18,19,20,21,22,25@N": {
              "name": "Combined Courts, Kumbakonam"
            },
            "1100159@4,7,8,9,10@N": {
              "name": "Combined Courts, Pattukkottai"
            },
            "1100161@1,2,3,11,12,13,14,15,16,17,26,27,29,31@N": {
              "name": "Combined Courts, Thanjavur"
            },
            "1100162@28@N": {
              "name": "DM cum JM Court, Thiruvidaimaruthur"
            },
            "1100163@5@N": {
              "name": "DM cum JM Court, Orathanadu"
            },
            "1100164@6@N": {
              "name": "DM cum JM Court, Papanasam"
            },
            "1100347@30@N": {
              "name": "DM cum JM Court, Peravurani"
            }
          }
        },
        "18": {
          "name": "Coimbatore",
          "courtComplexes": {
            "1100166@23,24@N": {
              "name": "DM cum JM Court, Sulur"
            },
            "1100167@26@N": {
              "name": "DM cum JM Court, Madukkarai"
            },
            "1100168@3,4,5,6,7,8,10,11,12,13,14,16,17,25,31,33@N": {
              "name": "Combined Courts, Coimbatore"
            },
            "1100169@20,21@N": {
              "name": "DM cum JM Court, Pollachi"
            },
            "1100170@2@N": {
              "name": "Sub Court, Pollachi"
            },
            "1100171@9@N": {
              "name": "Bomb Blast Court, Coimbatore"
            },
            "1100172@22,27,28@N": {
              "name": "Combined Courts, Mettupalayam"
            },
            "1100173@19@N": {
              "name": "DM cum JM Court, Valparai"
            },
            "1100356@29,30@N": {
              "name": "Commercial Courts, Coimbatore"
            },
            "1100392@32@N": {
              "name": "DM cum JM Court, Annur"
            }
          }
        },
        "19": {
          "name": "Karur",
          "courtComplexes": {
            "1100174@14@N": {
              "name": "DM cum JM Court, Aravakurichi"
            },
            "1100175@9,10,11,12@N": {
              "name": "Combined Courts, Kulithalai"
            },
            "1100176@2,3,4,5,6,7,8,13,17@N": {
              "name": "Combined Courts, Karur"
            },
            "1100326@15@N": {
              "name": "JM Mahila Court, Karur"
            },
            "1100341@16@N": {
              "name": "DM cum JM Court, Krishnarayapuram"
            }
          }
        },
        "20": {
          "name": "Cuddalore",
          "courtComplexes": {
            "1100179@6@N": {
              "name": "DM cum JM Court, Parangipettai"
            },
            "1100180@1,24,26@N": {
              "name": "District Court Complex, Cuddalore"
            },
            "1100181@29,34,35@N": {
              "name": "Combined Courts, Tittagudi"
            },
            "1100182@10,11,18,19,20@N": {
              "name": "Combined Courts, Chidambaram"
            },
            "1100183@9,21@N": {
              "name": "Combined Courts, Neyveli"
            },
            "1100184@12,13,14@N": {
              "name": "Combined Courts, Panruti"
            },
            "1100185@7,15,16,17@N": {
              "name": "Combined Courts, Virudhachalam"
            },
            "1100186@28@N": {
              "name": "DM cum JM Court, Kattumannarkoil"
            },
            "1100187@2,4,22,23,25,27,30,31,32,36@N": {
              "name": "New Combined Courts, Cuddalore"
            },
            "1100313@33@N": {
              "name": "DMcumJM Court, Kurunjipadi"
            }
          }
        },
        "21": {
          "name": "Ramanathapuram",
          "courtComplexes": {
            "1100188@2@N": {
              "name": "DM cum JM Court, Rameswaram"
            },
            "1100189@19,21@N": {
              "name": "SCST JMMAHILACourts, Ramanathapuram"
            },
            "1100190@20@N": {
              "name": "DM cum JM Court, Kadaladi"
            },
            "1100191@14,12,13,15@N": {
              "name": "Combined Courts, Paramakudi"
            },
            "1100192@6,7,8,9,10,17,18,24@N": {
              "name": "Combined Courts, Ramanathapuram"
            },
            "1100193@5,11,16@N": {
              "name": "Combined Courts, Mudukulathur"
            },
            "1100194@22,23@N": {
              "name": "Combined Courts, Thiruvadanai"
            },
            "1100195@4@N": {
              "name": "DM cum JM Court, Kamudhi"
            }
          }
        },
        "22": {
          "name": "Tiruvannamalai",
          "courtComplexes": {
            "1100196@2,11,12,21@N": {
              "name": "Combined Courts, Arani"
            },
            "1100199@5,9,10@N": {
              "name": "Sub Court Complex, Cheyyar"
            },
            "1100200@1,3,16,17,18,19,20,24,26,27,28,32@N": {
              "name": "Combined Courts, Tiruvannamalai"
            },
            "1100201@7,8,29@N": {
              "name": "Combined Courts, Chengam"
            },
            "1100203@25@N": {
              "name": "DM cum JM Court, Kalasapakkam"
            },
            "1100204@22,23@N": {
              "name": "Combined Courts, Vandavasi"
            },
            "1100340@30@N": {
              "name": "DM cum JM Court, Thandarampattu"
            },
            "1100342@14,15,31@N": {
              "name": "Combined Courts, Polur"
            },
            "1100360@33@N": {
              "name": "Sub Court Complex, Vandavasi"
            },
            "1370045@34@N": {
              "name": "DM cum JM Court, Kilpennathur"
            }
          }
        },
        "23": {
          "name": "Perambalur",
          "courtComplexes": {
            "1100206@2,3,4,5,6,7,8,11@N": {
              "name": "Combined Courts, Perambalur"
            },
            "1100328@9@N": {
              "name": "DM cum JM Court, Veppanthattai"
            },
            "1100335@10@N": {
              "name": "DM cum JM Court, Kunnam"
            }
          }
        },
        "24": {
          "name": "Erode",
          "courtComplexes": {
            "1100208@20,21,22,23,24,29@N": {
              "name": "Combined Courts, Bhavani"
            },
            "1100209@2,10,11@N": {
              "name": "Sub Court Complex, Sathyamangalam"
            },
            "1100210@18,19,30@N": {
              "name": "Combined Courts, Perundurai"
            },
            "1100212@4,7,8,26@N": {
              "name": "New Combined Court Building, Erode"
            },
            "1100214@3,5,6,9,25,27,28@N": {
              "name": "Combined Courts, Erode"
            },
            "1100215@31@N": {
              "name": "District Munsif Court, Anthiyur"
            },
            "1100217@13,14,15,16,17@N": {
              "name": "Combined Courts, Gobichettipalayam"
            },
            "1100218@12,32@N": {
              "name": "Combined Courts, Kodumudi"
            },
            "1370027@33@N": {
              "name": "DM cum JM Court, Modakurichi"
            }
          }
        },
        "25": {
          "name": "Tiruvarur",
          "courtComplexes": {
            "1100219@1,18@N": {
              "name": "Combined Courts, Mannargudi"
            },
            "1100220@6@N": {
              "name": "Munsif Court, Mannargudi"
            },
            "1100221@2@N": {
              "name": "DM cum JM Court, Nannilam"
            },
            "1100222@17@N": {
              "name": "DM cum JM Court, Needamangalam"
            },
            "1100223@5@N": {
              "name": "Magistrate Court, Mannargudi"
            },
            "1100224@7@N": {
              "name": "DM cum JM Court, Valangaiman"
            },
            "1100225@9,10,11,12,15@N": {
              "name": "Combined Courts, Tiruvarur"
            },
            "1100226@13,14,16,20@N": {
              "name": "Combined Courts, Thiruthuraipoondi"
            },
            "1100322@19,22@N": {
              "name": "Mahila Court and Scst Court, Tiruvarur"
            },
            "1100393@21@N": {
              "name": "DM cum JM Court, Kodavasal"
            }
          }
        },
        "26": {
          "name": "Krishnagiri",
          "courtComplexes": {
            "1100227@10@N": {
              "name": "DM cum JM Court, Pochampalli"
            },
            "1100228@8,9,19,20@N": {
              "name": "Combined Courts, Uthangarai"
            },
            "1100229@17@N": {
              "name": "II Magistrate Court, Hosur"
            },
            "1100230@2,3,4,7,11,12,13,14,21,24@N": {
              "name": "Combined Courts, Krishnagiri"
            },
            "1100231@18,23@N": {
              "name": "Combined Courts, Denkanikottai"
            },
            "1100232@5,6,15,16,22@N": {
              "name": "Combined Courts, Hosur"
            }
          }
        },
        "27": {
          "name": "Dindigul",
          "courtComplexes": {
            "1100233@8@N": {
              "name": "DM cum JM Court, Natham"
            },
            "1100234@24@N": {
              "name": "DM cum JM Court, Athoor"
            },
            "1100236@11,12,13,18,19@N": {
              "name": "Combined Courts, Palani"
            },
            "1100237@10,26@N": {
              "name": "Combined Courts, Kodaikanal"
            },
            "1100238@14,15,22@N": {
              "name": "Combined Courts, Vedasandur"
            },
            "1100239@2,3,4,5,16,17,20,23,27,28@N": {
              "name": "Combined Courts, Dindigul"
            },
            "1100240@7@N": {
              "name": "Magistrate Court, Nilakkottai"
            },
            "1100242@6@N": {
              "name": "Munsif Court, Nilakkottai"
            },
            "1100327@9,21,25@N": {
              "name": "Combined Courts, Oddanchathiram"
            }
          }
        },
        "29": {
          "name": "Sivagangai",
          "courtComplexes": {
            "1100247@3,4,5@N": {
              "name": "Combined Courts, Devakottai"
            },
            "1100248@13,14,15,16,18@N": {
              "name": "Old Combined Courts, Sivagangai"
            },
            "1100249@7@N": {
              "name": "DM cum JM Court, Tiruppathur"
            },
            "1100250@6@N": {
              "name": "DM cum JM Court, Ilayangudi"
            },
            "1100251@17,20,21@N": {
              "name": "Combined Courts, Karaikudi"
            },
            "1100252@1,2,11,12,19,26@N": {
              "name": "New Combined Courts, Sivagangai"
            },
            "1100330@22@N": {
              "name": "DM cum JM Court, Singampunari"
            },
            "1100331@9,23,25@N": {
              "name": "Combined Courts, Manamadurai"
            },
            "1100336@24@N": {
              "name": "DM cum JM Court, Thiruppuvanam"
            }
          }
        },
        "30": {
          "name": "Ariyalur",
          "courtComplexes": {
            "1100261@12@N": {
              "name": "DM cum JM Court Complex, Sendurai"
            },
            "1100264@4,5,6,7,9@N": {
              "name": "Combined Courts, Ariyalur"
            },
            "1100346@1,2,8,10,11@N": {
              "name": "Combined Courts, Jayankondam"
            }
          }
        },
        "31": {
          "name": "Kancheepuram",
          "courtComplexes": {
            "1100266@6@N": {
              "name": "II Magistrate Court, Kancheepuram"
            },
            "1100267@25,27@N": {
              "name": "Combined Courts, Sriperumbudur"
            },
            "1100269@4,12,13,14,33@N": {
              "name": "Combined Courts, Kancheepuram"
            },
            "1100271@20@N": {
              "name": "DM cum JM Court, Uthiramerur"
            },
            "1100320@29@N": {
              "name": "Labour Court, Kancheepuram"
            },
            "1370101@35@N": {
              "name": "Motor Accident Claim Tribunal Court, Kancheepuram"
            }
          }
        },
        "32": {
          "name": "Tiruvallur",
          "courtComplexes": {
            "1100274@1,17,19,20,29,30,31,32,33,36,42@N": {
              "name": "Combined Courts, Tiruvallur"
            },
            "1100277@8,9,34@N": {
              "name": "Combined Courts, Tiruttani"
            },
            "1100278@21,22,23,24,25,26,28@N": {
              "name": "Combined Courts, Poonamallee"
            },
            "1100279@3,4@N": {
              "name": "Sub Court Complex, Ponneri"
            },
            "1100281@38@N": {
              "name": "DM cum JM Court, Madhavaram"
            },
            "1100282@12,13,27,41@N": {
              "name": "Combined Courts, Ambattur"
            },
            "1100284@5@N": {
              "name": "Munsif Court, Ponneri"
            },
            "1100285@10,11,40@N": {
              "name": "Combined Courts, Tiruvottiyur"
            },
            "1100286@14@N": {
              "name": "DM cum JM Court, Pallipattu"
            },
            "1100287@15@N": {
              "name": "DM cum JM Court, Uthukottai"
            },
            "1100288@35@N": {
              "name": "I Magistrate Court, Ponneri"
            },
            "1100289@6@N": {
              "name": "II Magistrate Court, Ponneri"
            },
            "1100315@39@N": {
              "name": "DM cum JM Court, Gummidipoondi"
            }
          }
        },
        "33": {
          "name": "Tiruppur",
          "courtComplexes": {
            "1100292@2,3,29@N": {
              "name": "Combined Courts, Palladam"
            },
            "1100294@9,10,25@N": {
              "name": "Combined Courts, Kangeyam"
            },
            "1100298@17,18,19@N": {
              "name": "Sub Court Complex, Dharapuram"
            },
            "1100299@24@N": {
              "name": "Sub Court Complex, Avinashi"
            },
            "1100300@1,4@N": {
              "name": "Combined Courts, Avinashi"
            },
            "1100301@8@N": {
              "name": "Magistrate Court, Dharapuram"
            },
            "1100302@13,14,20,21,22,26,27,32@N": {
              "name": "Combined Courts Campus, Tiruppur"
            },
            "1100303@28@N": {
              "name": "DM cum JM Court, Madathukulam"
            },
            "1100307@5,6,7,31@N": {
              "name": "Sub Court Complex, Udumalpet"
            },
            "1100309@23@N": {
              "name": "I Magistrate Court, Udumalpet"
            },
            "1100321@30@N": {
              "name": "DM cum JM Court, Uthukuli"
            }
          }
        },
        "34": {
          "name": "Mayiladuthurai",
          "courtComplexes": {
            "1100349@1,2,3,4,5@N": {
              "name": "Combined Courts, Mayiladuthurai"
            },
            "1100351@6@N": {
              "name": "DM cum JM Court, Tharangambadi"
            },
            "1100352@7,8,9@N": {
              "name": "Combined Courts, Sirkali"
            }
          }
        },
        "35": {
          "name": "Kallakurichi",
          "courtComplexes": {
            "1100372@1,2,3,4,5,6,7,8@N": {
              "name": "Combined Courts, Kallakurichi"
            },
            "1100379@9,10,17@N": {
              "name": "Combined Courts, Sankarapuram"
            },
            "1100380@11,12,13@N": {
              "name": "Combined Courts, Tirukkoyilur"
            },
            "1100381@14,15,16@N": {
              "name": "Combined Courts, Ulundurpet"
            }
          }
        },
        "36": {
          "name": "Tenkasi",
          "courtComplexes": {
            "1100358@1,2,3,16@N": {
              "name": "Combined Courts, Tenkasi"
            },
            "1100361@8@N": {
              "name": "Munsif Court, Alangulam"
            },
            "1100362@7@N": {
              "name": "Magistrate Court, Alangulam"
            },
            "1100363@9,10,11@N": {
              "name": "Combined Courts, Sankarankovil"
            },
            "1100364@4@N": {
              "name": "DM cum JM Court, Shengottah"
            },
            "1100365@5,6@N": {
              "name": "Combined Courts, Sivagiri"
            },
            "1100366@12,13@N": {
              "name": "Additional Courts, Tenkasi"
            }
          }
        },
        "37": {
          "name": "Tirupathur",
          "courtComplexes": {
            "1100359@2,3,4,5,6,10@N": {
              "name": "Combined Courts, Tirupathur"
            },
            "1100375@7@N": {
              "name": "Sub Court, Vaniyambadi"
            },
            "1100376@8,13@N": {
              "name": "Combined Courts, Vaniyambadi"
            },
            "1100377@9,11,12@N": {
              "name": "Combined Courts, Ambur"
            }
          }
        },
        "38": {
          "name": "Chengalpattu",
          "courtComplexes": {
            "1100368@1@N": {
              "name": "DM cum JM Court, Sholinganallur"
            },
            "1100382@2,3,4@N": {
              "name": "Combined Courts, Maduranthakam"
            },
            "1100383@5,6,7,8@N": {
              "name": "Combined Courts, Alandur"
            },
            "1100384@9,10,11@N": {
              "name": "Combined Courts, Tambaram"
            },
            "1100385@12@N": {
              "name": "DM cum JM Court, Thiruporur"
            },
            "1100386@13@N": {
              "name": "DM cum JM Court, Cheyyur"
            },
            "1100387@14@N": {
              "name": "DM cum JM Court, Pallavaram"
            },
            "1100388@15@N": {
              "name": "DM cum JM Court, Thirukalukundram"
            },
            "1100389@16,17,18,20,21,22@N": {
              "name": "Combined Courts, Chengalpet"
            },
            "1100390@19@N": {
              "name": "Pocso Court, Chengalpet"
            }
          }
        },
        "39": {
          "name": "Ranipet",
          "courtComplexes": {
            "1100369@1,2,13,14@N": {
              "name": "Combined Courts, Ranipet"
            },
            "1100371@3,4,5,7,8,9@N": {
              "name": "Combined Courts, Arakkonam"
            },
            "1100373@6,10@N": {
              "name": "Combined Courts, Sholingur"
            },
            "1100374@11@N": {
              "name": "DM cum JM Court, Arcot"
            },
            "1100378@12,15@N": {
              "name": "Combined Courts, Walajah"
            }
          }
        }
      }
    },
    "11": {
      "name": "Odisha",
      "districts": {
        "1": {
          "name": "Cuttack",
          "courtComplexes": {
            "1110005@23@N": {
              "name": "JMFC Court Complex,Tigiria"
            },
            "1110006@19,20,21@N": {
              "name": "Court Complex, Salipur"
            },
            "1110007@12,25@Y": {
              "name": "Court Complex, Narasinghpur"
            },
            "1110008@17,22@N": {
              "name": "Collectorate Campus, Cuttack"
            },
            "1110010@13,26@Y": {
              "name": "Court Complex, Baramba"
            },
            "1110011@14,15@N": {
              "name": "Court Complex, Banki"
            },
            "1110012@7,8,9@N": {
              "name": "Court Complex, Athagarh"
            },
            "1110013@3,4,5,18,24@Y": {
              "name": "Courts Complex, Cuttack"
            }
          }
        },
        "2": {
          "name": "Kendrapada",
          "courtComplexes": {
            "1110014@2,4,5@N": {
              "name": "Court Complex, Kendrapara"
            }
          }
        },
        "3": {
          "name": "Nuapada",
          "courtComplexes": {
            "1110015@2,3@N": {
              "name": "Court Complex, Nuapada"
            },
            "1110016@5,6,10@Y": {
              "name": "Court Complex, Khariar"
            },
            "1110017@4@N": {
              "name": "Sub Judge Court Complex, Nuapada"
            },
            "1370076@7@N": {
              "name": "GRAM NYAYALAYA, KOMNA"
            },
            "1370096@8@Y": {
              "name": "JMFC Court Complex, Boden"
            },
            "1370097@9@Y": {
              "name": "JMFC Court Complex, Sinapali"
            }
          }
        },
        "4": {
          "name": "Ganjam",
          "courtComplexes": {
            "1110018@2,3,4@Y": {
              "name": "District Court Complex, Berhampur"
            },
            "1110019@11,12,23@N": {
              "name": "Court Complex, Khallikote"
            },
            "1110020@5@Y": {
              "name": "SDJM Court Complex, Berhampur"
            },
            "1110021@16,17,18@N": {
              "name": "Court Complex, Aska"
            },
            "1110022@19,20,21@N": {
              "name": "Court Complex, Bhanjanagar"
            },
            "1110023@10@N": {
              "name": "Court Complex, Digapahandi"
            },
            "1110024@6,7,24@N": {
              "name": "Court Complex, Kodala"
            },
            "1110025@9@N": {
              "name": "Court Complex, Patrapur"
            },
            "1110026@22,29@Y": {
              "name": "JMFC Court Complex, Soroda"
            },
            "1110027@8,28@N": {
              "name": "Court Complex, Purushottampur"
            },
            "1110028@13,14,15@N": {
              "name": "Court Complex, Chhatrapur"
            },
            "1110130@25,26@Y": {
              "name": "Court Complex, Hinjili"
            },
            "1110131@27@N": {
              "name": "Gram Nyayalaya, Sanakhemundi"
            },
            "1110135@30@Y": {
              "name": "Court Complex, Seragada"
            },
            "1110142@31@Y": {
              "name": "Court Complex, Buguda"
            },
            "1110143@32@N": {
              "name": "Court Complex, Kabisuryanagar"
            }
          }
        },
        "5": {
          "name": "Balasore",
          "courtComplexes": {
            "1110029@6,7,13@Y": {
              "name": "Court Complex, Jaleswar"
            },
            "1110030@2,3,4@N": {
              "name": "DJ Court Complex, Balasore"
            },
            "1110031@10,11,12@Y": {
              "name": "Court Complex, Soro"
            },
            "1110032@8,14@Y": {
              "name": "Court Complex, Nilagiri"
            },
            "1110033@5@N": {
              "name": "Collectorate Complex, Balasore"
            },
            "1110034@9@N": {
              "name": "Kacheri Complex, Nilagiri"
            }
          }
        },
        "6": {
          "name": "Koraput",
          "courtComplexes": {
            "1110035@10@N": {
              "name": "Court Complex, Laxmipur"
            },
            "1110036@3,4,5@N": {
              "name": "Court Complex, Jeypore"
            },
            "1110038@9@N": {
              "name": "Court Complex, Kotpad"
            },
            "1110039@6,7,8@N": {
              "name": "Court Complex, Koraput"
            },
            "1110129@12@N": {
              "name": "GRAM NYAYALAYA,SEMILIGUDA"
            }
          }
        },
        "7": {
          "name": "Dhenkanal",
          "courtComplexes": {
            "1110040@2,3,4@N": {
              "name": "Court Complex, Dhenkanal"
            },
            "1110041@8,9,10@N": {
              "name": "Court Complex, Hindol"
            },
            "1110042@5,6,7@N": {
              "name": "Court Complex, Kamakshyanagar"
            },
            "1110133@11@Y": {
              "name": "Court Complex Bhuban"
            },
            "1110137@12@Y": {
              "name": "JMFC Parjanga"
            }
          }
        },
        "8": {
          "name": "Khurda",
          "courtComplexes": {
            "1110043@9,10,11@Y": {
              "name": "Court Complex, Banapur"
            },
            "1110044@5,6,7@Y": {
              "name": "Court Complex, Khurda"
            },
            "1110045@2,3,4@Y": {
              "name": "Court Complex, Bhubaneswar"
            },
            "1110046@8@N": {
              "name": "Court Complex, Jatni"
            },
            "1110132@12@N": {
              "name": "Gram Nyayalaya, Tangi"
            }
          }
        },
        "9": {
          "name": "Gajapati",
          "courtComplexes": {
            "1110047@2,3,4@N": {
              "name": "Court Complex, Parlakhemundi"
            },
            "1110048@5,6@N": {
              "name": "Court Complex, R. Udayagiri"
            }
          }
        },
        "10": {
          "name": "Kalahandi",
          "courtComplexes": {
            "1110049@8,9,10@N": {
              "name": "Court Complex, Dharamgarh"
            },
            "1110050@14@N": {
              "name": "Court Complex, Junagarh"
            },
            "1110051@4,5,6@N": {
              "name": "District Court Complex, Bhawanipatna"
            },
            "1110052@3@N": {
              "name": "CJM Court Complex, Bhawanipatna"
            },
            "1110053@13@N": {
              "name": "JMFC Court Complex, Kesinga"
            },
            "1110054@12,15@Y": {
              "name": "Court Complex, Jaipatna"
            },
            "1110055@11@N": {
              "name": "Court Complex, M.Rampur"
            }
          }
        },
        "11": {
          "name": "Sambalpur",
          "courtComplexes": {
            "1110056@5,12@N": {
              "name": "Court Complex, Rairakhol"
            },
            "1110058@10@N": {
              "name": "Old Court Complex, Sambalpur"
            },
            "1110059@9@N": {
              "name": "SDJM Kunchinda"
            },
            "1110060@7,11@N": {
              "name": "Court Complex, Kuchinda"
            },
            "1110061@2,3,4@N": {
              "name": "New Court Complex Sambalpur"
            }
          }
        },
        "12": {
          "name": "Jharsuguda",
          "courtComplexes": {
            "1110062@2@N": {
              "name": "SDJM Court Complex"
            },
            "1110063@3,4,5@N": {
              "name": "Court Complex, Jharsuguda"
            },
            "1110141@6@Y": {
              "name": "Gramanayalaya Lakhanpur"
            }
          }
        },
        "13": {
          "name": "Keonjhar",
          "courtComplexes": {
            "1110064@8,9,10@N": {
              "name": "Court Complex, Champua"
            },
            "1110065@2,3,4@N": {
              "name": "District & Sessions Judge, Keonjhar"
            },
            "1110066@12@N": {
              "name": "Gram Nyayalaya, Ghasipura"
            },
            "1110067@7@N": {
              "name": "SDJM Court Complex, Badbil"
            },
            "1110068@5,6,11@N": {
              "name": "Court Complex, Anandpur"
            }
          }
        },
        "14": {
          "name": "Jagatsinghpur",
          "courtComplexes": {
            "1110069@6,7@N": {
              "name": "Court Complex, Kujanga"
            },
            "1110070@3,4,5@N": {
              "name": "Revenue Building, Jagatsinghpur"
            },
            "1110071@9@N": {
              "name": "D.I. of School Building, Jagatsinghpur"
            }
          }
        },
        "15": {
          "name": "Puri",
          "courtComplexes": {
            "1110072@13,15@Y": {
              "name": "Court Complex, Pipili"
            },
            "1110073@10,11,14@N": {
              "name": "Court Complex, Nimapara"
            },
            "1110074@12@N": {
              "name": "Old Court Complex, Puri"
            },
            "1110075@3,4,5@N": {
              "name": "New Court Complex, Puri"
            }
          }
        },
        "16": {
          "name": "Sundargarh",
          "courtComplexes": {
            "1110076@9,10,11@N": {
              "name": "Court Complex, Rourkela at Birjapalli"
            },
            "1110077@6,7,8@N": {
              "name": "Court Complex, Bonai"
            },
            "1110078@13@N": {
              "name": "JMFC Court Complex, Rajgangpur"
            },
            "1110079@2,3,4@N": {
              "name": "District Court Complex, Sundargarh"
            }
          }
        },
        "17": {
          "name": "Balangir",
          "courtComplexes": {
            "1110080@2,3,4@N": {
              "name": "DJ Court Complex, Bolangir"
            },
            "1110081@5,6,7@N": {
              "name": "Court Complex, Patnagarh"
            },
            "1110082@8,9,10@Y": {
              "name": "Court Complex, Titilagarh"
            },
            "1110083@11,12,13@Y": {
              "name": "Court Complex, Kantabanji"
            },
            "1110138@14@Y": {
              "name": "JMFC Loisingha"
            },
            "1110140@15@Y": {
              "name": "JMFC,Saintala"
            }
          }
        },
        "18": {
          "name": "Bhadrak",
          "courtComplexes": {
            "1110084@7@N": {
              "name": "Court Complex, Chandbali"
            },
            "1110085@2,3,4@N": {
              "name": "Court Complex, Bhadrak"
            },
            "1110086@5,8@N": {
              "name": "Court Complex, Basudevpur"
            },
            "1110087@6@N": {
              "name": "Court Complex, Dhamnagar"
            }
          }
        },
        "19": {
          "name": "Jajpur",
          "courtComplexes": {
            "1110088@5,6,7@N": {
              "name": "Court Complex, Jajpur Road"
            },
            "1110089@2,3,4@N": {
              "name": "Court Complex, Jajpur"
            },
            "1370100@8,9,10@Y": {
              "name": "Civil Courts Complex, Chandikhole"
            }
          }
        },
        "20": {
          "name": "Sonepur",
          "courtComplexes": {
            "1110090@5,8@N": {
              "name": "Chief Judicial Magistrate , Biramaharajpur"
            },
            "1110092@2,3,4@N": {
              "name": "Court Complex, Sonepur"
            },
            "1110136@6@Y": {
              "name": "Court Complex Binka"
            },
            "1110139@7@Y": {
              "name": "JMFC Court Rampur"
            }
          }
        },
        "21": {
          "name": "Rayagada",
          "courtComplexes": {
            "1110093@2,3,4@N": {
              "name": "Court Complex, Rayagada"
            },
            "1110094@5@N": {
              "name": "Court Complex, Kashipur"
            },
            "1110095@7,8,9@N": {
              "name": "Court Complex, Gunupur"
            },
            "1110096@6@N": {
              "name": "Court Complex, Bissamcuttack"
            }
          }
        },
        "22": {
          "name": "Nayagarh",
          "courtComplexes": {
            "1110097@8,12@Y": {
              "name": "Court Complex, Khandapara"
            },
            "1110099@7,13@Y": {
              "name": "Court Complex, Ranapur"
            },
            "1110100@2,3,4,5@Y": {
              "name": "District Court Complex, Nayagarh"
            },
            "1110101@9@N": {
              "name": "Court Complex, Daspalla"
            },
            "1110102@10,11@Y": {
              "name": "Court Complex, Odagaon"
            },
            "1370075@14@Y": {
              "name": "Court Complex, Bhapur"
            }
          }
        },
        "23": {
          "name": "Kandhamal",
          "courtComplexes": {
            "1110103@8@N": {
              "name": "Court Complex, Daringibadi"
            },
            "1110104@2,3,4@N": {
              "name": "Court Complex, Phulbani"
            },
            "1110105@6,7,9@N": {
              "name": "Court Complex, Baliguda"
            },
            "1110106@5@N": {
              "name": "Court Complex, G. Udayagiri"
            }
          }
        },
        "24": {
          "name": "Boudh",
          "courtComplexes": {
            "1110107@5,6,7@N": {
              "name": "Court Complex, Kantamal"
            },
            "1110108@2,3,4@N": {
              "name": "Court Complex, Boudh"
            }
          }
        },
        "26": {
          "name": "Mayurbhanj",
          "courtComplexes": {
            "1110109@5,6,7@N": {
              "name": "Court Complex, Rairangpur"
            },
            "1110110@10,11,14@Y": {
              "name": "Court Complex, Udala"
            },
            "1110111@8,9,12@N": {
              "name": "Court Complex, Karanjia"
            },
            "1110112@2,3,4@N": {
              "name": "District Court Complex, Baripada"
            },
            "1110128@13@N": {
              "name": "Court Complex , Betnoti"
            }
          }
        },
        "27": {
          "name": "Anugul",
          "courtComplexes": {
            "1110113@5,6,7@N": {
              "name": "Court Complex, Talcher"
            },
            "1110114@10,11,12,13@N": {
              "name": "Court Complex, Athamallik"
            },
            "1110115@2,3,4@N": {
              "name": "DJ Court Complex, Angul"
            },
            "1110116@8,9@N": {
              "name": "Court Complex, Pallahara"
            }
          }
        },
        "29": {
          "name": "Bargarh",
          "courtComplexes": {
            "1110117@7,8@N": {
              "name": "Court Complex, Sohella"
            },
            "1110118@9@N": {
              "name": "Fast Track Court Complex, Padmapur"
            },
            "1110119@4,5,6@N": {
              "name": "Sub Judge Court Complex, Padmapur"
            },
            "1110120@10,11@N": {
              "name": "Court Complex, Barapalli"
            },
            "1110121@1,2,3@N": {
              "name": "Court Complex, Bargarh"
            },
            "1110134@12@Y": {
              "name": "Gram Nyayalaya Complex, Attabira"
            }
          }
        },
        "30": {
          "name": "Deogarh",
          "courtComplexes": {
            "1110122@1,2,3@N": {
              "name": "District Court Complex, Deogarh"
            }
          }
        },
        "31": {
          "name": "Malkangiri",
          "courtComplexes": {
            "1110123@1,2@N": {
              "name": "Court Complex, Malkangiri"
            },
            "1110124@3,5@N": {
              "name": "SDJM Court Complex, Malkangiri"
            },
            "1110125@4@N": {
              "name": "Court Complex, Mottu"
            }
          }
        },
        "32": {
          "name": "Nabarangpur",
          "courtComplexes": {
            "1110126@1,2,3@N": {
              "name": "District Court Complex, Nabarangpur"
            },
            "1110127@5@N": {
              "name": "Court Complex, Umerkote"
            }
          }
        }
      }
    },
    "12": {
      "name": "Jammu and Kashmir",
      "districts": {
        "1": {
          "name": "Kathua",
          "courtComplexes": {
            "1120015@9,10@N": {
              "name": "Munsiff Court, Mahanpur"
            },
            "1120016@13,14@N": {
              "name": "Munsiff Court Bani"
            },
            "1120017@2,3,4@N": {
              "name": "District Court Complex ,Kathua"
            },
            "1120018@11,12@N": {
              "name": "Munsiff Court,Basholi"
            },
            "1120019@7,8@N": {
              "name": "Munsiff Court, Billawar"
            },
            "1120020@5,6@N": {
              "name": "Munsiff Court, Hiranagar"
            }
          }
        },
        "2": {
          "name": "Udhampur",
          "courtComplexes": {
            "1120021@9,10@N": {
              "name": "Munsiff Court Chenani"
            },
            "1120022@7,8@N": {
              "name": "Sub Judge Court Ramnagar"
            },
            "1120023@5,6@N": {
              "name": "Munsiff Court Majalta"
            },
            "1120024@2,3,4@N": {
              "name": "District Court Complex Udhampur"
            }
          }
        },
        "3": {
          "name": "Baramulla",
          "courtComplexes": {
            "1120025@12,13@N": {
              "name": "Sub Judge Court, Pattan"
            },
            "1120026@5,6,7@N": {
              "name": "ADSJ, Sopore"
            },
            "1120027@16,17@N": {
              "name": "Munsiff Court Chandoosa"
            },
            "1120028@8,9@N": {
              "name": "Munsiff Court, Tangmarg"
            },
            "1120029@2,3,4@N": {
              "name": "District Court, Baramula"
            },
            "1120030@14,15@N": {
              "name": "Munsiff Court, Boniyar"
            },
            "1120031@10,11@N": {
              "name": "Sub Judge Court, Uri"
            },
            "1120032@18,19@N": {
              "name": "Munsiff Court Dangiwacha, Baramulla"
            }
          }
        },
        "4": {
          "name": "Anantnag",
          "courtComplexes": {
            "1120033@5,6@N": {
              "name": "Sub Judge Court Complex,Bijbehara"
            },
            "1120034@13,14@N": {
              "name": "Munsiff Court Pahalgam"
            },
            "1120035@7,8@N": {
              "name": "Munsiff Court Complex,Aishmuqam"
            },
            "1120036@2,3,4@N": {
              "name": "District Court Complex, Anantnag"
            },
            "1120037@11,12@N": {
              "name": "Munisff Court Complex,Dooru"
            },
            "1120039@9,10@N": {
              "name": "Sub Judge Court Complex, Vailoo"
            },
            "1370037@15,16@N": {
              "name": "Munsiff Court Shagus"
            }
          }
        },
        "5": {
          "name": "Srinagar",
          "courtComplexes": {
            "1120040@2,3,4@N": {
              "name": "District Court Srinagar"
            },
            "1120041@5,6@N": {
              "name": "Munsiff Court Pathachowk"
            }
          }
        },
        "6": {
          "name": "Pulwama",
          "courtComplexes": {
            "1120042@1,2,3@N": {
              "name": "District Court Complex, Pulwama"
            },
            "1120043@8,9@N": {
              "name": "Munsiff Court, Pampore"
            },
            "1120044@4,5@N": {
              "name": "Munsiff Court, Tral"
            },
            "1120045@6,7@N": {
              "name": "Munsiff Court Awaitipora"
            }
          }
        },
        "7": {
          "name": "Ganderbal",
          "courtComplexes": {
            "1120046@2,3,4@N": {
              "name": "District Court Complex, Ganderbal"
            },
            "1120047@5,6@N": {
              "name": "Munsiff Court, Kangan"
            }
          }
        },
        "8": {
          "name": "Budgam",
          "courtComplexes": {
            "1120048@4,5@N": {
              "name": "Munsiff Court, Chadoora"
            },
            "1120049@1,2,3@N": {
              "name": "District Court, Budgam"
            },
            "1120050@10,11@N": {
              "name": "Munsiff Court Beerwah"
            },
            "1120051@8,9@N": {
              "name": "Munsiff Court, Charisharief"
            },
            "1120052@6,7@N": {
              "name": "Munsiff Court, Magam"
            }
          }
        },
        "9": {
          "name": "Reasi",
          "courtComplexes": {
            "1120053@4,5@N": {
              "name": "Munsiff Court, Mahore"
            },
            "1120054@1,2,3@N": {
              "name": "DISTRICT COURT COMPLEX REASI"
            },
            "1120055@6,7@N": {
              "name": "Sub Judge Court, Katra"
            }
          }
        },
        "10": {
          "name": "Shopian",
          "courtComplexes": {
            "1120056@1,2,3@N": {
              "name": "District Court Complex, Shopian"
            }
          }
        },
        "11": {
          "name": "Kupwara",
          "courtComplexes": {
            "1120057@1,2,3@N": {
              "name": "District Court Complex, Kupwara"
            },
            "1120058@7,8@N": {
              "name": "Court Complex, Sogam"
            },
            "1120059@4,5,6@N": {
              "name": "Court Complex, Handwara"
            }
          }
        },
        "12": {
          "name": "Poonch",
          "courtComplexes": {
            "1120060@4,5@N": {
              "name": "Munsif Court, Mendhar"
            },
            "1120061@1,2,3@N": {
              "name": "District Court Complex, Poonch"
            },
            "1120062@6,7@N": {
              "name": "Sub Judge Court, Surankote"
            }
          }
        },
        "13": {
          "name": "Rajouri",
          "courtComplexes": {
            "1120063@4,5@N": {
              "name": "Sub Judge Court, Nowshera"
            },
            "1120064@8,9@N": {
              "name": "Munsiff Court, Sunderbani"
            },
            "1120065@10,11@N": {
              "name": "Munsiff Court, Thanamandi"
            },
            "1120066@1,2,3@N": {
              "name": "PDSJ Rajouri"
            },
            "1120067@12,13@N": {
              "name": "Munsiff Court, Kotranka"
            },
            "1120068@6,7@N": {
              "name": "Munsiff Court, Kalakote"
            },
            "1120096@14,15@N": {
              "name": "MUNSIFF COURT, BUDHAL"
            }
          }
        },
        "14": {
          "name": "Ramban",
          "courtComplexes": {
            "1120069@1,2,3@N": {
              "name": "District Court Complex, Ramban"
            },
            "1120070@4,5@N": {
              "name": "Sub Judge Court, Batote"
            },
            "1120071@6,7@N": {
              "name": "Munsiff Court, Banihal"
            }
          }
        },
        "15": {
          "name": "Doda",
          "courtComplexes": {
            "1120072@9,10@N": {
              "name": "Munsiff Court Complex, Gandoh"
            },
            "1120073@6,7,8@N": {
              "name": "Addl Distt and Sessions Judge, Doda"
            },
            "1120074@1,2,3@N": {
              "name": "District Court Complex Bhaderwah"
            },
            "1120075@4,5@N": {
              "name": "Munsiff Court Complex, Thathri"
            }
          }
        },
        "18": {
          "name": "Bandipora",
          "courtComplexes": {
            "1120079@2,3,6@N": {
              "name": "District Court, Bandipora"
            },
            "1120080@4,5@N": {
              "name": "Munsif Court, Sumbal"
            }
          }
        },
        "19": {
          "name": "Jammu",
          "courtComplexes": {
            "1120081@8,9@N": {
              "name": "Munsiff Court, Bishnah"
            },
            "1120082@6,7@N": {
              "name": "Munsiff Court, RSPura"
            },
            "1120083@1,2,3@N": {
              "name": "District Court Complex Jammu"
            },
            "1120084@4,5@N": {
              "name": "Munsiff Court, Akhnoor"
            }
          }
        },
        "20": {
          "name": "Kulgam",
          "courtComplexes": {
            "1120085@6,7@N": {
              "name": "Munsiff Court Complex, Qazigund"
            },
            "1120086@1,2,3@N": {
              "name": "PDSJ Court Kulgam"
            },
            "1120087@4,5@N": {
              "name": "Munsif Court Complex, DH Pora"
            }
          }
        },
        "21": {
          "name": "Samba",
          "courtComplexes": {
            "1120088@1,2,3@N": {
              "name": "District Court Samba"
            }
          }
        },
        "22": {
          "name": "Kishtwar",
          "courtComplexes": {
            "1120089@1,2,3@N": {
              "name": "District Court, Kishtwar"
            }
          }
        }
      }
    },
    "13": {
      "name": "Uttar Pradesh",
      "districts": {
        "1": {
          "name": "Prayagraj",
          "courtComplexes": {
            "1130005@2,3,4,5,6,7@N": {
              "name": "District Court Complex, Prayagraj"
            },
            "1130006@8@N": {
              "name": "Railway Court Prayagraj"
            },
            "1130186@9@N": {
              "name": "Commercial Court Prayagraj"
            },
            "1370079@10@N": {
              "name": "Motor Accident Claim Tribunal, Prayagraj North"
            },
            "1370080@11@N": {
              "name": "Motor Accident Claim Tribunal, Prayagraj South"
            }
          }
        },
        "2": {
          "name": "Bareilly",
          "courtComplexes": {
            "1130007@10@N": {
              "name": "Railway NER, Bareilly"
            },
            "1130008@8@N": {
              "name": "Baheri Court Complex"
            },
            "1130009@2,3,4,5,6,7@N": {
              "name": "Bareilly District Court Complex"
            },
            "1130010@12@N": {
              "name": "Faridpur"
            },
            "1130011@9@N": {
              "name": "Civil Judge Junior Division, Aonla"
            },
            "1130012@13@N": {
              "name": "CJJD, Nawabganj"
            },
            "1130013@11@N": {
              "name": "NR Bareilly"
            },
            "1130188@14@N": {
              "name": "Commercial Court Bareilly"
            }
          }
        },
        "3": {
          "name": "Gorakhpur",
          "courtComplexes": {
            "1130014@9@N": {
              "name": "Railway Court Gorakhpur"
            },
            "1130015@2,3,4,5,6,7@N": {
              "name": "Gorakhpur District Court Complex"
            },
            "1130016@8@N": {
              "name": "Bansgaon Court Complex"
            },
            "1130182@10@N": {
              "name": "Commercial Court Gorakhpur"
            },
            "1370077@11@N": {
              "name": "Motor Accident Claim Tribunal, Gorakhpur"
            }
          }
        },
        "4": {
          "name": "Hardoi",
          "courtComplexes": {
            "1130017@2,3,4,5,6@N": {
              "name": "Hardoi District Court Complex"
            },
            "1370098@7@N": {
              "name": "Gram Nyayalaya Sandila"
            }
          }
        },
        "5": {
          "name": "Chitrakoot",
          "courtComplexes": {
            "1130018@2,3,4,5,6@N": {
              "name": "Chitrakoot District Court Complex"
            },
            "1130019@7@N": {
              "name": "Court Complex, Mau"
            }
          }
        },
        "6": {
          "name": "Meerut",
          "courtComplexes": {
            "1130020@7@N": {
              "name": "Sardhana Court Complex"
            },
            "1130021@2,3,4,5,6,9@N": {
              "name": "Meerut District Court Complex"
            },
            "1130022@8@N": {
              "name": "Mawana Court Complex"
            },
            "1130191@10@N": {
              "name": "Commercial Court Meerut"
            },
            "1370078@11@N": {
              "name": "Motor Accident Claim Tribunal, Meerut South"
            }
          }
        },
        "7": {
          "name": "Bahraich",
          "courtComplexes": {
            "1130023@2,3,4,5,6@N": {
              "name": "Bahraich District Court Complex"
            }
          }
        },
        "8": {
          "name": "Ghaziabad",
          "courtComplexes": {
            "1130024@2,3,4,5,6,7@N": {
              "name": "Ghaziabad District Court Complex"
            },
            "1130025@8@N": {
              "name": "Railway Court Ghaziabad"
            },
            "1130196@9@N": {
              "name": "Gram Nyayalaya Modinagar"
            },
            "1370082@10@N": {
              "name": "Motor Accident Claim Tribunal, Ghaziabad"
            }
          }
        },
        "9": {
          "name": "Fatehpur",
          "courtComplexes": {
            "1130026@2,3,4,5,7@N": {
              "name": "Fatehpur District Court Complex"
            },
            "1130027@6@N": {
              "name": "Court Complex, Khaga"
            }
          }
        },
        "10": {
          "name": "Lakhimpur Kheri",
          "courtComplexes": {
            "1130028@7,8,9@N": {
              "name": "Mohammadi Court Complex"
            },
            "1130029@2,3,4,5,6@N": {
              "name": "Kheri  District Court Complex"
            },
            "1370056@10@N": {
              "name": "Taluka Court, Nighasan"
            },
            "1370090@11@N": {
              "name": "Motor Accident Claim Tribunal, Lakhimpur"
            }
          }
        },
        "11": {
          "name": "Shravasti",
          "courtComplexes": {
            "1130030@2,3,4,5,6@N": {
              "name": "Shravasti District Court Complex"
            }
          }
        },
        "12": {
          "name": "Jaunpur",
          "courtComplexes": {
            "1130031@2,3,4,5,6@N": {
              "name": "Jaunpur District Court Complex"
            }
          }
        },
        "13": {
          "name": "Pilibhit",
          "courtComplexes": {
            "1130032@2,3,4,5,11@N": {
              "name": "Pilibhit District Court Complex"
            },
            "1130033@9,10@N": {
              "name": "Bisalpur Court Complex"
            },
            "1370087@12@N": {
              "name": "Motor Accident Claim Tribunal, Pilibhit"
            }
          }
        },
        "14": {
          "name": "Mainpuri",
          "courtComplexes": {
            "1130034@2,3,4,5,6@N": {
              "name": "Mainpuri District Court Complex"
            },
            "1370099@7@N": {
              "name": "Gram Nyayalaya Karhal"
            }
          }
        },
        "15": {
          "name": "Ambedkar Nagar",
          "courtComplexes": {
            "1130035@2,3,4,5,7@N": {
              "name": "AmbedkarNagar DistrictCourt Complex"
            },
            "1130036@6@N": {
              "name": "Court Complex, Tanda"
            }
          }
        },
        "16": {
          "name": "Sitapur",
          "courtComplexes": {
            "1130037@7@N": {
              "name": "Mahmoodabad District Court Complex"
            },
            "1130038@9@N": {
              "name": "Biswan Court Complex"
            },
            "1130039@2,3,4,5,6,8@N": {
              "name": "Sitapur District Court Complex"
            },
            "1130193@10@N": {
              "name": "Gram Nyaylay Sidhauli"
            }
          }
        },
        "17": {
          "name": "Auraiya",
          "courtComplexes": {
            "1130040@7@N": {
              "name": "Court Complex, Bidhuna"
            },
            "1130041@2,3,4,5,6@N": {
              "name": "Auraiya District Court Complex"
            },
            "1370086@8@N": {
              "name": "Motor Accident Claim Tribunal, Auraiya"
            }
          }
        },
        "18": {
          "name": "Budaun",
          "courtComplexes": {
            "1130042@6@N": {
              "name": "Bisauli Court Complex"
            },
            "1130044@7@N": {
              "name": "Sahaswan Court Complex"
            },
            "1130045@2,3,4,5,9@N": {
              "name": "Budaun District Court Complex"
            },
            "1130195@10@N": {
              "name": "Gram Nyayalaya Bilsi"
            }
          }
        },
        "19": {
          "name": "Kanpur Nagar",
          "courtComplexes": {
            "1130046@2,3,4,5,6,7,8@N": {
              "name": "Kanpur Nagar District Court Complex"
            },
            "1130189@8@N": {
              "name": "Commercial Court Kanpur Nagar"
            }
          }
        },
        "20": {
          "name": "Gautam Buddha Nagar",
          "courtComplexes": {
            "1130047@7@N": {
              "name": "Court Complex, Jewar"
            },
            "1130048@2,3,4,5,6@N": {
              "name": "G B Nagar District Court Complex"
            },
            "1130183@8@N": {
              "name": "Commercial Court Gautam Buddha Naga"
            },
            "1370094@9@N": {
              "name": "Motor Accident Claim Tribunal, Gautam Budha Nagar"
            }
          }
        },
        "21": {
          "name": "Ballia",
          "courtComplexes": {
            "1130049@2,3,4,5,6@N": {
              "name": "Ballia District Court Complex"
            }
          }
        },
        "22": {
          "name": "Bhadohi SR Nagar",
          "courtComplexes": {
            "1130050@2,3,4,5,6@N": {
              "name": "Bhadohi District Court Complex"
            },
            "1370085@7@N": {
              "name": "Motor Accident Claim Tribunal, Bhadohi"
            }
          }
        },
        "23": {
          "name": "Lalitpur",
          "courtComplexes": {
            "1130051@6,7,9@N": {
              "name": "Mehrauni Court Complex"
            },
            "1130052@10,11@N": {
              "name": "Gram Nyaylay Talbehat"
            },
            "1130053@2,3,4,5,8@N": {
              "name": "Lalitpur District Court Complex"
            }
          }
        },
        "24": {
          "name": "Lucknow",
          "courtComplexes": {
            "1130054@8@N": {
              "name": "Railway NER, Lucknow"
            },
            "1130055@2,3,4,5,6,7@N": {
              "name": "Lucknow District Court Complex"
            },
            "1130056@9@N": {
              "name": "Railway NR, Lucknow"
            },
            "1130180@10@N": {
              "name": "Commercial Court Lucknow"
            }
          }
        },
        "25": {
          "name": "Etah",
          "courtComplexes": {
            "1130092@2,3,4,5,6@N": {
              "name": "Deoria District Court Complex"
            }
          }
        },
        "26": {
          "name": "Muzaffarnagar",
          "courtComplexes": {
            "1130059@6@N": {
              "name": "Buddhana Court Complex"
            },
            "1130060@2,3,4,5,11@N": {
              "name": "Muzaffar Nagar  District Court Comp"
            }
          }
        },
        "27": {
          "name": "Varanasi",
          "courtComplexes": {
            "1130062@9@N": {
              "name": "Railway Court NR, Varanasi"
            },
            "1130063@8@N": {
              "name": "NER, Varanasi"
            },
            "1130064@2,3,4,5,6,7@N": {
              "name": "Varanasi District Court Complex"
            },
            "1130187@10@N": {
              "name": "Commercial Court Varanasi"
            },
            "1370095@11@N": {
              "name": "Gram Nyayalay Pindara"
            }
          }
        },
        "28": {
          "name": "Ghazipur",
          "courtComplexes": {
            "1130065@7@N": {
              "name": "Mohammdabad Court Complex"
            },
            "1130066@2,3,4,5,8@N": {
              "name": "Ghazipur District Court Complex"
            },
            "1130067@6@N": {
              "name": "Saidpur Court Complex"
            }
          }
        },
        "29": {
          "name": "Firozabad",
          "courtComplexes": {
            "1130068@2,3,4,5,6@N": {
              "name": "Firozabad District Court Complex"
            }
          }
        },
        "30": {
          "name": "Agra",
          "courtComplexes": {
            "1130069@9@N": {
              "name": "Railway Court, Agra"
            },
            "1130070@2,3,4,5,6,7@N": {
              "name": "Agra District Court Complex"
            },
            "1130071@8@N": {
              "name": "CJJD, Fatehabad"
            },
            "1130190@10@N": {
              "name": "Commercial Court Agra"
            },
            "1370083@11@N": {
              "name": "Motor Accident Claim Tribunal, Agra"
            }
          }
        },
        "31": {
          "name": "Pratapgarh",
          "courtComplexes": {
            "1130072@6,7@N": {
              "name": "Kunda Court Complex"
            },
            "1130073@8@N": {
              "name": "Lalganj Court Complex"
            },
            "1130074@2,3,4,5,9@N": {
              "name": "Pratapgarh District Court Complex"
            },
            "1370040@11@N": {
              "name": "Civil Judge Senior Division"
            },
            "1370084@13@N": {
              "name": "Motor Accident Claim Tribunal, Pratapgarh"
            }
          }
        },
        "33": {
          "name": "Etawah",
          "courtComplexes": {
            "1130075@2,3,4,5,6@N": {
              "name": "Etawah District Court Complex"
            }
          }
        },
        "34": {
          "name": "Kushinagar",
          "courtComplexes": {
            "1130076@6,7@N": {
              "name": "Kasia Court Complex"
            },
            "1130077@2,3,4,5,8@N": {
              "name": "Kushinagar District Court Complex"
            }
          }
        },
        "35": {
          "name": "Amroha",
          "courtComplexes": {
            "1130078@6@N": {
              "name": "Hasanpur Court Complex"
            },
            "1130079@2,3,4,5,7@N": {
              "name": "Amroha District Court Complex"
            }
          }
        },
        "36": {
          "name": "Barabanki",
          "courtComplexes": {
            "1130080@5@N": {
              "name": "Court Complex Ramsanehighat"
            },
            "1130081@8@N": {
              "name": "Court Complex, Haidergarh"
            },
            "1130082@2,3,4,6,7@N": {
              "name": "Barabanki District Court Complex"
            }
          }
        },
        "37": {
          "name": "Kaushambi",
          "courtComplexes": {
            "1130083@2,3,4,5,6,7@N": {
              "name": "Kaushambi District Court Complex"
            },
            "1370031@8@N": {
              "name": "Gram Nyayalaya Chail"
            }
          }
        },
        "38": {
          "name": "Mahoba",
          "courtComplexes": {
            "1130084@7@N": {
              "name": "Charkari Court Complex"
            },
            "1130085@2,3,4,5,6@N": {
              "name": "Mahoba District Court Complex"
            },
            "1130086@8@N": {
              "name": "Kulpahar District Court Complex"
            },
            "1370088@9@N": {
              "name": "Motor Accident Claim Tribunal, Mahoba"
            }
          }
        },
        "39": {
          "name": "Banda",
          "courtComplexes": {
            "1130087@9@N": {
              "name": "Railway Court, Banda"
            },
            "1130088@2,3,4,5,8@N": {
              "name": "Banda District Court Complex"
            },
            "1130089@6@N": {
              "name": "Court Complex, Atarra"
            },
            "1130090@7@N": {
              "name": "Court Complex, Baberu"
            }
          }
        },
        "40": {
          "name": "Kasganj",
          "courtComplexes": {
            "1130091@2,3,4,5,6@N": {
              "name": "Kasganj District Court Complex"
            }
          }
        },
        "41": {
          "name": "Deoria",
          "courtComplexes": {
            "1130092@2,3,4,5,6@N": {
              "name": "Deoria District Court Complex"
            }
          }
        },
        "42": {
          "name": "Mau",
          "courtComplexes": {
            "1130093@2,3,4,5,6@N": {
              "name": "Mau District Court Complex"
            }
          }
        },
        "43": {
          "name": "Aligarh",
          "courtComplexes": {
            "1130094@8@N": {
              "name": "Iglas Court Complex"
            },
            "1130095@10@N": {
              "name": "ACJM, Railway Court, Aligarh"
            },
            "1130096@7@N": {
              "name": "Atrauli Court Complex"
            },
            "1130097@11@N": {
              "name": "Court Complex, Khair"
            },
            "1130098@2,3,4,5,6,9@N": {
              "name": "Aligarh District Court Complex"
            },
            "1130185@12@N": {
              "name": "Commercial Court Aligarh"
            },
            "1130192@13@N": {
              "name": "Gram Nyaylay Gabhana"
            }
          }
        },
        "44": {
          "name": "Azamgarh",
          "courtComplexes": {
            "1130099@2,3,4,5,6@N": {
              "name": "Azamgarh  District Court Complex"
            },
            "1370046@10@N": {
              "name": "Gram Nyayalay Burhanpur"
            },
            "1370047@9@N": {
              "name": "Gram Nyayalaya Phulpur"
            },
            "1370048@8@N": {
              "name": "Gram Nyayalaya Lalganj"
            },
            "1370049@7@N": {
              "name": "Gram Nyayalaya Mehanagar"
            }
          }
        },
        "45": {
          "name": "Baghpat",
          "courtComplexes": {
            "1130100@2,3,4,5,6@N": {
              "name": "Baghpat District Court Complex"
            }
          }
        },
        "46": {
          "name": "Basti",
          "courtComplexes": {
            "1130101@2,3,4,5,7@N": {
              "name": "Basti District Court Complex"
            },
            "1130102@6@N": {
              "name": "Court Complex, Khalilabdad"
            },
            "1370081@11@N": {
              "name": "Motor Accident Claim Tribunal, Basti"
            }
          }
        },
        "47": {
          "name": "Bijnor",
          "courtComplexes": {
            "1130103@2,3,4,5,6,7@N": {
              "name": "Bijnor District Court Complex"
            },
            "1130104@8,9,10@N": {
              "name": "Nagina  Court Complex"
            },
            "1130105@12@N": {
              "name": "Court Complex, Chandpur"
            },
            "1130106@11@N": {
              "name": "Najibabad Court Complex"
            }
          }
        },
        "48": {
          "name": "Bulandshahr",
          "courtComplexes": {
            "1130107@11,12,13@N": {
              "name": "Court Complex, Khurja"
            },
            "1130108@2,3,4,5,6,7@N": {
              "name": "Bulandshahar District Court Complex"
            },
            "1130109@8,9,10@N": {
              "name": "Court Complex, Anoopshahar"
            }
          }
        },
        "49": {
          "name": "Ayodhya",
          "courtComplexes": {
            "1130110@2,3,4,5,6,7@N": {
              "name": "Ayodhya District Court Complex"
            },
            "1130184@8@N": {
              "name": "Commercial Court Ayodhya"
            },
            "1370092@9@N": {
              "name": "Motor Accident Claim Tribunal, Ayodhya"
            }
          }
        },
        "50": {
          "name": "Gonda",
          "courtComplexes": {
            "1130111@2,3,4,5,6@N": {
              "name": "Gonda District Court Complex"
            },
            "1130112@7@N": {
              "name": "Railway Court Gonda"
            }
          }
        },
        "51": {
          "name": "Kanpur Dehat",
          "courtComplexes": {
            "1130113@8@N": {
              "name": "Ghatampur"
            },
            "1130114@7@N": {
              "name": "Bhognipur"
            },
            "1130115@2,3,4,5,6@N": {
              "name": "Kanpur Dehat District Court Complex"
            }
          }
        },
        "52": {
          "name": "Maharajganj",
          "courtComplexes": {
            "1130116@7@N": {
              "name": "Pharenda"
            },
            "1130117@2,3,4,5,6@N": {
              "name": "Maharjganj District Court Complex"
            },
            "1370089@8@N": {
              "name": "Motor Accident Claim Tribunal, Maharajganj"
            }
          }
        },
        "53": {
          "name": "Mathura",
          "courtComplexes": {
            "1130118@8@N": {
              "name": "Railway Court"
            },
            "1130119@2,3,4,5,7@N": {
              "name": "Mathura District Court Complex"
            },
            "1130120@6@N": {
              "name": "Chhata Court Complex"
            }
          }
        },
        "54": {
          "name": "Moradabad",
          "courtComplexes": {
            "1130121@2,3,4,5,6,12,15@N": {
              "name": "Moradabad District Court Complex"
            },
            "1130122@14@N": {
              "name": "Railway Court Moradabad"
            },
            "1130123@13@N": {
              "name": "Outlying Court Thakurdwara"
            },
            "1370093@16@N": {
              "name": "Motor Accident Claim Tribunal, Moradabad"
            }
          }
        },
        "55": {
          "name": "Raebareli",
          "courtComplexes": {
            "1130126@2,3,4,5,6@N": {
              "name": "Raebareli District Court Complex"
            },
            "1370091@10@N": {
              "name": "Motor Accident Claim Tribunal, Raebareli"
            }
          }
        },
        "56": {
          "name": "Rampur",
          "courtComplexes": {
            "1130127@2,3,4,5,6@N": {
              "name": "Rampur District Court Complex"
            }
          }
        },
        "57": {
          "name": "Saharanpur",
          "courtComplexes": {
            "1130128@2,3,4,5,6,7@N": {
              "name": "Saharanpur District Court Complex"
            },
            "1130129@8,9,10,11@N": {
              "name": "Deoband"
            }
          }
        },
        "58": {
          "name": "Shahjahanpur",
          "courtComplexes": {
            "1130130@8@N": {
              "name": "Tilhar"
            },
            "1130131@7@N": {
              "name": "Puwayein"
            },
            "1130132@2,3,4,5,6@N": {
              "name": "Shahjahanpur District Court Complex"
            },
            "1130133@9@N": {
              "name": "Jalalabad"
            }
          }
        },
        "59": {
          "name": "Siddharthnagar",
          "courtComplexes": {
            "1130134@2,3,4,5,10@N": {
              "name": "Sidharth Nagar District Court Compl"
            },
            "1130135@11@N": {
              "name": "CJSD, Dumariaganj"
            },
            "1130136@7,8,9@N": {
              "name": "Bansi Court Complex"
            },
            "1370069@12@N": {
              "name": "Gram Nyayalaya Etwa"
            }
          }
        },
        "60": {
          "name": "Sonbhadra",
          "courtComplexes": {
            "1130137@2,3,4,5,8@N": {
              "name": "Sonebhadra District Court Complex"
            },
            "1130138@6@N": {
              "name": "Duddhi Court Complex"
            },
            "1130139@7@N": {
              "name": "Anpara at Obra"
            }
          }
        },
        "61": {
          "name": "Sultanpur",
          "courtComplexes": {
            "1130140@2,3,4,5,6@N": {
              "name": "Sultanpur District Court Complex"
            },
            "1130141@7@N": {
              "name": "CJJD, Kadipur"
            },
            "1130142@8@N": {
              "name": "CJJD, Musafirkhana"
            }
          }
        },
        "62": {
          "name": "Unnao",
          "courtComplexes": {
            "1130143@2,3,4,5,6@N": {
              "name": "Unnao District Court Complex"
            },
            "1130144@7@N": {
              "name": "Purva"
            },
            "1370066@8@N": {
              "name": "Taluka Court Safipur"
            }
          }
        },
        "63": {
          "name": "Farrukhabad",
          "courtComplexes": {
            "1130145@8@N": {
              "name": "Railway Court, Farrukhabad"
            },
            "1130146@2,3,4,5,7@N": {
              "name": "Farrukhabad  District Court Complex"
            },
            "1130147@6@N": {
              "name": "Kayamganj Court Complex"
            }
          }
        },
        "64": {
          "name": "Hamirpur",
          "courtComplexes": {
            "1130148@7@N": {
              "name": "Rath Court Complex"
            },
            "1130149@6@N": {
              "name": "Maudaha Court Complex"
            },
            "1130150@2,3,4,5,8@N": {
              "name": "Hamirpur District Court Complex"
            }
          }
        },
        "65": {
          "name": "Hathras",
          "courtComplexes": {
            "1130151@8,9@N": {
              "name": "Sadabad Court Complex"
            },
            "1130152@6@N": {
              "name": "Outlying Court Sikandra Rao"
            },
            "1130153@2,3,4,5,7@N": {
              "name": "Hathras District Court Complex"
            }
          }
        },
        "66": {
          "name": "Jhansi",
          "courtComplexes": {
            "1130154@2,3,4,5,6,14@N": {
              "name": "Jhansi District Court Complex"
            },
            "1130155@13@N": {
              "name": "Jhansi Railway Court Complex"
            },
            "1130156@11,12,16,17@N": {
              "name": "Taluka Court Garautha"
            },
            "1130157@9,10@N": {
              "name": "Mauranipur Court Complex"
            },
            "1130158@7,8@N": {
              "name": "Moth Court Complex"
            },
            "1130181@15@N": {
              "name": "Commercial Court Jhansi"
            }
          }
        },
        "67": {
          "name": "Balrampur",
          "courtComplexes": {
            "1130159@7@N": {
              "name": "Court Complex, Utraula"
            },
            "1130160@2,3,4,5,6@N": {
              "name": "Balrampur District Court Complex"
            },
            "1370035@8@N": {
              "name": "Gram Nyaylay Tulsipur"
            }
          }
        },
        "68": {
          "name": "Mirzapur",
          "courtComplexes": {
            "1130161@2,3,4,5,6,7@N": {
              "name": "Mirzapur District Court Complex"
            }
          }
        },
        "69": {
          "name": "Kannauj",
          "courtComplexes": {
            "1130162@2,3,4,5,6@N": {
              "name": "Kannauj District Court Complex"
            },
            "1130163@7,8@N": {
              "name": "Chhibramau Court Complex"
            },
            "1370071@9@N": {
              "name": "Motor Accident Claim Tribunal"
            }
          }
        },
        "70": {
          "name": "Jalaun",
          "courtComplexes": {
            "1130164@8@N": {
              "name": "Konch Court Complex"
            },
            "1130165@2,3,4,5,6,7,10@N": {
              "name": "Jalaun District Court Complex"
            },
            "1130166@9@N": {
              "name": "Kalpi Court Complex"
            }
          }
        },
        "71": {
          "name": "Santkabir Nagar",
          "courtComplexes": {
            "1130167@2,3,4,5,6@N": {
              "name": "S K Nagar District Court Complex"
            },
            "1130194@7@N": {
              "name": "Gram Nyayalaya Menhdawal"
            }
          }
        },
        "73": {
          "name": "Hapur",
          "courtComplexes": {
            "1130168@5@N": {
              "name": "Garhmukteshwar Court Complex"
            },
            "1130169@1,2,3,4,6@N": {
              "name": "Hapur Court Complex"
            }
          }
        },
        "74": {
          "name": "Sambhal at Chandausi",
          "courtComplexes": {
            "1130170@5@N": {
              "name": "Court Complex Sambhal"
            },
            "1130171@1,2,3,4@N": {
              "name": "Chandausi Court Complex"
            },
            "1130172@6@N": {
              "name": "Court Complex Gunnaur"
            },
            "1130173@7,8,9,10,11@N": {
              "name": "Sambhal at Chandausi"
            }
          }
        },
        "75": {
          "name": "Chandauli",
          "courtComplexes": {
            "1130174@6@N": {
              "name": "Chakia Court Complex"
            },
            "1130175@1,2,3,4,5@N": {
              "name": "Chandauli"
            },
            "1130178@7@N": {
              "name": "Railway Court Chandauli"
            }
          }
        },
        "76": {
          "name": "Shamli at Kairana",
          "courtComplexes": {
            "1130176@6,7,8,9@N": {
              "name": "Court Complex Kairana"
            },
            "1130177@1,2,3,4,5@N": {
              "name": "Shamli"
            }
          }
        }
      }
    },
    "14": {
      "name": "Haryana",
      "districts": {
        "1": {
          "name": "Karnal",
          "courtComplexes": {
            "1140007@2,5@N": {
              "name": "Judicial Court Complex, Assandh"
            },
            "1140008@6,7@N": {
              "name": "Judicial Court Complex, Indri"
            },
            "1140009@1,3,4@N": {
              "name": "District and Sessions Court Complex , Karnal"
            },
            "1370074@8,9@N": {
              "name": "Judicial Court Complex, Gharaunda"
            }
          }
        },
        "2": {
          "name": "Sirsa",
          "courtComplexes": {
            "1140010@6,7@N": {
              "name": "Judicial Complex, Ellenabad"
            },
            "1140011@1,3,4@N": {
              "name": "District Court, Sirsa"
            },
            "1140012@8,9@N": {
              "name": "Gramnayalya Complex, Rania"
            },
            "1140013@2,5@N": {
              "name": "Judicial Complex, Dabwali"
            }
          }
        },
        "3": {
          "name": "Ambala",
          "courtComplexes": {
            "1140014@2,5@N": {
              "name": "Judicial Complex, Naraingarh"
            },
            "1140015@7@N": {
              "name": "Family Complex, Naraingarh"
            },
            "1140016@1,3,4@N": {
              "name": "District Court, Ambala"
            },
            "1140017@6@N": {
              "name": "Railway Complex, Ambala Cantt"
            }
          }
        },
        "4": {
          "name": "Bhiwani",
          "courtComplexes": {
            "1140018@1,5,6@N": {
              "name": "District Court, Bhiwani"
            },
            "1140019@3,8,13@N": {
              "name": "Judicial Complex, Loharu"
            },
            "1140020@10,11,14@N": {
              "name": "Judicial Complex, Tosham"
            },
            "1140022@4,9,15@N": {
              "name": "Judicial Complex, Siwani"
            }
          }
        },
        "5": {
          "name": "Faridabad",
          "courtComplexes": {
            "1140023@1,2,3@N": {
              "name": "District Court, Faridabad"
            }
          }
        },
        "6": {
          "name": "Gurugram",
          "courtComplexes": {
            "1140024@1,2,3@N": {
              "name": "District Court, Gurugram"
            },
            "1140025@6,7@N": {
              "name": "Judicial Complex, Sohna"
            },
            "1140026@4,5@N": {
              "name": "Judicial Complex, Pataudi"
            }
          }
        },
        "7": {
          "name": "Hisar",
          "courtComplexes": {
            "1140027@1,5,6@N": {
              "name": "Judicial Complex, Hansi"
            },
            "1140028@2,3,4@N": {
              "name": "District Court, Hisar"
            }
          }
        },
        "8": {
          "name": "Jhajjar",
          "courtComplexes": {
            "1140029@2,5@N": {
              "name": "Judicial Complex, Bahadurgarh"
            },
            "1140030@1,3,4@N": {
              "name": "District Court, Jhajjar"
            }
          }
        },
        "9": {
          "name": "Jind",
          "courtComplexes": {
            "1140031@3,7@N": {
              "name": "Judicial Court Complex , Safidon"
            },
            "1140032@1,4,5@N": {
              "name": "District Court, Jind"
            },
            "1140033@2,6@N": {
              "name": "Judicial Complex, Narwana"
            }
          }
        },
        "10": {
          "name": "Kurukshetra",
          "courtComplexes": {
            "1140034@1,3,4@N": {
              "name": "District Court, Kurukshetra"
            },
            "1140035@6,7@N": {
              "name": "Judicial Complex, Shahabad"
            },
            "1140036@2,5@N": {
              "name": "Judicial Complex, Pehowa"
            }
          }
        },
        "11": {
          "name": "Narnaul",
          "courtComplexes": {
            "1140037@2,6,9@N": {
              "name": "Judicial Complex, Mohindergarh"
            },
            "1140038@1,4,5@N": {
              "name": "District Court, Narnaul"
            },
            "1140039@7,8,10@N": {
              "name": "Judicial Complex, Kanina"
            }
          }
        },
        "12": {
          "name": "Rohtak",
          "courtComplexes": {
            "1140040@2,5,6@N": {
              "name": "Judicial Complex, Meham"
            },
            "1140041@1,3,4@N": {
              "name": "District Court, Rohtak"
            }
          }
        },
        "13": {
          "name": "Sonepat",
          "courtComplexes": {
            "1140042@7,8,12@N": {
              "name": "Judicial Complex, Gohana"
            },
            "1140043@9,10,11@N": {
              "name": "Judicial Complex, Kharkhoda"
            },
            "1140044@2,6,13@N": {
              "name": "Judicial Complex, Ganaur"
            },
            "1140046@1,4,5@N": {
              "name": "District Court, Sonepat"
            }
          }
        },
        "14": {
          "name": "Panchkula",
          "courtComplexes": {
            "1140047@1,2,3@N": {
              "name": "District Court, Panchkula"
            },
            "1140048@4,5,6@N": {
              "name": "Judicial Complex, Kalka"
            }
          }
        },
        "15": {
          "name": "Fatehabad",
          "courtComplexes": {
            "1140049@3,7@N": {
              "name": "Judicial Complex, Tohana"
            },
            "1140050@2,6@N": {
              "name": "Judicial Complex, Ratia"
            },
            "1140051@1,4,5@N": {
              "name": "District Court, Fatehabad"
            }
          }
        },
        "16": {
          "name": "Kaithal",
          "courtComplexes": {
            "1140052@1,3,4@N": {
              "name": "District Court, Kaithal"
            },
            "1140053@2,5@N": {
              "name": "Judicial Complex, Guhla"
            }
          }
        },
        "17": {
          "name": "Rewari",
          "courtComplexes": {
            "1140054@2,6@N": {
              "name": "Judicial Complex, Kosli"
            },
            "1140055@7,8@N": {
              "name": "Judicial Complex, Bawal"
            },
            "1140056@1,4,5@N": {
              "name": "District Court, Rewari"
            }
          }
        },
        "18": {
          "name": "Panipat",
          "courtComplexes": {
            "1140057@4,5@N": {
              "name": "Judicial Complex, Samalkha"
            },
            "1140058@1,2,3@N": {
              "name": "District Court, Panipat"
            }
          }
        },
        "19": {
          "name": "Nuh",
          "courtComplexes": {
            "1140059@1,3,4@N": {
              "name": "District Court, Nuh"
            },
            "1140060@5,6@N": {
              "name": "Judicial Complex, Ferozepur Jhirka"
            },
            "1140067@7,8@N": {
              "name": "Judicial Complex, Punhana"
            }
          }
        },
        "20": {
          "name": "Yamunanagar",
          "courtComplexes": {
            "1140061@1,2,3,4,5,6@N": {
              "name": "District Court, Yamunanagar"
            },
            "1140062@4,5@N": {
              "name": "Judicial Complex, Bilaspur"
            }
          }
        },
        "23": {
          "name": "Palwal",
          "courtComplexes": {
            "1140063@4,5@N": {
              "name": "Judicial Complex, Hodal"
            },
            "1140064@1,2,3@N": {
              "name": "District Court, Palwal"
            },
            "1140065@6,7@N": {
              "name": "Judicial Complex, Hathin"
            }
          }
        },
        "88": {
          "name": "Charkhi Dadri",
          "courtComplexes": {
            "1140021@1,2,3@N": {
              "name": "Judicial Court Complex, Charkhi Dadri"
            }
          }
        }
      }
    },
    "15": {
      "name": "Uttarakhand",
      "districts": {
        "1": {
          "name": "Nainital",
          "courtComplexes": {
            "1150003@1,4,5,6@N": {
              "name": "District Court Nainital"
            },
            "1150004@7,8,9,10@N": {
              "name": "Civil Court Haldwani"
            },
            "1150005@14,15@N": {
              "name": "Civil Court Dhari"
            },
            "1150006@3,11,12,13@N": {
              "name": "Civil Court Ramnager"
            },
            "1150078@16@N": {
              "name": "Family Court Nainital"
            },
            "1150079@17@N": {
              "name": "Family Court Haldwani"
            },
            "1150085@18@N": {
              "name": "Commercial Court Haldwani"
            },
            "1370025@19@N": {
              "name": "Railway Court Haldwani"
            },
            "1370028@20@N": {
              "name": "Juvenile Justice Board Haldwani"
            }
          }
        },
        "2": {
          "name": "Pauri Garhwal",
          "courtComplexes": {
            "1150007@2,3,4,5@N": {
              "name": "District Court Pauri Garhwal"
            },
            "1150008@11,12@N": {
              "name": "Civil Court Dhumakot"
            },
            "1150009@13,14@N": {
              "name": "Civil Court Srinagar"
            },
            "1150010@15,16@N": {
              "name": "Civil Court Lansdowne"
            },
            "1150011@6,7,8,9@N": {
              "name": "Civil Court Kotdwar"
            },
            "1150012@10@N": {
              "name": "Family Court Pauri Garhwal"
            },
            "1150067@17@N": {
              "name": "Juvenile Justice Board Pauri"
            },
            "1150080@18@N": {
              "name": "Family Court Kotdwar"
            }
          }
        },
        "3": {
          "name": "Tehri Garhwal",
          "courtComplexes": {
            "1150013@2,3,4,5@N": {
              "name": "District Court Tehri Garhwal"
            },
            "1150014@8,9@N": {
              "name": "Civil Court Kirti Nagar"
            },
            "1150015@10,11@N": {
              "name": "Civil Court Pratapnagar"
            },
            "1150016@6,7@N": {
              "name": "Civil Court Narendra Nagar"
            },
            "1150074@12@N": {
              "name": "Juvenile Justice Board, Tehri"
            },
            "1150077@13@N": {
              "name": "Family Court Tehri Garhwal"
            }
          }
        },
        "4": {
          "name": "Udham Singh Nagar",
          "courtComplexes": {
            "1150017@3,4,5,6@N": {
              "name": "District Court U S Nagar"
            },
            "1150018@16,17@N": {
              "name": "Civil Court Jaspur"
            },
            "1150019@7,8,9,10@N": {
              "name": "Civil Court Kashipur"
            },
            "1150020@14,15@N": {
              "name": "Civil Court Bazpur"
            },
            "1150021@11,12,13@N": {
              "name": "Civil Court Khatima"
            },
            "1150022@18,19@N": {
              "name": "Civil Court Sitarganj"
            },
            "1150063@20@N": {
              "name": "Family Court Rudrapur"
            },
            "1150066@21@N": {
              "name": "Family Court-II Rudrapur"
            },
            "1150075@22@N": {
              "name": "Juvenile Justice Board U.S.Nagar"
            },
            "1150081@23,24@N": {
              "name": "Civil Court Kichha"
            },
            "1150082@25@N": {
              "name": "Family Court Kashipur"
            },
            "1150083@26@N": {
              "name": "Family Court Khatima"
            }
          }
        },
        "5": {
          "name": "Dehradun",
          "courtComplexes": {
            "1150023@12,13,14,15@N": {
              "name": "Civil Court Vikasnagar"
            },
            "1150024@17,18@N": {
              "name": "Civil Court Chakrata"
            },
            "1150025@21@N": {
              "name": "Family Court Dehradun"
            },
            "1150026@3,5,6,11@N": {
              "name": "Civil Court Rishikesh"
            },
            "1150027@8,9,10@N": {
              "name": "District Court Dehradun"
            },
            "1150028@7@N": {
              "name": "Family Court Rishikesh"
            },
            "1150029@2@N": {
              "name": "FTC court Dehradun"
            },
            "1150030@19,20@N": {
              "name": "Civil Court Doiwala"
            },
            "1150031@22@N": {
              "name": "Commercial Court Dehradun"
            },
            "1150032@16@N": {
              "name": "Family Court Vikasnagar"
            },
            "1150065@23,24@N": {
              "name": "Civil Court Mussoorie"
            },
            "1150070@25@N": {
              "name": "Juvenile Justice Board Dehradun"
            }
          }
        },
        "6": {
          "name": "Uttarkashi",
          "courtComplexes": {
            "1150033@2,3,4,5@N": {
              "name": "District Court Uttarkashi"
            },
            "1150034@8,9@N": {
              "name": "Civil Court Barkot"
            },
            "1150035@6,7@N": {
              "name": "Civil Court Purola"
            },
            "1150073@10@N": {
              "name": "Juvenile Justice Board, Uttarkashi"
            },
            "1370019@11@N": {
              "name": "Family Court Uttarkashi"
            }
          }
        },
        "7": {
          "name": "Almora",
          "courtComplexes": {
            "1150036@8,9@N": {
              "name": "Civil Court Bhikiyasain"
            },
            "1150037@6,7@N": {
              "name": "Civil Court Dwarahat"
            },
            "1150038@10,11,12@N": {
              "name": "Civil Court Ranikhet"
            },
            "1150039@2,3,4,5@N": {
              "name": "District Court Almora"
            },
            "1150040@13@N": {
              "name": "Family Court Almora"
            },
            "1150068@14@N": {
              "name": "Juvenile Justice Board Almora"
            }
          }
        },
        "8": {
          "name": "Chamoli",
          "courtComplexes": {
            "1150041@15,16@N": {
              "name": "Civil Court Joshimath"
            },
            "1150042@6,7@N": {
              "name": "Civil Court Pokhari"
            },
            "1150043@8,9,10,17@N": {
              "name": "Civil Court Karanprayag"
            },
            "1150044@13,14@N": {
              "name": "Civil Court Tharali"
            },
            "1150045@2,3,4,5@N": {
              "name": "District Court Chamoli"
            },
            "1150046@11,12@N": {
              "name": "Civil Court Gairsain"
            },
            "1150069@18@N": {
              "name": "Juvenile Justice Board Chamoli"
            },
            "1370006@19@N": {
              "name": "Family Court Chamoli"
            }
          }
        },
        "9": {
          "name": "Haridwar",
          "courtComplexes": {
            "1150047@12@N": {
              "name": "Family Court Roorkee"
            },
            "1150048@13,14,15,16@N": {
              "name": "Civil Court Laksar"
            },
            "1150049@1,3,4,5@N": {
              "name": "District Court Haridwar"
            },
            "1150050@6,7,8,9@N": {
              "name": "Civil Court Roorkree"
            },
            "1150051@10@N": {
              "name": "Family Court Haridwar"
            },
            "1150064@17@N": {
              "name": "Family Court Laksar"
            },
            "1150084@11@N": {
              "name": "Juvenile Justice Board Haridwar"
            }
          }
        },
        "13": {
          "name": "Champawat",
          "courtComplexes": {
            "1150052@2,3,4,5@N": {
              "name": "District Court Champawat"
            },
            "1150054@6,7@N": {
              "name": "Civil Court Tanakpur"
            },
            "1150086@8@N": {
              "name": "Juvenile Justice Board Champawat"
            },
            "1370005@9@N": {
              "name": "Family Court Champawat"
            }
          }
        },
        "14": {
          "name": "Bageshwar",
          "courtComplexes": {
            "1150055@6,7@N": {
              "name": "Civil Court Garur"
            },
            "1150056@2,3,4,5@N": {
              "name": "District Court Bageshwar"
            },
            "1150072@8@N": {
              "name": "Juvenile Justice Board Bageshwar"
            },
            "1370014@9@N": {
              "name": "Family Court Bageshwar"
            }
          }
        },
        "15": {
          "name": "Pithoragarh",
          "courtComplexes": {
            "1150057@10,11@N": {
              "name": "Civil Court Dharchula"
            },
            "1150058@2,3,4,5@N": {
              "name": "District Court Pithoragarh"
            },
            "1150059@8,9@N": {
              "name": "CIVIL COURT GANGOLIHAT"
            },
            "1150060@6,7@N": {
              "name": "Civil Court Didihat"
            },
            "1150076@12@N": {
              "name": "Juvenile Justice Board Pithoragarh"
            },
            "1370012@13@N": {
              "name": "Family Court Pithoragarh"
            }
          }
        },
        "16": {
          "name": "Rudraprayag",
          "courtComplexes": {
            "1150061@5,6@N": {
              "name": "CIVIL COURT UKHIMATH"
            },
            "1150062@1,2,3,4@N": {
              "name": "District Court Rudraprayag"
            },
            "1150071@7@N": {
              "name": "Juvenile Justice Board Rudraprayag"
            },
            "1370015@8@N": {
              "name": "Family Court Rudraprayag"
            }
          }
        }
      }
    },
    "16": {
      "name": "West Bengal",
      "districts": {
        "1": {
          "name": "Malda",
          "courtComplexes": {
            "1160002@2,3,4,5@N": {
              "name": "MALDA DISTRICT COURT COMPLEX"
            },
            "1160096@6,7,8,9@N": {
              "name": "Chanchal Court Complex"
            }
          }
        },
        "2": {
          "name": "Hooghly",
          "courtComplexes": {
            "1160003@7,8,9,18@N": {
              "name": "CHANDANNAGORE COURT COMPLEX"
            },
            "1160004@3,4,5,6@N": {
              "name": "CHINSURAH DISTRICT COURT COMPLEX"
            },
            "1160005@10,11,12,13@N": {
              "name": "SERAMPORE COURT COMPLEX"
            },
            "1160006@14,15,16,17@N": {
              "name": "ARAMBAGH COURT COMPLEX"
            }
          }
        },
        "3": {
          "name": "Calcutta",
          "courtComplexes": {
            "1160007@6@N": {
              "name": "CITY SESSIONS COURT COMPLEX"
            },
            "1160008@5@N": {
              "name": "CITY CIVIL COURT COMPLEX"
            },
            "1160009@7@N": {
              "name": "METROPOLITAN MAGISTRATE COURT COMPLEX"
            },
            "1160010@8@N": {
              "name": "MUNICIPAL MAGISTRATE COURT COMPLEX"
            },
            "1160011@4@N": {
              "name": "PRESIDENCY SMALL CAUSES COURT COMPLEX"
            }
          }
        },
        "4": {
          "name": "Jalpaiguri",
          "courtComplexes": {
            "1160013@6@N": {
              "name": "MAL BAZAR COURT COMPLEX"
            },
            "1160014@7@N": {
              "name": "RAILWAY COURT COMPLEX"
            },
            "1160015@2,3,4,5@N": {
              "name": "JALPAIGURI DISTRICT COURT COMPLEX"
            }
          }
        },
        "6": {
          "name": "Coochbehar",
          "courtComplexes": {
            "1160016@17,18,19@N": {
              "name": "MEKHLIGANJ COURT COMPLEX"
            },
            "1160017@16@N": {
              "name": "JUVENILE COURT COMPLEX"
            },
            "1160018@2,3,4,5@N": {
              "name": "COOCHBEHAR DISTRICT COURT COMPLEX"
            },
            "1160019@6,7,8,9@N": {
              "name": "DINHATA COURT COMPLEX"
            },
            "1160020@13,14,15@N": {
              "name": "MATHABHANGA COURT COMPLEX"
            },
            "1160021@10,11,12@N": {
              "name": "TUFANGANJ COURT COMPLEX"
            }
          }
        },
        "7": {
          "name": "Paschim Medinpur",
          "courtComplexes": {
            "1160022@2,3,4,5@N": {
              "name": "MEDINIPUR DISTRICT COURT COMPLEX"
            },
            "1160023@16,20,21,22@N": {
              "name": "KHARAGPUR COURT COMPLEX"
            },
            "1160024@12,13,14,15@N": {
              "name": "GHATAL COURT COMPLEX"
            },
            "1160025@10,11@N": {
              "name": "GARBETA COURT COMPLEX"
            },
            "1160026@18,19@N": {
              "name": "DANTAN COURT COMPLEX"
            }
          }
        },
        "8": {
          "name": "Birbhum",
          "courtComplexes": {
            "1160027@9,10,11,12@N": {
              "name": "RAMPURHAT COURT COMPLEX"
            },
            "1160028@6,7,8@N": {
              "name": "DUBRAJPUR COURT COMPLEX"
            },
            "1160029@2,3,4,5@N": {
              "name": "SURI DISTRICT COURT COMPLEX"
            },
            "1160030@13,14,15,16@N": {
              "name": "BOLPUR COURT COMPLEX"
            }
          }
        },
        "9": {
          "name": "Purba Medinipur",
          "courtComplexes": {
            "1160031@2,3,4,5@N": {
              "name": "TAMLUK DISTRICT COURT COMPLEX"
            },
            "1160032@10,11,12,13@N": {
              "name": "HALDIA COURT COMPLEX"
            },
            "1160033@6,7,8,9@N": {
              "name": "CONTAI COURT COMPLEX"
            }
          }
        },
        "10": {
          "name": "Purulia",
          "courtComplexes": {
            "1160034@6,7,8,9@N": {
              "name": "RAGHUNATH COURT COMPLEX"
            },
            "1160035@2,3,4,5@N": {
              "name": "PURULIA DISTRICT COURT COMPLEX"
            }
          }
        },
        "11": {
          "name": "Howrah",
          "courtComplexes": {
            "1160036@6,7,8@N": {
              "name": "AMTA COURT COMPLEX"
            },
            "1160037@9,10,11,12@N": {
              "name": "ULUBERIA COURT COMPLEX"
            },
            "1160038@5@N": {
              "name": "HOWRAH CRIMINIAL COURT COMPLEX"
            },
            "1160039@13@N": {
              "name": "RAILWAY MAGISTRATE COURT COMPLEX"
            },
            "1160040@2,3,4@N": {
              "name": "HOWRAH CIVIL COURT COMPLEX"
            }
          }
        },
        "12": {
          "name": "Murshidabad",
          "courtComplexes": {
            "1160041@2,3,4@N": {
              "name": "BERHAMPUR CIVIL COURT COMPLEX"
            },
            "1160042@11,12,13,14@N": {
              "name": "KANDI COURT COMPLEX"
            },
            "1160043@8,9,10@N": {
              "name": "LALBAGH CIVIL COURT COMPLEX"
            },
            "1160044@15,16,17,18@N": {
              "name": "JANGIPORE COURT COMPLEX"
            },
            "1160045@6,7@N": {
              "name": "LALBAGH CRIMINAL COURT COMPLEX"
            },
            "1160046@5@N": {
              "name": "BERHAMPUR CRIMINAL COURT"
            }
          }
        },
        "13": {
          "name": "South Dinajpur",
          "courtComplexes": {
            "1160047@2,3,4,5@N": {
              "name": "BALURGHAT DISTRICT COURT COMPLEX"
            },
            "1160048@6,7,8@N": {
              "name": "BUNIADPUR COURT COMPLEX"
            }
          }
        },
        "14": {
          "name": "North  Twenty Four Parganas",
          "courtComplexes": {
            "1160049@11,12,13@N": {
              "name": "BARRACKPUR COURT COMPLEX"
            },
            "1160050@14,15,16,17@N": {
              "name": "BONGAO COURT COMPLEX"
            },
            "1160051@7,8,9,10@N": {
              "name": "BASIRHAT COURT COMPLEX"
            },
            "1160052@3,4,5,6@N": {
              "name": "BARASAT DISTRICT COURT COMPLEX"
            },
            "1160053@18@N": {
              "name": "JUVENILE COURT COMPLEX SALT LAKE"
            },
            "1160054@2,19@N": {
              "name": "BIDHANAGAR COURT COMPLEX"
            },
            "1160055@20@N": {
              "name": "Commercial Court Rajarhat"
            },
            "1160094@21@N": {
              "name": "MP-MLA Court Complex"
            }
          }
        },
        "17": {
          "name": "Darjeeling",
          "courtComplexes": {
            "1160056@2,3,4@N": {
              "name": "DARJEELING DISTRICT COURT COMPLEX"
            },
            "1160057@6,7,8,9,10,21@N": {
              "name": "SILIGURI COURT COMPLEX"
            },
            "1160058@18,19,20,23@N": {
              "name": "KURSEONG COURT COMPLEX"
            },
            "1160059@22@N": {
              "name": "commercial court siliguri"
            },
            "1160060@14,15@N": {
              "name": "MIRIK COURT COMPLEX"
            },
            "1160062@16,17@N": {
              "name": "MUNGPOO COURT COMPLEX"
            }
          }
        },
        "18": {
          "name": "Purba Bardhaman",
          "courtComplexes": {
            "1160063@2,3,4,5@N": {
              "name": "PURBA BARDHAMAN DIST COURT COMPLEX"
            },
            "1160064@10,11,12,13@N": {
              "name": "KALNA COURT COMPLEX"
            },
            "1160065@18,19,20,21@N": {
              "name": "KATWA COURT COMPLEX"
            }
          }
        },
        "19": {
          "name": "Bankura",
          "courtComplexes": {
            "1160066@5,6,7,8@N": {
              "name": "KHATRA COURT COMPLEX"
            },
            "1160067@9,10,11,12@N": {
              "name": "BISHNUPUR COURT COMPLEX"
            },
            "1160068@1,2,3,4@N": {
              "name": "BANKURA DISTRICT COURT COMPLEX"
            }
          }
        },
        "20": {
          "name": "South Twenty Four Parganas",
          "courtComplexes": {
            "1160069@16,17,18@N": {
              "name": "DIAMOND HARBOUR CIVIL COURT COMPLEX"
            },
            "1160070@4@N": {
              "name": "RAILWAY MAGISTRATE COURT COMPLEX"
            },
            "1160071@11,12,13,14@N": {
              "name": "BARUIPUR COURT COMPLEX"
            },
            "1160072@22@N": {
              "name": "Alipur CBI Court Complex"
            },
            "1160073@7,8,9,10@N": {
              "name": "SEALDAH CRIMINAL COURT COMPLEX"
            },
            "1160074@19,20,21@N": {
              "name": "KAKDWIP COURT COMPLEX"
            },
            "1160075@1,2,3@N": {
              "name": "ALIPUR CIVIL COURT COMPLEX"
            },
            "1160076@15@N": {
              "name": "DIAMOND HARBOUR CRIMINAL COURT COMPLEX"
            },
            "1160077@5,6@N": {
              "name": "ALIPUR CRIMINAL COURT COMPLEX"
            },
            "1160078@23@N": {
              "name": "Commercial Court Alipur"
            }
          }
        },
        "21": {
          "name": "North Dinajpur",
          "courtComplexes": {
            "1160079@1,2,3,4@N": {
              "name": "RAIGANJ DISTRICT COURT COMPLEX"
            },
            "1160080@5,6,7,8@N": {
              "name": "ISLAMPUR COURT COMPLEX"
            }
          }
        },
        "22": {
          "name": "Nadia",
          "courtComplexes": {
            "1160081@1,2,3,4,15@N": {
              "name": "KALYANI COURT COMPLEX"
            },
            "1160082@12,13,14,22@N": {
              "name": "TEHATTA COURT COMPLEX"
            },
            "1160083@5,6,7,8@N": {
              "name": "KRISHNANAGAR DISTRICT COURT COMPLEX"
            },
            "1160084@9,10,11@N": {
              "name": "NABADWIP COURT COMPLEX"
            },
            "1160085@16,17,18,19,20,21@N": {
              "name": "RANAGHAT COURT COMPLEX"
            }
          }
        },
        "23": {
          "name": "kalimpong",
          "courtComplexes": {
            "1160086@5,6@N": {
              "name": "Gorubathan Court Complex"
            },
            "1160088@2,3,4@N": {
              "name": "KALIMPONG DISTRICT COURT COMPLEX"
            }
          }
        },
        "24": {
          "name": "Paschim Bardhaman",
          "courtComplexes": {
            "1160089@1,2,6,7@N": {
              "name": "DURGAPUR COURT COMPLEX"
            },
            "1160090@9@N": {
              "name": "Asansol Commercial Court"
            },
            "1160091@3,4,5,8@N": {
              "name": "ASANSOL COURT COMPLEX"
            }
          }
        },
        "25": {
          "name": "Jhargram",
          "courtComplexes": {
            "1160092@1,2,3,4@N": {
              "name": "JHARGRAM COURT COMPLEX"
            }
          }
        },
        "26": {
          "name": "Alipurduar",
          "courtComplexes": {
            "1160095@1,2,3,4@N": {
              "name": "Alipurduar District Court Complex"
            }
          }
        }
      }
    },
    "17": {
      "name": "Gujarat",
      "districts": {
        "11": {
          "name": "GANDHINAGAR",
          "courtComplexes": {
            "1170024@1,2@N": {
              "name": "District and Civil Court Complex"
            },
            "1170025@4@N": {
              "name": "MANSA,GANDHINAGAR."
            },
            "1170026@8@N": {
              "name": "FAMILY COURT, GANDHINAGAR"
            },
            "1170027@3@N": {
              "name": "DEHGAM,GANDHINAGAR."
            },
            "1170028@5,6,7@N": {
              "name": "Kalol,gandhinagar"
            }
          }
        },
        "13": {
          "name": "Ahmedabad",
          "courtComplexes": {
            "1170030@17,19@N": {
              "name": "Multistoreyed Building, Laldarwaja"
            },
            "1170031@12@N": {
              "name": "Taluka Court , Mandal"
            },
            "1170032@1,5@N": {
              "name": "Mirzapur, Ahmedabad"
            },
            "1170033@22@N": {
              "name": "CMM COURT COMPLEX"
            },
            "1170034@8,27@N": {
              "name": "Dhandhuka"
            },
            "1170035@7,28@N": {
              "name": "DHOLKA,AHMEDABAD."
            },
            "1170036@18@N": {
              "name": "FTC, VIRAMGAM, AHMEDABAD."
            },
            "1170037@9@N": {
              "name": "SANAND,AHMEDABAD."
            },
            "1170038@10,26@N": {
              "name": "VIRAMGAM,AHMEDABAD."
            },
            "1170039@11@N": {
              "name": "BAVLA,  AHMEDABAD"
            },
            "1170040@3,4,21@N": {
              "name": "Bhadra, Laldarwaja"
            },
            "1170042@20@N": {
              "name": "Railway Court, Ahmedabad"
            },
            "1170044@24@N": {
              "name": "Taluka Court Dholera"
            },
            "1170045@23@N": {
              "name": "Taluka Court, Detroj"
            },
            "1170416@25@N": {
              "name": "Addl. Court,Dholka"
            },
            "1370021@29@N": {
              "name": "SARAS N.I. Courts, CJM, Ahmedabad City"
            }
          }
        },
        "14": {
          "name": "SURAT",
          "courtComplexes": {
            "1170046@17@N": {
              "name": "FAST TRACK COURT COMPLEX, SURAT"
            },
            "1170047@8@N": {
              "name": "MAHUVA, SURAT"
            },
            "1170048@1,2,15@N": {
              "name": "District and Civil Court Complex"
            },
            "1170049@9@N": {
              "name": "PALSANA, SURAT"
            },
            "1170050@12@N": {
              "name": "KATHOR, SURAT"
            },
            "1170051@13,14@N": {
              "name": "SEVASADAN, SURAT"
            },
            "1170052@3@N": {
              "name": "OLPAD, SURAT"
            },
            "1170053@5@N": {
              "name": "MANGROL, SURAT"
            },
            "1170055@16@N": {
              "name": "RAILWAY COURT, SURAT."
            },
            "1170056@7,19,21@N": {
              "name": "BARDOLI, SURAT"
            },
            "1170057@18@N": {
              "name": "FAMILY COURT,NANPURA,SURAT"
            },
            "1170058@10@N": {
              "name": "UMARPADA, SURAT"
            },
            "1170059@6,20@N": {
              "name": "MANDVI, SURAT"
            }
          }
        },
        "15": {
          "name": "Mahesana",
          "courtComplexes": {
            "1170060@11@N": {
              "name": "SATLASANA, MAHESANA"
            },
            "1170061@16@N": {
              "name": "Family Court, Mahesana"
            },
            "1170062@1,2@N": {
              "name": "District and Civil Court Complex"
            },
            "1170063@5,20@N": {
              "name": "KHERALU,MAHESANA."
            },
            "1170064@14@N": {
              "name": "LABOUR COURT, MAHESANA"
            },
            "1170065@7@N": {
              "name": "VIJAPUR,MAHESANA."
            },
            "1170067@8@N": {
              "name": "BECHARAJI, MAHESANA."
            },
            "1170068@3,19@N": {
              "name": "KADI, MAHESANA"
            },
            "1170069@12,17@N": {
              "name": "UNJHA,MAHESANA."
            },
            "1170070@9@N": {
              "name": "VADNAGAR,MAHESANA."
            },
            "1170071@6,18@N": {
              "name": "CIVIL COURT, VISNAGAR"
            },
            "1170424@15@N": {
              "name": "ADDL. DISTRICT COURT, VISNAGAR"
            },
            "1170427@21@N": {
              "name": "TALUKA COURT-JOTANA"
            }
          }
        },
        "16": {
          "name": "RAJKOT",
          "courtComplexes": {
            "1170073@6,22,28@N": {
              "name": "DHORAJI, RAJKOT"
            },
            "1170074@2,25@N": {
              "name": "CIVIL AND SMALL CAUSES COURT"
            },
            "1170076@9@N": {
              "name": "TALUKA COURT, LODHIKA"
            },
            "1170078@24@N": {
              "name": "FAMILY COURT, FTC BUILDING, RAJKOT."
            },
            "1170079@8@N": {
              "name": "JAMKANDORANA, RAJKOT"
            },
            "1170080@27@N": {
              "name": "TALUKA COURT, VINCHHIYA"
            },
            "1170081@14,31@N": {
              "name": "JASDAN, RAJKOT"
            },
            "1170082@7,23@N": {
              "name": "UPLETA, RAJKOT"
            },
            "1170084@10@N": {
              "name": "PADDHARI, RAJKOT"
            },
            "1170085@16,18@N": {
              "name": "BAHUMALI BHAVAN, RAJKOT"
            },
            "1170086@3@N": {
              "name": "KOTDA SANGANI, RAJKOT"
            },
            "1170087@5,21,30@N": {
              "name": "JETPUR, RAJKOT"
            },
            "1170089@4,19,29@N": {
              "name": "GONDAL, RAJKOT"
            },
            "1170090@1@N": {
              "name": "DISTRICT COURT, FTC BUILDING"
            }
          }
        },
        "17": {
          "name": "Amreli",
          "courtComplexes": {
            "1170092@4@N": {
              "name": "Khambha, Amreli"
            },
            "1170093@6@N": {
              "name": "JAFRABAD, AMRELI"
            },
            "1170094@15@N": {
              "name": "Amreli, FTC"
            },
            "1170095@16@N": {
              "name": "ADJ COURT, DHARI"
            },
            "1170096@7@N": {
              "name": "KUNKAVAV VADIA, AMRELI"
            },
            "1170098@8@N": {
              "name": "Babara, Amreli"
            },
            "1170099@11,18@N": {
              "name": "BAGASARA,AMRELI."
            },
            "1170100@3@N": {
              "name": "DHARI, AMRELI"
            },
            "1170101@13@N": {
              "name": "Labour Court, Amreli"
            },
            "1170102@9@N": {
              "name": "LATHI,AMRELI."
            },
            "1170103@5,14,20@N": {
              "name": "RAJULA,AMRELI."
            },
            "1170104@1,2@N": {
              "name": "District and Civil Court Complex"
            },
            "1170105@10@N": {
              "name": "LILIA, AMRELI"
            },
            "1170106@12,17,19@N": {
              "name": "SAVARKUNDLA,AMRELI."
            }
          }
        },
        "18": {
          "name": "Anand",
          "courtComplexes": {
            "1170107@11@N": {
              "name": "FAMILY COURT, ANAND"
            },
            "1170108@3,12,15@N": {
              "name": "PETLAD,ANAND."
            },
            "1170109@1@N": {
              "name": "DISTRICT COURT, ANAND"
            },
            "1170110@2@N": {
              "name": "CIVIL COURT, ANAND."
            },
            "1170111@4,14@N": {
              "name": "BORSAD,ANAND."
            },
            "1170112@5,13,16@N": {
              "name": "KHAMBHAT,ANAND."
            },
            "1170113@7@N": {
              "name": "TARAPUR, ANAND"
            },
            "1170114@8@N": {
              "name": "UMRETH,ANAND."
            },
            "1170115@9@N": {
              "name": "ANKLAV, ANAND"
            },
            "1170116@6@N": {
              "name": "SOJITTRA, ANAND"
            },
            "1170117@10@N": {
              "name": "LABOUR COURT, ANAND"
            }
          }
        },
        "19": {
          "name": "Banaskanth at Palanpur",
          "courtComplexes": {
            "1170358@6@N": {
              "name": "CIVIL COURT, MODASA"
            },
            "1170359@4@N": {
              "name": "MEGHRAJ, MODASA"
            },
            "1170360@3,9@N": {
              "name": "BHILODA, MODASA"
            },
            "1170361@1,10@N": {
              "name": "BAYAD, MODASA"
            },
            "1170362@8@N": {
              "name": "FAMILY COURT, MODASA"
            },
            "1170363@5@N": {
              "name": "MALPUR, MODASA"
            },
            "1170364@7@N": {
              "name": "DISTRICT COURT, MODASA"
            },
            "1170365@2@N": {
              "name": "DHANSURA, MODASA"
            }
          }
        },
        "20": {
          "name": "Bharuch",
          "courtComplexes": {
            "1170139@13@N": {
              "name": "TALUKA COURT, NETRANG"
            },
            "1170140@8,15@N": {
              "name": "JHAGADIA,BHARUCH."
            },
            "1170141@3,11,14@N": {
              "name": "ANKLESHWAR,BHARUCH"
            },
            "1170142@12@N": {
              "name": "FAMILY COURT, Bharuch"
            },
            "1170143@6,16@N": {
              "name": "JAMBUSAR,BHARUCH."
            },
            "1170144@5@N": {
              "name": "WAGRA,BHARUCH."
            },
            "1170145@1,2@N": {
              "name": "District and Civil Court Complex"
            },
            "1170146@4@N": {
              "name": "HANSOT,BHARUCH"
            },
            "1170147@9@N": {
              "name": "VALIA,BHARUCH."
            },
            "1170148@10@N": {
              "name": "INDUSTRIAL COURT, BHARUCH"
            },
            "1170149@7@N": {
              "name": "AMOD,BHARUCH"
            }
          }
        },
        "21": {
          "name": "Bhavnagar",
          "courtComplexes": {
            "1170151@6@N": {
              "name": "GARIADHAR,BHAVNAGAR."
            },
            "1170152@15@N": {
              "name": "FAST TRACK COURT, MAHUVA."
            },
            "1170154@12@N": {
              "name": "VALLABHIPUR,BHAVNAGAR."
            },
            "1170156@9@N": {
              "name": "UMRALA,BHAVNAGAR."
            },
            "1170157@8@N": {
              "name": "SIHOR,BHAVNAGAR."
            },
            "1170158@7@N": {
              "name": "PALITANA,BHAVNAGAR."
            },
            "1170159@20@N": {
              "name": "FAMILY COURT, BHAVNAGAR"
            },
            "1170160@5,23@N": {
              "name": "MAHUVA,BHAVNAGAR."
            },
            "1170163@3@N": {
              "name": "GOGHA,BHAVNAGAR."
            },
            "1170164@14,16@N": {
              "name": "Industrial Court, Bhavnagar"
            },
            "1170166@4,22@N": {
              "name": "TALAJA,BHAVNAGAR."
            },
            "1170167@18@N": {
              "name": "Railway Court, Bhavnagar"
            },
            "1170168@2,19@N": {
              "name": "BHAVNAGAR FTC"
            },
            "1170169@21@N": {
              "name": "TALUKA COURT, JESAR"
            },
            "1170170@1@N": {
              "name": "District Court Building, Bhavnagar"
            }
          }
        },
        "22": {
          "name": "Dahod",
          "courtComplexes": {
            "1170171@9@N": {
              "name": "LABOUR COURT, DAHOD"
            },
            "1170172@1,2@N": {
              "name": "DISTRICT AND CIVIL COURT COMPLEX"
            },
            "1170174@3@N": {
              "name": "DEVGADH BARIA, DAHOD"
            },
            "1170175@11@N": {
              "name": "Dahod FTC (Family Court)"
            },
            "1170176@10@N": {
              "name": "SANJELI, DAHOD"
            },
            "1170177@8@N": {
              "name": "GARBADA, DAHOD"
            },
            "1170178@7@N": {
              "name": "FATEPURA, DAHOD"
            },
            "1170179@5,14@N": {
              "name": "JHALOD, DAHOD"
            },
            "1170180@6@N": {
              "name": "DHANPUR, DAHOD"
            },
            "1170181@4,12,13@N": {
              "name": "LIMKHEDA, DAHOD"
            }
          }
        },
        "23": {
          "name": "Jamnagar",
          "courtComplexes": {
            "1170182@3,18@N": {
              "name": "LALPUR,JAMANGAR"
            },
            "1170184@1@N": {
              "name": "District and Civil Court Complex"
            },
            "1170186@16@N": {
              "name": "FAMILY COURT, JAMNAGAR"
            },
            "1170187@13,15@N": {
              "name": "SEVASADAN-4, JAMNAGAR"
            },
            "1170188@2@N": {
              "name": "CIVIL COURT COMPLEX, JAMNAGAR."
            },
            "1170189@10,17@N": {
              "name": "DHROL,JAMANGAR"
            },
            "1170190@9@N": {
              "name": "JODIYA,JAMNAGAR."
            },
            "1170191@11@N": {
              "name": "KALAVAD, JAMNAGAR"
            },
            "1170192@4@N": {
              "name": "JAMJODHPUR,JAMNAGAR."
            }
          }
        },
        "24": {
          "name": "Junagadh",
          "courtComplexes": {
            "1170195@3@N": {
              "name": "MENDARDA, JUNAGADH"
            },
            "1170196@10,20,23@N": {
              "name": "VANTHALI, JUNAGADH"
            },
            "1170197@7@N": {
              "name": "MANGROL,JUNAGADH."
            },
            "1170198@9@N": {
              "name": "MANAVADAR,JUNAGADH."
            },
            "1170199@12,18,21@N": {
              "name": "VISVADAR,JUNAGADH."
            },
            "1170200@6@N": {
              "name": "MALIA-HATINA,JUNAGADH."
            },
            "1170201@17@N": {
              "name": "FTC, JUNAGADH."
            },
            "1170202@11@N": {
              "name": "BHESAN,JUNAGADH"
            },
            "1170203@8,22@N": {
              "name": "KESHOD,JUNAGADH."
            },
            "1170204@19@N": {
              "name": "Additional District Court, Keshod"
            },
            "1170205@1,2@N": {
              "name": "District and Civil Court Complex"
            },
            "1170207@16@N": {
              "name": "LABOUR COURT, JUNAGADH"
            }
          }
        },
        "25": {
          "name": "Kheda at Nadiad",
          "courtComplexes": {
            "1170210@15@N": {
              "name": "Family Court, Nadiad"
            },
            "1170213@7,19@N": {
              "name": "CIVIL COURT, THASARA, KHEDA."
            },
            "1170214@1@N": {
              "name": "DISTRICT COURT COMPLEX, NADIAD"
            },
            "1170215@8@N": {
              "name": "KATHLAL, KHEDA"
            },
            "1170216@2@N": {
              "name": "CIVIL COURT COMPLEX, NADIAD"
            },
            "1170217@3@N": {
              "name": "CIVIL COURT, MAHEMDABAD, KHEDA."
            },
            "1170218@4@N": {
              "name": "MATAR,KHEDA."
            },
            "1170219@12@N": {
              "name": "DAKOR,KHEDA."
            },
            "1170220@17@N": {
              "name": "TALUKA COURT, VASO"
            },
            "1170222@13,14@N": {
              "name": "INDUSTRIAL COURT, KHEDA"
            },
            "1170223@9@N": {
              "name": "MAUDHA, KHEDA"
            },
            "1170224@11,21@N": {
              "name": "KHEDA."
            },
            "1170225@5,18,20@N": {
              "name": "KAPADWANJ,KHEDA."
            },
            "1170226@16@N": {
              "name": "GALTESHWAR, KHEDA"
            }
          }
        },
        "26": {
          "name": "kachchh at Bhuj",
          "courtComplexes": {
            "1170227@6@N": {
              "name": "LAKHPAT, KUCHCHH"
            },
            "1170228@17@N": {
              "name": "Family Court, Bhuj"
            },
            "1170229@2@N": {
              "name": "CIVIL COURT, BHUJ."
            },
            "1170230@15,20@N": {
              "name": "GANDHIDHAM,KACHCHH."
            },
            "1170231@1@N": {
              "name": "District Court Complex, Bhuj"
            },
            "1170232@14@N": {
              "name": "LABOUR COURT, BHUJ"
            },
            "1170233@7,22@N": {
              "name": "NAKHTRANA,KACHCHH."
            },
            "1170234@10,16@N": {
              "name": "ANJAR, KUCHCHH"
            },
            "1170235@8@N": {
              "name": "RAHPAR,KACHCHH."
            },
            "1170236@12@N": {
              "name": "NALIYA,KACHCHH."
            },
            "1170237@11@N": {
              "name": "CIVIL COURT, GANDHIDHAM, KACHCHH"
            },
            "1170238@9,18,19@N": {
              "name": "BHACHAU,KACHCHH."
            },
            "1170239@4@N": {
              "name": "MANDAVI,KACHCHH."
            },
            "1170240@13@N": {
              "name": "KHAVDA, KUCHCHH"
            },
            "1170241@3,21@N": {
              "name": "MUNDRA,KACHCHH."
            }
          }
        },
        "27": {
          "name": "Panchmahal at Godhra",
          "courtComplexes": {
            "1170245@4,17,19@N": {
              "name": "HALOL, PANCH MAHALS"
            },
            "1170246@13@N": {
              "name": "Labour Court, Godhra"
            },
            "1170250@2@N": {
              "name": "CIVIL COURT, PANCH MAHALS"
            },
            "1170251@1@N": {
              "name": "District and Sessions Court"
            },
            "1170252@14@N": {
              "name": "FAMILY COURT, GODHRA"
            },
            "1170253@8@N": {
              "name": "Ghoghamba, Godhra"
            },
            "1170254@3@N": {
              "name": "KALOL, PANCH MAHALS"
            },
            "1170255@7@N": {
              "name": "Pr. Civil & JMFC, Jambhughoda"
            },
            "1170256@9@N": {
              "name": "Pr. Civil Judge, Morva (Hadaf)"
            },
            "1170257@16@N": {
              "name": "Railway Court, Godhra"
            },
            "1170258@5,18@N": {
              "name": "SAHERA, PANCH MAHALS"
            }
          }
        },
        "28": {
          "name": "Patan",
          "courtComplexes": {
            "1170259@4,15@N": {
              "name": "SAMI, PATAN"
            },
            "1170260@1,2,10@N": {
              "name": "District and Civil Court Complex"
            },
            "1170261@3@N": {
              "name": "CHANASMA, PATAN"
            },
            "1170262@5@N": {
              "name": "HARIJ, PATAN"
            },
            "1170263@7,14@N": {
              "name": "RADHANPUR, PATAN"
            },
            "1170264@9@N": {
              "name": "VARAHI, PATAN"
            },
            "1170265@11@N": {
              "name": "Taluka Court, Sankheshwar"
            },
            "1170266@12@N": {
              "name": "Taluka Court, Saraswati"
            },
            "1170267@13@N": {
              "name": "ADDL DISTRICT COURT, RADHANPUR"
            },
            "1170268@6@N": {
              "name": "SIDHPUR, PATAN"
            }
          }
        },
        "29": {
          "name": "Sabarkantha at Himmatnagar",
          "courtComplexes": {
            "1170269@4,18,21@N": {
              "name": "IDAR, SABARKANTHA"
            },
            "1170270@3@N": {
              "name": "PRANTIJ, SABAR KANTHA"
            },
            "1170271@2@N": {
              "name": "CIVIL COURT COMPLEX, HIMATNAGAR."
            },
            "1170274@14@N": {
              "name": "VADALI, SABARKANTHA"
            },
            "1170275@6@N": {
              "name": "VIJAYNAGAR, SABARKANTHA"
            },
            "1170276@12@N": {
              "name": "TALOD, SABARKANTHA"
            },
            "1170277@5,22@N": {
              "name": "KHEDBRAHMA, SABAR KANTHA"
            },
            "1170278@19@N": {
              "name": "POSHINA, SABARKANTHA"
            },
            "1170279@1,20@N": {
              "name": "HIMATNAGAR, SABAR KANTHA"
            },
            "1170280@15@N": {
              "name": "LABOUR COURT, SABARKANTHA"
            }
          }
        },
        "30": {
          "name": "Surendranagar",
          "courtComplexes": {
            "1170281@6@N": {
              "name": "MULI, SURENDRANAGAR"
            },
            "1170282@11@N": {
              "name": "CHUDA, SURENDRANAGAR"
            },
            "1170283@5@N": {
              "name": "CHOTILA, SURENDRANAGAR"
            },
            "1170284@13@N": {
              "name": "LABOUR COURT, SURENDRANAGAR"
            },
            "1170285@4@N": {
              "name": "SAYLA, SURENDRANAGAR"
            },
            "1170286@2@N": {
              "name": "CIVIL COURT, SURENDRANAGAR."
            },
            "1170287@10@N": {
              "name": "LAKHTAR, SURENDRANAGAR"
            },
            "1170288@14@N": {
              "name": "WADHWAN, SURENDRANAGAR"
            },
            "1170289@17@N": {
              "name": "TALUKA COURT,THANGADH"
            },
            "1170290@3,16,20@N": {
              "name": "LIMBDI, SURENDRANAGAR"
            },
            "1170291@8,15,19@N": {
              "name": "DHRANGADHRA, SURENDRANAGAR"
            },
            "1170292@1@N": {
              "name": "DISTRICT COURT, SURENDRANAGAR"
            },
            "1170293@12@N": {
              "name": "PATDI, SURENDRANAGAR"
            },
            "1170425@18@N": {
              "name": "FTC, SURENDRANAGAR"
            }
          }
        },
        "31": {
          "name": "Vadodara",
          "courtComplexes": {
            "1170294@19@N": {
              "name": "CIVIL AND JMFC COURT, DESAR"
            },
            "1170296@1,2,17@N": {
              "name": "NyayMandir, VADODARA - 390001"
            },
            "1170297@13@N": {
              "name": "CIVIL AND JMFC COURT, SINOR"
            },
            "1170298@18@N": {
              "name": "FAMILY COURT, VADODARA"
            },
            "1170299@6@N": {
              "name": "CIVIL AND JMFC COURT, VAGHODIA"
            },
            "1170300@5,20,24@N": {
              "name": "TALUKA COURT, SAVLI"
            },
            "1170302@21@N": {
              "name": "ADDL COURT, DABHOI"
            },
            "1170304@14,15@N": {
              "name": "INDUSTRIAL COURT, VADODARA"
            },
            "1170306@3,22,26@N": {
              "name": "KARJAN, VADODARA"
            },
            "1170311@4@N": {
              "name": "CIVIL AND JMFC COURT, PADRA"
            },
            "1170313@7,25@N": {
              "name": "CIVIL AND JMFC COURT, DABHOI"
            },
            "1170426@23@N": {
              "name": "VADODARA RAILWAY COURT,VADODARA"
            }
          }
        },
        "32": {
          "name": "Navsari",
          "courtComplexes": {
            "1170315@11@N": {
              "name": "Taluka Court, Khergam"
            },
            "1170316@13@N": {
              "name": "TALUKA COURT, SUBIR"
            },
            "1170317@2,10@N": {
              "name": "FTC, NAVSARI."
            },
            "1170318@3@N": {
              "name": "GANDEVI, NAVSARI"
            },
            "1170319@4,16@N": {
              "name": "VANSDA, NAVSARI"
            },
            "1170320@12@N": {
              "name": "TALUKA COURT, VAGHAI"
            },
            "1170321@5,15@N": {
              "name": "Chikhli taluka court, navasari"
            },
            "1170322@1@N": {
              "name": "District and Civil Court Complex"
            },
            "1170323@7,9,14@N": {
              "name": "AHWA, NAVSARI"
            },
            "1170324@8@N": {
              "name": "LABOUR COURT, NAVSARI"
            }
          }
        },
        "33": {
          "name": "Narmada",
          "courtComplexes": {
            "1170325@5@N": {
              "name": "TILAKWADA, NARMADA"
            },
            "1170326@1,2,7@N": {
              "name": "NEAR RAJPIPLA BUS STAND, RAJPIPLA"
            },
            "1170327@3@N": {
              "name": "SAGBARA, NARMADA"
            },
            "1170328@6,9@N": {
              "name": "TALUKA COURT, GARUDESHWAR"
            },
            "1170329@4,8@N": {
              "name": "DEDIPADA,NARMADA."
            }
          }
        },
        "34": {
          "name": "Tapi",
          "courtComplexes": {
            "1170330@1,2@N": {
              "name": "DISTRICT AND CIVIL COURT, TAPI"
            },
            "1170331@5@N": {
              "name": "UCHCHHAL, TAPI"
            },
            "1170332@4,10@N": {
              "name": "NIZAR, TAPI"
            },
            "1170333@7@N": {
              "name": "TALUKA COURT, DOLVAN"
            },
            "1170334@6,9@N": {
              "name": "SONGADH, TAPI"
            },
            "1170335@3@N": {
              "name": "VALOD, TAPI"
            }
          }
        },
        "35": {
          "name": "Valsad",
          "courtComplexes": {
            "1170336@2@N": {
              "name": "CIVIL COURT COMPLEX, VALSAD"
            },
            "1170337@1,11@N": {
              "name": "DHARAMPUR ROAD, VALSAD"
            },
            "1170338@3@N": {
              "name": "PARDI, VALSAD"
            },
            "1170339@5,10,12@N": {
              "name": "DHARAMPUR,VALSAD."
            },
            "1170340@7@N": {
              "name": "LABOUR COURT, VALSAD"
            },
            "1170341@4@N": {
              "name": "UMBERGAON, VALSAD"
            },
            "1170342@8,9,13@N": {
              "name": "VAPI, VALSAD."
            },
            "1170344@6@N": {
              "name": "KAPARADA, VALSAD."
            }
          }
        },
        "36": {
          "name": "Porbandar",
          "courtComplexes": {
            "1170345@4@N": {
              "name": "KUTIYANA, PORBANDAR."
            },
            "1170346@1,2@N": {
              "name": "DISTRICT AND CIVIL COURT, PORBANDAR"
            },
            "1170347@3@N": {
              "name": "RANAVAV, PORBANDAR."
            },
            "1170348@5@N": {
              "name": "FAMILY COURT, PORBANDAR"
            }
          }
        },
        "37": {
          "name": "Gir Somnath at Veraval",
          "courtComplexes": {
            "1170349@6,9,12@N": {
              "name": "KODINAR, VERAVAL"
            },
            "1170351@1,10@N": {
              "name": "DISTRICT COURT, VERAVAL"
            },
            "1170352@3@N": {
              "name": "FTC, UNA, VERAVAL"
            },
            "1170353@5@N": {
              "name": "SUTRAPADA, VERAVAL"
            },
            "1170354@4@N": {
              "name": "UNA, VERAVAL"
            },
            "1170355@2@N": {
              "name": "CIVIL COURT, VERAVAL"
            },
            "1170356@8@N": {
              "name": "TALUKA COURT, GIRGADHADA"
            },
            "1170357@7@N": {
              "name": "TALALA, VERAVAL"
            },
            "1170419@11@N": {
              "name": "UNA, NYAY MANDIR"
            }
          }
        },
        "38": {
          "name": "Aravalli at Modasa",
          "courtComplexes": {
            "1170358@6@N": {
              "name": "CIVIL COURT, MODASA"
            },
            "1170359@4@N": {
              "name": "MEGHRAJ, MODASA"
            },
            "1170360@3,9@N": {
              "name": "BHILODA, MODASA"
            },
            "1170361@1,10@N": {
              "name": "BAYAD, MODASA"
            },
            "1170362@8@N": {
              "name": "FAMILY COURT, MODASA"
            },
            "1170363@5@N": {
              "name": "MALPUR, MODASA"
            },
            "1170364@7@N": {
              "name": "DISTRICT COURT, MODASA"
            },
            "1170365@2@N": {
              "name": "DHANSURA, MODASA"
            }
          }
        },
        "39": {
          "name": "MORBI",
          "courtComplexes": {
            "1170366@2@N": {
              "name": "CIVIL COURT, MORBI"
            },
            "1170368@3@N": {
              "name": "TALUKA COURT, MALIYA"
            },
            "1170369@4@N": {
              "name": "TALUKA COURT, WAKANER"
            },
            "1170371@6,8@N": {
              "name": "TALUKA COURT, HALVAD"
            },
            "1170374@5@N": {
              "name": "TALUKA COURT, TANKARA"
            },
            "1170376@7@N": {
              "name": "FAMILY COURT, MORBI"
            },
            "1170378@1@N": {
              "name": "DISTRICT COURT, MORBI"
            }
          }
        },
        "40": {
          "name": "Devbhumi Dwarka at Khambhaliya",
          "courtComplexes": {
            "1170380@4,10@N": {
              "name": "TALUKA COURT, KALYANPUR"
            },
            "1170382@5@N": {
              "name": "TALUKA COURT, BHANVAD"
            },
            "1170383@1@N": {
              "name": "DISTRICT COURT, KHAMBHALIA"
            },
            "1170384@6,9@N": {
              "name": "TALUKA COURT, OKHAMANDAL"
            },
            "1170387@2,7@N": {
              "name": "CIVIL COURT, KHAMBHALIA"
            },
            "1170390@3,8@N": {
              "name": "SESSIONS AND CIVIL COURT , DWARKA"
            }
          }
        },
        "41": {
          "name": "Chhota Udepur",
          "courtComplexes": {
            "1170391@1,9@N": {
              "name": "District Court, Chhota Udepur"
            },
            "1170392@7@N": {
              "name": "Taluka Court, Kawant"
            },
            "1170393@6@N": {
              "name": "Taluka Court, Naswadi"
            },
            "1170394@5@N": {
              "name": "Taluka Court, JetpurPavi"
            },
            "1170395@3,8,10@N": {
              "name": "TALUKA SEVASADAN BODELI"
            },
            "1170396@2@N": {
              "name": "Civil Court, Chhota Udepur"
            },
            "1170397@4@N": {
              "name": "Taluka Court, Sankheda"
            }
          }
        },
        "42": {
          "name": "Mahisagar at Lunawada",
          "courtComplexes": {
            "1170398@6,9@N": {
              "name": "Santrampur, Mahisagar"
            },
            "1170399@2@N": {
              "name": "Taluka Court, Kadana"
            },
            "1170400@3,8@N": {
              "name": "District Court, Mahisagar"
            },
            "1170401@7@N": {
              "name": "Taluka Court, Virpur"
            },
            "1170402@5@N": {
              "name": "Taluka Court, Khanpur"
            },
            "1170403@4@N": {
              "name": "Taluka Court, Balasinor"
            },
            "1170404@1@N": {
              "name": "Civil Court, Lunawada"
            }
          }
        },
        "43": {
          "name": "BOTAD",
          "courtComplexes": {
            "1170405@5@N": {
              "name": "CIVIL COURT, BOTAD"
            },
            "1170406@2@N": {
              "name": "TALUKA COURT, BARWALA"
            },
            "1170407@1,6@N": {
              "name": "DISTRICT COURT, BOTAD"
            },
            "1170408@3@N": {
              "name": "TALUKA COURT, GADHADA"
            },
            "1170409@4@N": {
              "name": "TALUKA COURT, RANPUR"
            }
          }
        },
        "87": {
          "name": "Dangs",
          "courtComplexes": {

          }
        }
      }
    },
    "18": {
      "name": "Chhattisgarh",
      "districts": {
        "1": {
          "name": "Korba",
          "courtComplexes": {
            "1180012@6@N": {
              "name": "Civil Court Pali, Pali"
            },
            "1180013@3,4,8@Y": {
              "name": "Civil Court Katghora Katghora"
            },
            "1180014@1,2,7,9@Y": {
              "name": "Distt  Session Court  Korba"
            },
            "1180015@5@N": {
              "name": "Civil Court Kartala,Kartala-T"
            }
          }
        },
        "2": {
          "name": "Bilaspur",
          "courtComplexes": {
            "1180017@5@N": {
              "name": "Civil Court Takhatpur"
            },
            "1180018@6@N": {
              "name": "Civil Court Marwahi, Marwahi"
            },
            "1180019@7@N": {
              "name": "Civil Court Bilha"
            },
            "1180020@8,9@Y": {
              "name": "Civil Court Pendraroad"
            },
            "1180021@3@N": {
              "name": "Civil Court Kota"
            },
            "1180023@1,2,12@Y": {
              "name": "Dist and Sessions Court Bilaspur"
            },
            "1180107@13@N": {
              "name": "Family Court Bilaspur"
            }
          }
        },
        "3": {
          "name": "Raipur",
          "courtComplexes": {
            "1180024@5@N": {
              "name": "Civil Court Devbhog"
            },
            "1180025@6@N": {
              "name": "Civil Court Tilda"
            },
            "1180026@4@N": {
              "name": "Civil Court Rajim"
            },
            "1180027@9@N": {
              "name": "Comm Court Dist Level Naya Raipur"
            },
            "1180028@7,8,12@N": {
              "name": "Civil Court Gariyaband"
            },
            "1180029@1,2,10,11@Y": {
              "name": "Distt Session Court  Raipur"
            },
            "1370036@13@Y": {
              "name": "Civil Court Arang"
            }
          }
        },
        "4": {
          "name": "Surguja at Ambikapur",
          "courtComplexes": {
            "1180034@6@N": {
              "name": "Civil Court Sitapur"
            },
            "1180035@1,2,3,10@Y": {
              "name": "District and Sessions Court Sarguja"
            }
          }
        },
        "5": {
          "name": "Dhamtari",
          "courtComplexes": {
            "1180036@3@N": {
              "name": "Civil Court Nagri"
            },
            "1180037@1,2,5,6@Y": {
              "name": "DJ ADJ Court  Dhamtari"
            },
            "1180038@4,7@Y": {
              "name": "Civil Court Kurud"
            }
          }
        },
        "6": {
          "name": "Raigarh",
          "courtComplexes": {
            "1180039@6,10@Y": {
              "name": "Civil Court Gharghora"
            },
            "1180040@4@N": {
              "name": "Civil Court Dharamjaigarh"
            },
            "1180041@3@N": {
              "name": "Civil Court Kharsiya"
            },
            "1180042@5,7@Y": {
              "name": "Civil Court Saranggarh,Saranggarh"
            },
            "1180043@1,2,8,9@Y": {
              "name": "Distt Session Court  Raigarh"
            },
            "1180096@11@N": {
              "name": "Civil Court Bhatgaon, Bhatgaon"
            },
            "1180099@12@N": {
              "name": "Civil Court Bilaigarh, Bilaigarh"
            }
          }
        },
        "7": {
          "name": "Durg",
          "courtComplexes": {
            "1180044@4@N": {
              "name": "Bhilai"
            },
            "1180045@1,2,5,6@Y": {
              "name": "District and Sessions Court Durg"
            },
            "1180046@3,8@Y": {
              "name": "Civil Court Patan,Patan T"
            },
            "1180109@7@N": {
              "name": "Civil Court Dhamdha"
            }
          }
        },
        "9": {
          "name": "Kawardha",
          "courtComplexes": {
            "1180047@1,2,4,5@Y": {
              "name": "District and Sessions CourtKawardha"
            },
            "1180048@3@N": {
              "name": "Civil Court Pandariya"
            }
          }
        },
        "10": {
          "name": "Rajnandgaon",
          "courtComplexes": {
            "1180049@8@N": {
              "name": "Civil Court  Chhuikhadan"
            },
            "1180050@4,5@Y": {
              "name": "Civil Court Dongargarh"
            },
            "1180051@1,2,9,10@Y": {
              "name": "Distt Session Court Rajnandgaon"
            },
            "1180052@6,7,11@Y": {
              "name": "Civil Court Khairagarh,Khairagarh"
            },
            "1180053@3,12@Y": {
              "name": "Civil Court Ambagarh Chowki"
            }
          }
        },
        "11": {
          "name": "Koriya",
          "courtComplexes": {
            "1180054@3,10@N": {
              "name": "Civil Court Chirmiri, Chirmiri-T"
            },
            "1180055@6@N": {
              "name": "Civil Court Janakpur"
            },
            "1180056@1,2,7,9@Y": {
              "name": "Distt Session Court  Koriya"
            },
            "1180057@4,5,8@Y": {
              "name": "Civil Court Manendragarh"
            }
          }
        },
        "12": {
          "name": "Mahasamund",
          "courtComplexes": {
            "1180058@6@N": {
              "name": "Civil Court Basna"
            },
            "1180059@3@N": {
              "name": "Civil Court Pithoura"
            },
            "1180060@4,5,9@Y": {
              "name": "Civil Court Saraipali"
            },
            "1180061@1,2,7,8@Y": {
              "name": "DJ ADJ Court  Mahasamund"
            },
            "1180108@10@N": {
              "name": "Civil Court Bagbahara"
            }
          }
        },
        "13": {
          "name": "Kanker",
          "courtComplexes": {
            "1180062@5,8@Y": {
              "name": "Civil Court Pakhanjur"
            },
            "1180063@1,2,6,7@Y": {
              "name": "District and Sessions Court Kanker"
            },
            "1180064@3,4@Y": {
              "name": "Civil Court Bhanupratappur"
            }
          }
        },
        "15": {
          "name": "Bastar",
          "courtComplexes": {
            "1180065@1,2,3,4@Y": {
              "name": "District And Sessions Court Bastar"
            }
          }
        },
        "16": {
          "name": "Jashpur",
          "courtComplexes": {
            "1180066@3,4@Y": {
              "name": "Civil Court Kunkuri"
            },
            "1180067@6@N": {
              "name": "Civil Court Bagicha"
            },
            "1180068@5,9@Y": {
              "name": "Civil Court Patthalgaon"
            },
            "1180069@1,2,7,8@Y": {
              "name": "Distt Session Court  Jashpur"
            }
          }
        },
        "17": {
          "name": "Dantewada",
          "courtComplexes": {
            "1180070@4,8@N": {
              "name": "Civil Court Sukma"
            },
            "1180071@3,7@N": {
              "name": "Civil Court Bijapur"
            },
            "1180072@9@N": {
              "name": "Civil Court Konta"
            },
            "1180073@1,2,6,10@Y": {
              "name": "District and Sessio Court Dantewada"
            },
            "1180074@5@N": {
              "name": "Civil Court Bacheli"
            }
          }
        },
        "18": {
          "name": "Janjgir",
          "courtComplexes": {
            "1180075@9@N": {
              "name": "Civil Court Jaijaipur,Jaijaipur-T"
            },
            "1180076@10@N": {
              "name": "Civil Court Akaltara, Akaltara"
            },
            "1180077@5,6,14@Y": {
              "name": "Civil Court, Sakti"
            },
            "1180078@8@N": {
              "name": "Civil Court Pamgarh,Pamgarh-T"
            },
            "1180079@1,2,12,13@Y": {
              "name": "District and Sessions Court Janjgir"
            },
            "1180080@4@N": {
              "name": "Civil Court Champa"
            },
            "1180081@11@N": {
              "name": "Civil Court Nawagarh"
            },
            "1180082@7@N": {
              "name": "Civil Court Malkharouda"
            },
            "1180083@3@N": {
              "name": "Civil Court Dabhara, Dabhara"
            }
          }
        },
        "19": {
          "name": "Balod",
          "courtComplexes": {
            "1180084@3@N": {
              "name": "Civil Court Gunderdehi"
            },
            "1180085@5@N": {
              "name": "Civil Court Dondilohara"
            },
            "1180086@4@N": {
              "name": "Civil Court Dallirajhara"
            },
            "1180087@1,2,6,7@N": {
              "name": "District and Sessions Court Balod"
            }
          }
        },
        "20": {
          "name": "Bemetara",
          "courtComplexes": {
            "1180088@1,2,3,4@N": {
              "name": "District Sessions Court Bemetara"
            },
            "1180089@5@N": {
              "name": "Civil Court Saja, Saja"
            }
          }
        },
        "21": {
          "name": "Surajpur",
          "courtComplexes": {
            "1180090@3,4,5,6@Y": {
              "name": "District and Sessions CourtSurajpur"
            },
            "1180091@1,2@N": {
              "name": "Civil Court Pratappur, Pratappur"
            }
          }
        },
        "22": {
          "name": "Kondagaon",
          "courtComplexes": {
            "1180092@3,6,8@Y": {
              "name": "Civil Court Narayanpur"
            },
            "1180093@4@N": {
              "name": "Civil Court Keshkal"
            },
            "1180094@1,2,5,7@Y": {
              "name": "District and Sessi Court Kondagaon"
            }
          }
        },
        "23": {
          "name": "Balodabazar",
          "courtComplexes": {
            "1180095@3@N": {
              "name": "Civil Court Kasdol, Kasdol"
            },
            "1180097@1,2,8,10@Y": {
              "name": "District and Sessions C Balodabazar"
            },
            "1180098@4@N": {
              "name": "Civil Court Simga, Simga"
            },
            "1180100@5,6@N": {
              "name": "Civil Court Bhatapara, Bhatapara"
            }
          }
        },
        "24": {
          "name": "Mungeli",
          "courtComplexes": {
            "1180101@1,2,3,5@N": {
              "name": "District and Sessions Court Mungeli"
            },
            "1180102@4@N": {
              "name": "Civil Court Lormi"
            }
          }
        },
        "25": {
          "name": "Balrampur Ramanujganj",
          "courtComplexes": {
            "1180103@6@N": {
              "name": "Civil Court Wadrafnagar"
            },
            "1180104@1@N": {
              "name": "Civil Court Balrampur"
            },
            "1180105@5@N": {
              "name": "Civil Court Rajpur"
            },
            "1180106@2,3,4@N": {
              "name": "District Court Balrampur"
            }
          }
        },
        "80": {
          "name": "sukma",
          "courtComplexes": {

          }
        },
        "81": {
          "name": "Gaurela Pendra Marwahi",
          "courtComplexes": {

          }
        }
      }
    },
    "19": {
      "name": "Mizoram",
      "districts": {
        "1": {
          "name": "Aizawl",
          "courtComplexes": {
            "1190006@1,2,3,4,12,13@Y": {
              "name": "Aizawl District Court"
            },
            "1190007@5,6@Y": {
              "name": "Serchhip District Court"
            },
            "1190011@7,8@Y": {
              "name": "Mamit District Court"
            },
            "1190014@9,10@Y": {
              "name": "Kolasib District Court"
            }
          }
        },
        "2": {
          "name": "Lunglei",
          "courtComplexes": {
            "1190008@4,5@Y": {
              "name": "Lawngtlai District Court"
            },
            "1190009@1,2,3@Y": {
              "name": "Lunglei District Court"
            },
            "1190012@6,7,8@Y": {
              "name": "Saiha District Court"
            }
          }
        },
        "4": {
          "name": "Champhai",
          "courtComplexes": {
            "1190013@1,2,3,4@Y": {
              "name": "Champhai District Court"
            }
          }
        }
      }
    },
    "20": {
      "name": "Tripura",
      "districts": {
        "1": {
          "name": "West Tripura",
          "courtComplexes": {
            "1200012@4,5,6,7,8,9@Y": {
              "name": "District Judge Agartala"
            }
          }
        },
        "2": {
          "name": "North Tripura",
          "courtComplexes": {
            "1200016@6,7,8,9,12,13@Y": {
              "name": "District Judge Dharmanagar"
            },
            "1200017@10,11@Y": {
              "name": "SDJM Kanchanpur"
            }
          }
        },
        "3": {
          "name": "South Tripura",
          "courtComplexes": {
            "1200018@7,8,9,10,14,15@Y": {
              "name": "District Judge Belonia"
            },
            "1200019@11,12,13@Y": {
              "name": "SDJM Sabroom"
            }
          }
        },
        "5": {
          "name": "Unakoti",
          "courtComplexes": {
            "1200020@2,3,4,6,7@Y": {
              "name": "District Judge Kailasahar"
            },
            "1200021@5@Y": {
              "name": "CJM Kailasahar"
            }
          }
        },
        "6": {
          "name": "Gomati",
          "courtComplexes": {
            "1200023@2,3,4,5,6,12@Y": {
              "name": "District and Sessions Judge Udaipur"
            },
            "1200024@10,11@Y": {
              "name": "SDJM Amarpur"
            }
          }
        },
        "9": {
          "name": "Sepahijala",
          "courtComplexes": {
            "1200025@4,5,7@Y": {
              "name": "Addl District Judge Bishalgarh"
            },
            "1200026@1,2,3,6,8,9@Y": {
              "name": "District Judge Sepahijala"
            }
          }
        },
        "10": {
          "name": "Khowai",
          "courtComplexes": {
            "1200027@1,2,3,4,5,6@Y": {
              "name": "District Judge Khowai"
            }
          }
        },
        "11": {
          "name": "Dhalai",
          "courtComplexes": {
            "1200028@3,4@Y": {
              "name": "SDJM Gandachera"
            },
            "1200029@8,9,10,11,12@Y": {
              "name": "DJ Court Complex Ambassa"
            },
            "1200030@1,2@Y": {
              "name": "SDJM LongtaraiValley"
            },
            "1200031@5,6,7,13@Y": {
              "name": "ADJ Kamalpur"
            }
          }
        }
      }
    },
    "21": {
      "name": "Meghalaya",
      "districts": {
        "1": {
          "name": "East Khasi Hills",
          "courtComplexes": {
            "1210002@2,3,4,5,6,7,8,10@N": {
              "name": "District Court Complex Shillong"
            },
            "1210024@9@N": {
              "name": "Sub Divisional Court, Sohra"
            }
          }
        },
        "2": {
          "name": "West Garo Hills",
          "courtComplexes": {
            "1210003@1,2,3,4,5@N": {
              "name": "District Court Complex Tura"
            },
            "1210021@6@N": {
              "name": "Sub Divisional Court, Dadenggre"
            }
          }
        },
        "3": {
          "name": "West Jaintia Hills",
          "courtComplexes": {
            "1210004@1,2,3,4,5,6,7,8,9,10@N": {
              "name": "District Court Complex Jowai"
            },
            "1210008@11@N": {
              "name": "Sub Divisional Court, Amlarem"
            }
          }
        },
        "4": {
          "name": "East Garo Hills",
          "courtComplexes": {
            "1210015@1,2,3,4,5@N": {
              "name": "District Court Complex Williamnagar"
            }
          }
        },
        "5": {
          "name": "Ri Bhoi",
          "courtComplexes": {
            "1210016@1,2,3@N": {
              "name": "Nongpoh, Dist and Session Court"
            }
          }
        },
        "6": {
          "name": "South West Khasi Hills",
          "courtComplexes": {
            "1210018@1,2,3,4@N": {
              "name": "District Court Complex Ampati"
            }
          }
        },
        "7": {
          "name": "West Khasi Hills",
          "courtComplexes": {
            "1210017@1,2,3,4,5@N": {
              "name": "District Court Complex Nongstoin"
            }
          }
        },
        "8": {
          "name": "South West Garo Hills",
          "courtComplexes": {
            "1210018@1,2,3,4@N": {
              "name": "District Court Complex Ampati"
            }
          }
        },
        "9": {
          "name": "KHADC Court",
          "courtComplexes": {
            "1210020@1@N": {
              "name": "KHADC Court Complex, Shillong"
            }
          }
        },
        "10": {
          "name": "North Garo Hills",
          "courtComplexes": {
            "1210022@1,2,3,4@N": {
              "name": "District Court Complex Resubelpara"
            }
          }
        },
        "11": {
          "name": "East Jaintia Hills",
          "courtComplexes": {
            "1210023@1,2,3,4@N": {
              "name": "District Court Complex Khliehriat"
            }
          }
        },
        "12": {
          "name": "South Garo Hills",
          "courtComplexes": {
            "1210025@1,2,3@N": {
              "name": "District Court Complex, Baghmara"
            }
          }
        },
        "13": {
          "name": "Eastern West Khasi Hills",
          "courtComplexes": {
            "1210027@1,2@N": {
              "name": "Sub Divisional Court, Mairang"
            }
          }
        }
      }
    },
    "22": {
      "name": "Punjab",
      "districts": {
        "1": {
          "name": "Ludhiana",
          "courtComplexes": {
            "1220003@6,9,14@N": {
              "name": "Judicial Complex, Samrala"
            },
            "1220004@10,11,12@N": {
              "name": "Judicial Complex, Payal"
            },
            "1220005@7,8,13@N": {
              "name": "Judicial Complex, Jagraon"
            },
            "1220006@2,5,15@N": {
              "name": "Judicial Complex, Khanna"
            },
            "1220007@1,3,4@N": {
              "name": "District Court, Ludhiana"
            }
          }
        },
        "2": {
          "name": "Jalandhar",
          "courtComplexes": {
            "1220008@2,6,8@N": {
              "name": "Judicial Complex, Phillaur"
            },
            "1220009@3,7,9@N": {
              "name": "Judicial Complex, Nakodar"
            },
            "1220010@1,4,5@N": {
              "name": "District Court, Jalandhar"
            }
          }
        },
        "3": {
          "name": "Rupnagar",
          "courtComplexes": {
            "1220011@1,8,9@N": {
              "name": "District Courts, Rupnagar"
            },
            "1220012@6,10,13@N": {
              "name": "Judicial Complex, Anandpur Sahib"
            },
            "1220013@11,12,14@N": {
              "name": "Judicial Complex, Nangal"
            }
          }
        },
        "4": {
          "name": "Fatehgarh Sahib",
          "courtComplexes": {
            "1220014@2,5,8@N": {
              "name": "Judicial Complex, Amloh"
            },
            "1220015@1,3,4@N": {
              "name": "District Court, Fatehgarh Sahib"
            },
            "1220016@6,7,9@N": {
              "name": "Judicial Complex, Khamanon"
            }
          }
        },
        "5": {
          "name": "Patiala",
          "courtComplexes": {
            "1220017@1,5,6@N": {
              "name": "District Court, Patiala"
            },
            "1220018@4,9,11@N": {
              "name": "Judicial Complex, Samana"
            },
            "1220019@2,8,10@N": {
              "name": "Judicial Complex, Rajpura"
            },
            "1220020@3,7,12@N": {
              "name": "Judicial Complex, Nabha"
            }
          }
        },
        "6": {
          "name": "Ferozepur",
          "courtComplexes": {
            "1220023@2,11,15@N": {
              "name": "Judicial Courts Complex, Zira."
            },
            "1220026@1,6,7@N": {
              "name": "District and Sessions Court Complex, Ferozepur"
            },
            "1220031@13,14,16@N": {
              "name": "Judicial Complex, Guruharsahai"
            }
          }
        },
        "8": {
          "name": "Amritsar",
          "courtComplexes": {
            "1220033@3,10,11@N": {
              "name": "Judicial Complex, Baba Bakala"
            },
            "1220035@2,8,12@N": {
              "name": "Judicial Complex, Ajnala"
            },
            "1220036@1,6,7@N": {
              "name": "District Court, Amritsar"
            }
          }
        },
        "9": {
          "name": "Faridkot",
          "courtComplexes": {
            "1220037@1,2,3@N": {
              "name": "District Court, Faridkot"
            },
            "1220038@4,5@N": {
              "name": "Judicial Complex, Jaitu"
            }
          }
        },
        "10": {
          "name": "Gurdaspur",
          "courtComplexes": {
            "1220040@1,2,3@N": {
              "name": "District Court, Gurdaspur"
            },
            "1220041@4,5,6@N": {
              "name": "Judicial Complex, Batala"
            }
          }
        },
        "11": {
          "name": "Kapurthala",
          "courtComplexes": {
            "1220042@1,4,5@Y": {
              "name": "District Court, Kapurthala"
            },
            "1220043@3,7,11@Y": {
              "name": "Judicial Complex, Sultanpur Lodhi"
            },
            "1220044@8,9,12@Y": {
              "name": "Judicial Complex, Bholath"
            },
            "1220045@2,6,10@Y": {
              "name": "Judicial Complex, Phagwara"
            }
          }
        },
        "12": {
          "name": "Moga",
          "courtComplexes": {
            "1220048@4,5,8@Y": {
              "name": "Judicial Complex, Nihalsinghwala"
            },
            "1220049@6,7,9@Y": {
              "name": "Judicial Complex, Baghapurana"
            },
            "1220050@1,2,3@N": {
              "name": "District Court, Moga"
            },
            "1220090@10,11@Y": {
              "name": "Gram Nyayalay Kot Ise\nKhan"
            }
          }
        },
        "13": {
          "name": "Mansa",
          "courtComplexes": {
            "1220051@1,4,5@N": {
              "name": "District Court Complex, Mansa"
            },
            "1220052@2,7,8@N": {
              "name": "Judicial Complex, Budhlada"
            },
            "1220053@3,6,9@N": {
              "name": "Judicial Complex, Sardulgarh"
            }
          }
        },
        "14": {
          "name": "Sri Muktsar Sahib",
          "courtComplexes": {
            "1220054@4,6,10@Y": {
              "name": "Judicial Complex, Malout"
            },
            "1220055@1,2,7,8@Y": {
              "name": "District Court, Sri Muktsar Sahib"
            },
            "1220056@3,5,11@N": {
              "name": "Judicial Complex, Gidderbaha"
            }
          }
        },
        "15": {
          "name": "SBS Nagar",
          "courtComplexes": {
            "1220058@6@N": {
              "name": "Family Complex, Balachaur"
            },
            "1220059@2,5@N": {
              "name": "Judicial Complex, Balachaur"
            },
            "1220060@1,3,4@N": {
              "name": "District Court,  SBS Nagar"
            }
          }
        },
        "16": {
          "name": "Barnala",
          "courtComplexes": {
            "1220061@1,2,3@N": {
              "name": "District Court, Barnala"
            }
          }
        },
        "17": {
          "name": "Bathinda",
          "courtComplexes": {
            "1220062@1,4,5@N": {
              "name": "District as Court, Bathinda"
            },
            "1220063@2,7,8@N": {
              "name": "Judicial Complex, Phul"
            },
            "1220064@3,6,9@N": {
              "name": "Judicial Complex, Talwandi Sabo"
            }
          }
        },
        "18": {
          "name": "Hoshiarpur",
          "courtComplexes": {
            "1220065@9,10,11@N": {
              "name": "Judicial Courts Complex, Mukerian."
            },
            "1220066@1,7,13@N": {
              "name": "Judicial Complex, Dasuya"
            },
            "1220067@3,5,6@N": {
              "name": "District Court, Hoshiarpur"
            },
            "1220068@2,8,12@N": {
              "name": "Judicial Complex, Garhshankar"
            }
          }
        },
        "19": {
          "name": "Sangrur",
          "courtComplexes": {
            "1220069@1,6,7@N": {
              "name": "District Court, Sangrur"
            },
            "1220070@3,8,14@N": {
              "name": "Judicial Complex, Dhuri"
            },
            "1220071@5,10,15@N": {
              "name": "Judicial Complex, Sunam"
            },
            "1220072@2,11,13@N": {
              "name": "Judicial Complex, Moonak"
            },
            "1220073@4,9,12@N": {
              "name": "Judicial Complex, Malerkotla"
            }
          }
        },
        "21": {
          "name": "Pathankot",
          "courtComplexes": {
            "1220074@1,2,3@N": {
              "name": "District Court, Pathankot"
            }
          }
        },
        "23": {
          "name": "Tarn Taran",
          "courtComplexes": {
            "1220076@6,7,8@N": {
              "name": "Judicial Complex, Khadur Sahib"
            },
            "1220077@9,10,11@Y": {
              "name": "Judicial Complex, Patti"
            },
            "1220079@1,2,3@Y": {
              "name": "District Court, Tarn Taran"
            }
          }
        },
        "24": {
          "name": "SAS Nagar",
          "courtComplexes": {
            "1220080@4,5@N": {
              "name": "Judicial Complex, Kharar"
            },
            "1220081@1,2,3@N": {
              "name": "District and Sessions Court Complex, SAS Nagar"
            },
            "1220085@6,7@N": {
              "name": "Judicial Court, Derabassi"
            }
          }
        },
        "26": {
          "name": "Fazilka",
          "courtComplexes": {
            "1220086@1,2,7@N": {
              "name": "District Court, Fazilka"
            },
            "1220087@5,6,9@N": {
              "name": "Judicial Complex, Jalalabad"
            },
            "1220088@3,4,8@N": {
              "name": "Judicial Court Complex, Abohar"
            }
          }
        }
      }
    },
    "23": {
      "name": "Madhya Pradesh",
      "districts": {
        "1": {
          "name": "Jabalpur",
          "courtComplexes": {
            "1230006@3@N": {
              "name": "Civil Court,Patancivil court patan"
            },
            "1230007@2@N": {
              "name": "Civil Court,sihoracivil court sihora"
            },
            "1230008@1,4@N": {
              "name": "District & Sessions Court ,JabalpurDistrict & Sessions Court,Jabalpur"
            }
          }
        },
        "2": {
          "name": "Narsinghpur",
          "courtComplexes": {
            "1230009@4@N": {
              "name": "LinkCourtTendukhedaDist Narsinghpur"
            },
            "1230010@1,3@N": {
              "name": "District & Sessions Court, NarsinghpurDistrict & Sessions Court,Pathak ward, Narsinghpur"
            },
            "1230011@2@N": {
              "name": "Civil Court ,GadarwaraCivil Court ,Gadarwara Bhama Ward Gadarwara"
            },
            "1230232@5@N": {
              "name": "Civil Court Gotegaon"
            }
          }
        },
        "3": {
          "name": "Hoshangabad",
          "courtComplexes": {
            "1230012@4@N": {
              "name": "Civil Court, Seoni MalwaCivil Court, Seoni Malwa, Distt. Hoshangabad"
            },
            "1230013@3@N": {
              "name": "Civil Court, PipariyaCivil Court, Pipariya District Hoshangabad"
            },
            "1230014@7@N": {
              "name": "Civil Court, PachmarhiCivil Court, Pachmarhi District Hoshangabad"
            },
            "1230015@2@N": {
              "name": "Civil Court, ItarsiCivil court, Itarsi, Distt. Hoshangabad"
            },
            "1230016@1,6@N": {
              "name": "District & Sessions Court, HoshagabadHoshangabad"
            },
            "1230017@5@N": {
              "name": "Civil Court, SohagpurCivil Court, Sohagpur District Hoshangabad"
            }
          }
        },
        "4": {
          "name": "Harda",
          "courtComplexes": {
            "1230018@1@N": {
              "name": "District & Sessions Court, HardaDistrict & Sessions Court, Harda"
            },
            "1230019@3@N": {
              "name": "Family Court Harda"
            },
            "1230020@2@N": {
              "name": "Civil Court khirkiya"
            },
            "1230228@4@N": {
              "name": "Civil Court Timarni District Harda"
            }
          }
        },
        "5": {
          "name": "Umaria",
          "courtComplexes": {
            "1230021@2@N": {
              "name": "Civil Court Birsinghpur paliNagar Panchayat Bhawan, Birsinghpur pali, M.P."
            },
            "1230022@1@N": {
              "name": "Civil Court, UmariaCivil Court,Near Ranvijay Chowk, Umaria"
            },
            "1230023@3@N": {
              "name": "Family Court Umaria"
            },
            "1230220@4@N": {
              "name": "Civil Court Manpur District Umaria"
            }
          }
        },
        "6": {
          "name": "Dindori",
          "courtComplexes": {
            "1230024@1,2@N": {
              "name": "Civil Court,DindoriCivil Court,Dindori"
            },
            "1230222@3@N": {
              "name": "Civil Court Shahpura Dist. Dindori"
            }
          }
        },
        "7": {
          "name": "Panna",
          "courtComplexes": {
            "1230025@2@N": {
              "name": "Civil Court, AjaygarhCivil Court,Ajaygarh"
            },
            "1230026@1,4@N": {
              "name": "District & Sessions Court,PannaMahendra Bhawan, Panna"
            },
            "1230027@3@N": {
              "name": "Civil Court,PawaiCivil Court,Pawai"
            }
          }
        },
        "8": {
          "name": "Alirajpur",
          "courtComplexes": {
            "1230028@2@N": {
              "name": "Civil Court Jobat"
            },
            "1230029@1@N": {
              "name": "District and Session Court"
            },
            "1230030@3@Y": {
              "name": "Family Court Alirajpur"
            }
          }
        },
        "9": {
          "name": "Jhabua",
          "courtComplexes": {
            "1230031@1,4@N": {
              "name": "District And Sessions Court Jhabua"
            },
            "1230033@3@N": {
              "name": "Civil Court,PetlawadCivil Court,Petlawad"
            },
            "1230034@2@N": {
              "name": "Civil Court,ThandlaCivil Court,Thandla"
            }
          }
        },
        "10": {
          "name": "Khandwa",
          "courtComplexes": {
            "1230035@2@N": {
              "name": "Civil Court, Harsud"
            },
            "1230036@4@N": {
              "name": "Civil Court Punasa District khandwa"
            },
            "1230037@1,3@N": {
              "name": "District & Sessions Court ,KhandwaCourt complex, civil line, khandwa mp 450001"
            }
          }
        },
        "11": {
          "name": "Shahdol",
          "courtComplexes": {
            "1230038@2@N": {
              "name": "Civil Court ,BeohariMartand Ganj, Beohari M.P."
            },
            "1230039@1,5@N": {
              "name": "District & Sessions Court, Shahdolpali road shahdol m.p."
            },
            "1230040@4@N": {
              "name": "Civil Court ,JaisinghnagarNear Bus Stand, Jaisinghnagar, M.P."
            },
            "1230041@3@N": {
              "name": "Civil Court ,BurharFront of Police Station, Burhar, M.P."
            }
          }
        },
        "12": {
          "name": "Sheopur",
          "courtComplexes": {
            "1230042@1@N": {
              "name": "District & Sessions Court,SheopurShivpuri road ,sheopur"
            },
            "1230043@2@N": {
              "name": "Civil Court, Vijaypur"
            },
            "1230239@3@N": {
              "name": "Family Court District Sheopur"
            }
          }
        },
        "13": {
          "name": "Datia",
          "courtComplexes": {
            "1230044@2@N": {
              "name": "Civil Court, Seodha"
            },
            "1230045@3@N": {
              "name": "Civil Court, Bhander"
            },
            "1230046@1,4@N": {
              "name": "District and Session Court , DatiaDistrict and Session Court , Datia"
            }
          }
        },
        "14": {
          "name": "Rajgarh",
          "courtComplexes": {
            "1230047@1,7@N": {
              "name": "District & Sessions court ,RajgarhDistrict & Sessions court,Old Collectorate building, Rajgarh"
            },
            "1230048@3@N": {
              "name": "Civil Court ,KhilchipurCivil Court ,Main road ,Khilchipur"
            },
            "1230049@6@N": {
              "name": "Civil Court Sarangpur"
            },
            "1230050@4@N": {
              "name": "Civil Court, NarsinghgarhCivil Court,Lanka puri ,Narsinghgarh"
            },
            "1230051@5@N": {
              "name": "Civil Court,Near Bus Stand, Zirapur"
            },
            "1230052@2@N": {
              "name": "Civil Court,BiaoraCivil Court,Juna ,Biaora"
            }
          }
        },
        "15": {
          "name": "Morena",
          "courtComplexes": {
            "1230053@1,5@N": {
              "name": "District & Sessions Court,MorenaDistrict & Sessions Court,Morena"
            },
            "1230054@2@N": {
              "name": "Civil court , AmbahCivil court,Ambah"
            },
            "1230055@4@N": {
              "name": "Civil Court, SabalgarhCivil Court, Sabalgarh"
            },
            "1230056@3@N": {
              "name": "Civil Court ,JoraCivil Court ,M.S.Road,Jora"
            }
          }
        },
        "16": {
          "name": "Mandleshwar",
          "courtComplexes": {
            "1230057@5@N": {
              "name": "Civil Court, KasrawadKhargone-Mandleshwar Road, Opp. Bus stand Kasrawad"
            },
            "1230058@1,7@N": {
              "name": "District & Session Court, MandleshwarBarwaha Road Mandleshwar"
            },
            "1230060@6@N": {
              "name": "Civil Court, MaheshwarDhamnod-Barwaha Road, Maheshwar"
            },
            "1230061@2,8@N": {
              "name": "Civil Court, KhargoneOpp. Nagar Palika Town, Sanawad Road Khargone"
            },
            "1230062@4@N": {
              "name": "Civil Court, BhikangaonBehind Bus Stand, Bhikangaon"
            },
            "1230063@3@N": {
              "name": "Civil Court, BarwahaM.G. Road, Barwaha"
            }
          }
        },
        "17": {
          "name": "Neemuch",
          "courtComplexes": {
            "1230064@2@N": {
              "name": "Civil Court Complex JawadCivil Court Jawad District Neemuch"
            },
            "1230065@3@N": {
              "name": "Civil Court Complex ManasaCivil Court Manasa District Neemuch"
            },
            "1230066@1,4@N": {
              "name": "District & Sessions Court ,NeemuchDistrict & Sessions Court, Neemuch"
            },
            "1230231@5@N": {
              "name": "Civil Court Rampura Neemuch"
            }
          }
        },
        "18": {
          "name": "Barwani",
          "courtComplexes": {
            "1230067@5@N": {
              "name": "Civil Court , Sendhwa"
            },
            "1230068@4@N": {
              "name": "Civil Court ,Rajpur"
            },
            "1230069@3@N": {
              "name": "Civil Court ,Khetiya"
            },
            "1230070@1,6@N": {
              "name": "District & Sessions Court,Barwani"
            },
            "1230071@2@N": {
              "name": "Civil Court, Anjad"
            }
          }
        },
        "19": {
          "name": "Shajapur",
          "courtComplexes": {
            "1230073@1,5@N": {
              "name": "District & Sessions Court, ShajapurA.B. Road ,Shajapur"
            },
            "1230075@3@N": {
              "name": "Civil Court ,ShujalpurCivil Court, Shujalpur"
            }
          }
        },
        "20": {
          "name": "Chhindwara",
          "courtComplexes": {
            "1230077@3@N": {
              "name": "Civil Court, SausarCivil Court, Sausar"
            },
            "1230078@4@N": {
              "name": "Civil Court, AmarwaraCivil Court, Amarwara"
            },
            "1230079@7@N": {
              "name": "Civil Court, Junnardeo"
            },
            "1230080@2@N": {
              "name": "Civil Court, ParasiyaCivil Court, Parasiya"
            },
            "1230081@5@N": {
              "name": "Civil Court, ChoraiCivil Court, Chorai"
            },
            "1230082@6@N": {
              "name": "Civil Court, PandurnaCivil Court, Pandurna"
            },
            "1230083@9@N": {
              "name": "Civil Court Harrai Dist Chhindwara"
            },
            "1230084@1,8@N": {
              "name": "District & Sessions Court, ChhindwaraOffice of the District & Sessions Court, Chhindwara M.P. PIN- 480001"
            },
            "1230224@10@N": {
              "name": "Link Court Tamia"
            }
          }
        },
        "21": {
          "name": "Sidhi",
          "courtComplexes": {
            "1230085@3@N": {
              "name": "Civil Court, Rampurnaikin, District Sidhi"
            },
            "1230086@1,4@N": {
              "name": "District & Sessions Court, SidhiDistrict & Sessions Court, Sidhi"
            },
            "1230087@2@N": {
              "name": "Civil Court, ChurhatCivil Court Churhat Distt Sidhi"
            },
            "1230088@5@N": {
              "name": "Civil Court, MajhouliCivil Court, Majhouli"
            }
          }
        },
        "22": {
          "name": "Anuppur",
          "courtComplexes": {
            "1230089@2@N": {
              "name": "Civil Court, Rajendragram, MP"
            },
            "1230090@3@N": {
              "name": "Civil Court ,Kotma"
            },
            "1230091@1@N": {
              "name": "District Court Anuppur MP"
            },
            "1230221@4@N": {
              "name": "Family Court District Anuppur"
            }
          }
        },
        "23": {
          "name": "Shivpuri",
          "courtComplexes": {
            "1230092@2@N": {
              "name": "Civil Court ,KolarasCivil Court, Kolaras Distt. Shivpuri"
            },
            "1230093@3@N": {
              "name": "Civil Court ,PichhoreCourt Campus Pichhore Distt. Shivpuri"
            },
            "1230094@7@N": {
              "name": "Civil Court ,KhaniadhanaCivil Court, Khaniadhana Distt. Shivpuri"
            },
            "1230095@1,5@N": {
              "name": "District & Sessions Court ,ShivpuriDistrict & Sessions Court ,Shivpuri"
            },
            "1230096@4@N": {
              "name": "Civil Court,PohariCivil Court,Pohari,Distt.Shivpuri"
            },
            "1230097@6@N": {
              "name": "Civil Court, KareraCivil Court, Karera"
            }
          }
        },
        "24": {
          "name": "Raisen",
          "courtComplexes": {
            "1230098@7@N": {
              "name": "Civil Court ,UdaipuraCivil Court,Udaipura"
            },
            "1230099@1,8@N": {
              "name": "District & Sessions Court ,RaisenDistrict & Sessions Court,Sanchi Road, Raisen"
            },
            "1230100@2@N": {
              "name": "Civil Court,BareliCivil Court,Bareli"
            },
            "1230101@6@N": {
              "name": "Civil Court,SilwaniCivil Court,Silwani"
            },
            "1230102@3@N": {
              "name": "Civil Court ,BegumganjCivil Court ,Begumganj"
            },
            "1230103@4@N": {
              "name": "Civil Court,GairatganjCivil Court,Gairatganj"
            },
            "1230104@5@N": {
              "name": "Civil Court,GoharganjCivil Court,Goharganj"
            }
          }
        },
        "25": {
          "name": "Sehore",
          "courtComplexes": {
            "1230105@2@N": {
              "name": "Civil Court, BudhniCivil Court ,Budhni District Sehore"
            },
            "1230106@5@N": {
              "name": "Civil Court,IchhawarCivil Court,Ichhawar"
            },
            "1230107@3@N": {
              "name": "Civil Court, NasrullaganjCivil Court,Rehti Road, Near Bus Stand, Nasrullaganj"
            },
            "1230108@4@N": {
              "name": "Civil Court, AshtaCivil Court,Kannod Road, Ashta"
            },
            "1230109@1,6@N": {
              "name": "District & Sessions Court ,Sehore Indore-Bhopal Road, near mprtc depo, Sehore"
            }
          }
        },
        "26": {
          "name": "Balaghat",
          "courtComplexes": {
            "1230110@4@N": {
              "name": "Civil Court, Katangi"
            },
            "1230111@1,5@N": {
              "name": "District & Sessions Court, BalaghatDistrict & Sessions Court,Balaghat"
            },
            "1230112@3@N": {
              "name": "Civil Court, WaraseoniCivil court ,Waraseoni distt. balaghat m.p."
            },
            "1230113@2@N": {
              "name": "Civil Court, BaiharCivil Court, Baihar Distt.-Balaghat, M.P."
            },
            "1230225@6@N": {
              "name": "Civil Court Lanji Balaghat"
            }
          }
        },
        "27": {
          "name": "Damoh",
          "courtComplexes": {
            "1230114@5@N": {
              "name": "CIVIL COURT TENDUKHERA"
            },
            "1230115@2@N": {
              "name": "Civil Court,HattaCivil Court Building Patera Road Hatta MP"
            },
            "1230116@1,4@N": {
              "name": "District & Sessions Court,DamohNear Old Collectorate Complex Damoh MP PIN 470661"
            },
            "1230117@3@N": {
              "name": "Civil court, Pathariya District Damoh"
            }
          }
        },
        "28": {
          "name": "Vidisha",
          "courtComplexes": {
            "1230118@4@N": {
              "name": "Civil Court,LateriCivil Court,Lateri"
            },
            "1230119@5@N": {
              "name": "Civil Court, Sironj"
            },
            "1230120@2@N": {
              "name": "Civil Court,KurwaiCivil Court,Kurwai"
            },
            "1230121@3@N": {
              "name": "Civil Court, Ganjbasoda, District Vidisha"
            },
            "1230122@1,6@N": {
              "name": "District & Sessions Court VidishaDistrict & Sessions Court, Vidisha"
            }
          }
        },
        "29": {
          "name": "Bhind",
          "courtComplexes": {
            "1230123@1,5@N": {
              "name": "District & Sessions Court BhindLahar Road Bhind"
            },
            "1230124@2@N": {
              "name": "Civil Court, GohadKila Gohad Distt. Bhind MP"
            },
            "1230125@4@N": {
              "name": "Civil Court, MehgaonGandhi Road, Mehgaon Distt. Bhind MP"
            },
            "1230126@3@N": {
              "name": "Civil Court, LaharCourt Road, Lahar Distt. Bhind MP"
            }
          }
        },
        "30": {
          "name": "Guna",
          "courtComplexes": {
            "1230127@1,4@N": {
              "name": "District & Sessions Court, GunaA.B. Road, Guna"
            },
            "1230128@3@N": {
              "name": "Civil Court, RaghogarhNear Old Bus Stand, Raghogarh"
            },
            "1230129@2@N": {
              "name": "Civil Court, AaronRaghogarh Road, Aaron"
            },
            "1230130@5@N": {
              "name": "Civil Court, ChachodaTehsil Campus, Chachoda"
            }
          }
        },
        "31": {
          "name": "Singrauli",
          "courtComplexes": {
            "1230131@1,3@N": {
              "name": "District Session Court, Singrauli"
            },
            "1230132@2@N": {
              "name": "Civil Court Deosar"
            }
          }
        },
        "32": {
          "name": "Satna",
          "courtComplexes": {
            "1230133@1,7@N": {
              "name": "District & Sessions Court, satnaDistrict & sessions court satna"
            },
            "1230134@5@N": {
              "name": "Civil Court,RampurBaghelaCivil Court,RampurBaghela"
            },
            "1230135@6@N": {
              "name": "Civil Court, Uchehara"
            },
            "1230136@3@N": {
              "name": "Civil Court , MaiharCivil Court ,Maihar"
            },
            "1230137@8@N": {
              "name": "Civil Court, Chitrakoot"
            },
            "1230138@2@N": {
              "name": "Civil Court,AmarpatanCivil Court,Amarpatan"
            },
            "1230139@4@N": {
              "name": "Civil Court,NagodCivil Court,Nagod"
            }
          }
        },
        "33": {
          "name": "Seoni",
          "courtComplexes": {
            "1230140@2@N": {
              "name": "Civil Court, Lakhnadon.Civil Court, Lakhnadon Distt. Seoni."
            },
            "1230141@1,3@N": {
              "name": "District & Session Court Seoni.District Court Seoni."
            },
            "1230234@4@N": {
              "name": "civil court keolari dist. Seoni"
            },
            "1230235@5@N": {
              "name": "Civil Court Ghansor"
            },
            "1370072@1@N": {
              "name": "Link Court Chhapara District Seoni"
            }
          }
        },
        "34": {
          "name": "Katni",
          "courtComplexes": {
            "1230142@5@N": {
              "name": "Civil Court Dhimarkheda katni"
            },
            "1230143@1,3@N": {
              "name": "District & Sessions Court,KatniDistrict & Sessions Court,Katni"
            },
            "1230144@2@N": {
              "name": "Civil Court ,VijayraghavgarhJanpad Building, Vijayraghavgarh"
            },
            "1230145@4@N": {
              "name": "Civil Court Barhi District Katni"
            }
          }
        },
        "35": {
          "name": "Mandsaur",
          "courtComplexes": {
            "1230146@1,6@N": {
              "name": "District & Sessions Court ,MandsaurKila Road Fort Mandsaur"
            },
            "1230147@3@N": {
              "name": "Civil Court, BhanpuraBhanpura Garoth Road Near Bus Stand Tehasil Bhanpura District Mandsaur"
            },
            "1230148@4@N": {
              "name": "Civil Court, SitamauBehind Tehasil Office Mandsaur Road Tehasil Sitamau District Mandsaur"
            },
            "1230149@5@N": {
              "name": "Civil Court, GarothBhanpura Road Garoth District Mandsaur"
            },
            "1230150@2@N": {
              "name": "Civil Court, NarayangarhManasa Road Naraynagarh Tehasil Malhargarh District Mandsaur"
            }
          }
        },
        "36": {
          "name": "Tikamgarh",
          "courtComplexes": {
            "1230151@1,5@N": {
              "name": "District & Sessions Court,TikamgarhNear Collectorate,Jhansi Road,Tikamgarh"
            },
            "1230152@2@N": {
              "name": "Civil Court,JataraCivil Court,Jatara"
            },
            "1230153@3@N": {
              "name": "Civil Court,orchhaCivil Court,orchha"
            },
            "1230154@4@N": {
              "name": "Civil Court,NiwariCivil Court,Station Road,Niwari"
            }
          }
        },
        "37": {
          "name": "Betul",
          "courtComplexes": {
            "1230155@1,5@N": {
              "name": "District & Sessions Court,BetulDistrict & Sessions Court, Near Bus Stand, Betul"
            },
            "1230156@3@N": {
              "name": "Civil Court,MultaiCivil Court, Near Bus Stand, Multai"
            },
            "1230157@2@N": {
              "name": "Civil Court, BhainsdehiCivil Court, Bhainsdehi,"
            },
            "1230158@4@N": {
              "name": "Civil Court, Amla, District Betul"
            }
          }
        },
        "38": {
          "name": "Dhar",
          "courtComplexes": {
            "1230159@1,7@N": {
              "name": "District & Sessions Court, DharDistrict & Sessions Court, Collectorate campus, Dhar"
            },
            "1230160@4@N": {
              "name": "Civil Court, SardarpurCivil Court,Sardarpur"
            },
            "1230161@5@N": {
              "name": "Civil Court ,DharampuriCivil Court,Dhamnod Road ,Dharampuri"
            },
            "1230162@2@N": {
              "name": "Civil Court ,BadnawarCivil Court,Badnawar"
            },
            "1230163@6@N": {
              "name": "Civil Court ,KukshiCivil Court,Alirajpur Road, Kukshi"
            },
            "1230164@3@N": {
              "name": "Civil Court, ManawarCivil Court ,Behind Bus Stand ,Manawar"
            }
          }
        },
        "39": {
          "name": "Chhatarpur",
          "courtComplexes": {
            "1230165@7@N": {
              "name": "Civil Court, Bada Malehra"
            },
            "1230166@1,4@N": {
              "name": "District & Sessions Court, Chhatarpurnear Chhatrasal Chauraha, Chhatarpur m.p."
            },
            "1230167@5@N": {
              "name": "Civil Court, LaundiCivil Court, maharajpur road, Laundi"
            },
            "1230168@6@N": {
              "name": "Civil Court, Rajnagar"
            },
            "1230169@2@N": {
              "name": "Civil court, BijawarCivil court,Main road,Bijawar"
            },
            "1230170@3@N": {
              "name": "Civil court ,NowgaonCivil court,behind polytechnic collage,Nowgaon"
            }
          }
        },
        "40": {
          "name": "Dewas",
          "courtComplexes": {
            "1230171@4@N": {
              "name": "Civil Court,BagliChapda Road,Bagli"
            },
            "1230172@1,7@N": {
              "name": "District & Sessions Court, DewasDistrict & Sessions Court, Dewas"
            },
            "1230173@2@N": {
              "name": "Civil Court,KhategaonNew Building,Civil Court,Khategaon"
            },
            "1230174@6@N": {
              "name": "Civil Court, Tonkkhurd"
            },
            "1230175@5@N": {
              "name": "Civil Court,KannodCivil Court,Kannod"
            },
            "1230176@3@N": {
              "name": "Civil Court,SonkatchSonkatch main road,Sonkatch"
            }
          }
        },
        "41": {
          "name": "Mandla",
          "courtComplexes": {
            "1230177@4@N": {
              "name": "Civil Court, Nainpur"
            },
            "1230178@3@N": {
              "name": "Civil Court,NiwasCivil Court,Niwas"
            },
            "1230179@1,2@N": {
              "name": "District & Sessions Court,MandlaDistrict & Sessions Court,Mandla"
            },
            "1230230@5@N": {
              "name": "Civil court bichhiya district mandl"
            }
          }
        },
        "42": {
          "name": "Ratlam",
          "courtComplexes": {
            "1230180@2@N": {
              "name": "Civil Court, JaoraCivil Court,jaora"
            },
            "1230181@4@N": {
              "name": "Civil Court ,AloteCivil Court,Alote"
            },
            "1230182@3@N": {
              "name": "Civil Court ,SailanaCivil Court ,Sailana"
            },
            "1230183@1,5@N": {
              "name": "District & Sessions Court, RatlamDistrict & Sessions Court,Ratlam"
            }
          }
        },
        "43": {
          "name": "Sagar",
          "courtComplexes": {
            "1230184@4@N": {
              "name": "Civil Court,KhuraiCivil Court,Khurai"
            },
            "1230185@9@N": {
              "name": "Civil COURT KESLI"
            },
            "1230186@2@N": {
              "name": "Civil Court,BinaCivil Court,Bina"
            },
            "1230187@1,8@N": {
              "name": "District & Sessions Court ,SagarNew Court Building, Collectrate Area Civil Lines Sagar"
            },
            "1230188@6@N": {
              "name": "Civil Court,BandaCivil Court,Banda"
            },
            "1230189@10@N": {
              "name": "civil court shahgarh"
            },
            "1230190@3@N": {
              "name": "Civil Court,DeoriCivil Court,Deori"
            },
            "1230191@5@N": {
              "name": "Civil Court, RehliCivil Court ,Rehli"
            },
            "1230192@7@N": {
              "name": "Civil Court,GaracotaCivil Court,Garacota"
            },
            "1230223@11@N": {
              "name": "Civil Court Malthone District sagar"
            },
            "1370041@12@Y": {
              "name": "Civil Court Rahatgarh"
            }
          }
        },
        "44": {
          "name": "Gwalior",
          "courtComplexes": {
            "1230193@1@N": {
              "name": "District and Sessions Court,GwaliorJayendra ganj, Lashkar, Gwalior"
            },
            "1230194@3@N": {
              "name": "Civil Court, DabraCivil Court, Dabra"
            },
            "1230195@2@N": {
              "name": "Civil Court, BhitarwarCivil Court,Bhitarwar"
            },
            "1230229@4@N": {
              "name": "Family court district Gwalior MP"
            }
          }
        },
        "45": {
          "name": "Ujjain",
          "courtComplexes": {
            "1230196@1@N": {
              "name": "District & Sessions Court, UjjainKothi Palce, Dewas Road, Ujjain"
            },
            "1230197@7@N": {
              "name": "Civil Court, Nagda"
            },
            "1230198@2@N": {
              "name": "Civil Court, Badnagar"
            },
            "1230199@5@N": {
              "name": "Civil Court, Khachraud"
            },
            "1230200@6@N": {
              "name": "Family Court Ujjain"
            },
            "1230201@3@N": {
              "name": "Civil Court, Tarana"
            },
            "1230202@4@N": {
              "name": "Civil Court, Mahidpur"
            }
          }
        },
        "46": {
          "name": "Rewa",
          "courtComplexes": {
            "1230203@1,5@N": {
              "name": "District & Sessions Court ,RewaDistrict & Sessions Court , Kothi Compound, Rewa"
            },
            "1230204@4@N": {
              "name": "Civil Court, TeontherCivil Court,Teonther"
            },
            "1230205@2@N": {
              "name": "Civil Court,MauganjCivil Court, Mauganj"
            },
            "1230206@6@N": {
              "name": "Civil Court, Hanumana"
            },
            "1230207@3@N": {
              "name": "Civil Court,SirmourCivil Court,Sirmour"
            },
            "1370068@7@N": {
              "name": "Civil Court Mangawan"
            }
          }
        },
        "47": {
          "name": "Indore",
          "courtComplexes": {
            "1230208@2@N": {
              "name": "Civil Court,MhowCivil Court,Mhow"
            },
            "1230209@4@N": {
              "name": "Civil Court,DepalpurCivil Court,Depalpur"
            },
            "1230210@1@N": {
              "name": "District & Sessions Court,IndoreDistrict & Sessions Court,512,M.G Road,Indore"
            },
            "1230211@3@N": {
              "name": "Civil Court,SanwerCivil Court,Sanwer"
            },
            "1230212@5@N": {
              "name": "Civil Court, Hatod"
            },
            "1230226@6@N": {
              "name": "Family Court District Indore"
            }
          }
        },
        "48": {
          "name": "Ashoknagr",
          "courtComplexes": {
            "1230213@2@N": {
              "name": "civil court mugauli"
            },
            "1230214@3@N": {
              "name": "civil court chanderi"
            },
            "1230215@1,2,3,4@N": {
              "name": "District  Court AshokNagar"
            },
            "1230233@5@N": {
              "name": "Link Court Eshagarh"
            }
          }
        },
        "49": {
          "name": "Burhanpur",
          "courtComplexes": {
            "1230216@1,2@N": {
              "name": "District and Session Court"
            },
            "1230227@3@N": {
              "name": "Civil Court Nepanagar"
            }
          }
        },
        "50": {
          "name": "Bhopal",
          "courtComplexes": {
            "1230217@2@N": {
              "name": "Civil Court, Berasia"
            },
            "1230218@1@N": {
              "name": "District & sessions Court, BhopalArera Hills ,Bhopal"
            },
            "1230219@3@N": {
              "name": "Family Court District Bhopal"
            }
          }
        },
        "51": {
          "name": "Agar Malwa",
          "courtComplexes": {
            "1230236@1@N": {
              "name": "District and Session court agar"
            },
            "1230237@2@N": {
              "name": "CIVIL COURT NALKHEDA"
            },
            "1230238@3@N": {
              "name": "CIVIL COURT SUSNER"
            }
          }
        }
      }
    },
    "24": {
      "name": "Sikkim",
      "districts": {
        "1": {
          "name": "Namchi",
          "courtComplexes": {
            "1240001@8,9@N": {
              "name": "Jorethang Court Complex"
            },
            "1240003@2,3,4,5@N": {
              "name": "Namchi Court Complex"
            },
            "1370020@6,7@N": {
              "name": "Yangang Court Complex"
            }
          }
        },
        "2": {
          "name": "Mangan",
          "courtComplexes": {
            "1240004@1,2,3,4,5,6@N": {
              "name": "District and Sessions Court Complex"
            }
          }
        },
        "3": {
          "name": "Gyalshing",
          "courtComplexes": {
            "1240006@1,2,3,4@N": {
              "name": "District and Sessions Court Complex"
            }
          }
        },
        "4": {
          "name": "Gangtok",
          "courtComplexes": {
            "1240008@2,4,5,6@N": {
              "name": "District and Sessions Court Complex,"
            }
          }
        },
        "6": {
          "name": "PAKYONG",
          "courtComplexes": {
            "1240007@1,2@N": {
              "name": "Rangpo Sub-Division"
            },
            "1240009@3,4@N": {
              "name": "Rongli Sub-Division"
            }
          }
        },
        "7": {
          "name": "SORENG",
          "courtComplexes": {
            "1240005@1,2,3@N": {
              "name": "CCJM Soreng, West Sikkim"
            }
          }
        }
      }
    },
    "25": {
      "name": "Manipur",
      "districts": {
        "1": {
          "name": "Imphal East",
          "courtComplexes": {
            "1250019@5,6,9,10@N": {
              "name": "Lamphel Court Complex, Lamphel"
            },
            "1250020@11@N": {
              "name": "Jiribam Court Complex"
            },
            "1250021@1,12@N": {
              "name": "Cheirap Court Complex, Uripok"
            }
          }
        },
        "2": {
          "name": "Imphal West",
          "courtComplexes": {
            "1250022@3,6,7,8,9,12,13,16@N": {
              "name": "Lamphel Court Complex"
            },
            "1250023@11@N": {
              "name": "MACT Court Complex"
            },
            "1250024@1,5,14,15@N": {
              "name": "Cheirap Court Complex"
            }
          }
        },
        "3": {
          "name": "Bishnupur",
          "courtComplexes": {
            "1250025@1,2,3@N": {
              "name": "Bishnupur Court Complex, Bishnupur"
            }
          }
        },
        "4": {
          "name": "Thoubal",
          "courtComplexes": {
            "1250026@1,2,4@N": {
              "name": "Thoubal Court Complex"
            },
            "1250027@3@N": {
              "name": "Family Court Complex Thoubal"
            }
          }
        },
        "5": {
          "name": "Senapati",
          "courtComplexes": {
            "1250029@1@N": {
              "name": "DJ Senapati Court Complex"
            },
            "1250036@2,3@Y": {
              "name": "Kangpokpi Court Complex"
            }
          }
        },
        "6": {
          "name": "Churachandpur",
          "courtComplexes": {
            "1250030@1@N": {
              "name": "Churachandpur Court Complex"
            },
            "1370050@2@N": {
              "name": "CJM Court Complex"
            }
          }
        },
        "7": {
          "name": "Ukhrul",
          "courtComplexes": {
            "1250031@1@N": {
              "name": "DJ Court Complex Ukhrul"
            },
            "1250032@2@N": {
              "name": "CJM Ukhrul Court Complex,Ukhrul"
            }
          }
        },
        "8": {
          "name": "Chandel",
          "courtComplexes": {
            "1250033@1,3@N": {
              "name": "Chandel Court Complex"
            },
            "1250037@2@N": {
              "name": "Moreh Court Complex"
            }
          }
        },
        "9": {
          "name": "Tamenglong",
          "courtComplexes": {
            "1250039@2@N": {
              "name": "DJ Tamenglong Court Complex"
            },
            "1250040@1@N": {
              "name": "CJM Tamenglong"
            }
          }
        }
      }
    },
    "26": {
      "name": "Delhi",
      "districts": {
        "1": {
          "name": "North East",
          "courtComplexes": {
            "1260001@1,2,3,4@Y": {
              "name": "Karkardooma Court Complex"
            }
          }
        },
        "2": {
          "name": "Shahdara",
          "courtComplexes": {
            "1260002@1,2,3,4,5@Y": {
              "name": "Karkardooma Court Complex"
            }
          }
        },
        "3": {
          "name": "East",
          "courtComplexes": {
            "1260003@1,2,3,4,5@N": {
              "name": "Karkardooma Court Complex"
            }
          }
        },
        "4": {
          "name": "North",
          "courtComplexes": {
            "1260004@1,2,3,4@Y": {
              "name": "Rohini Court Complex"
            }
          }
        },
        "5": {
          "name": "North West",
          "courtComplexes": {
            "1260005@1,2,3,4@Y": {
              "name": "Rohini Court Complex"
            }
          }
        },
        "6": {
          "name": "South West",
          "courtComplexes": {
            "1260006@1,2,3,5,6@Y": {
              "name": "Dwarka Court Complex"
            }
          }
        },
        "7": {
          "name": "New Delhi",
          "courtComplexes": {
            "1260007@1,2,3,4@Y": {
              "name": "Patiala House Court Complex"
            }
          }
        },
        "8": {
          "name": "Central",
          "courtComplexes": {
            "1260008@5,6,7@N": {
              "name": "Rouse Avenue Court Complex"
            },
            "1260009@1,2,3,4,8@Y": {
              "name": "Tis Hazari Court Complex"
            }
          }
        },
        "9": {
          "name": "West",
          "courtComplexes": {
            "1260010@1,2,3,4@Y": {
              "name": "Tis Hazari Court Complex"
            }
          }
        },
        "10": {
          "name": "South",
          "courtComplexes": {
            "1260011@1,2,3,4@Y": {
              "name": "Saket Court Complex"
            }
          }
        },
        "11": {
          "name": "South East",
          "courtComplexes": {
            "1260012@1,2,3,4@Y": {
              "name": "Saket Court Complex"
            }
          }
        }
      }
    },
    "27": {
      "name": "Chandigarh",
      "districts": {
        "1": {
          "name": "Chandigarh",
          "courtComplexes": {
            "1270001@1,2,3@N": {
              "name": "District Court Chandigarh"
            }
          }
        }
      }
    },
    "28": {
      "name": "Andaman and Nicobar",
      "districts": {
        "1": {
          "name": "Port Blair",
          "courtComplexes": {
            "1280004@2,3,4,5@N": {
              "name": "PORT BLAIR COURT COMPLEX"
            }
          }
        },
        "82": {
          "name": "Nicobars",
          "courtComplexes": {

          }
        },
        "83": {
          "name": "North And Middle Andaman",
          "courtComplexes": {

          }
        },
        "84": {
          "name": "SOUTH ANDAMANS",
          "courtComplexes": {

          }
        }
      }
    },
    "29": {
      "name": "Telangana",
      "districts": {
        "1": {
          "name": "Adilabad",
          "courtComplexes": {
            "1290005@1,2,3,4,5@N": {
              "name": "Adilabad, PDJ Court Complex"
            },
            "1290009@21@N": {
              "name": "Utnoor, JCJ Court Complex"
            },
            "1290014@14@N": {
              "name": "Boath, JCJ Court Complex"
            }
          }
        },
        "2": {
          "name": "Hyderabad",
          "courtComplexes": {
            "1290016@21,30,31@N": {
              "name": "HYD, CBI Court Complex"
            },
            "1290017@16,17,29@N": {
              "name": "HYD, City SmallCauses Court Complex"
            },
            "1290018@1,10,12,23,24,25,26@N": {
              "name": "SEC-BAD, CCC-CSCC-MSJ Court Complex"
            },
            "1290019@2,6,11,20@N": {
              "name": "HYD, City Civil Court Complex"
            },
            "1290022@3,5,8,28@N": {
              "name": "HYD, Criminal Court Complex"
            },
            "1290025@18@N": {
              "name": "HYD, V ACMM Juvanile Court Complex"
            },
            "1290026@22@N": {
              "name": "HYD, MM Court Complex"
            },
            "1290027@19@N": {
              "name": "HYD, II MM Railway Court Complex"
            },
            "1290227@32@N": {
              "name": "HACA Bhavan, POCSO Court Complex"
            },
            "1290228@27,33@N": {
              "name": "Hyd,Integrated Family Court Complex"
            }
          }
        },
        "3": {
          "name": "Karimnagar",
          "courtComplexes": {
            "1290030@19,20@N": {
              "name": "Huzurabad, SCJ Court  Complex"
            },
            "1290041@1,2,3,18,23@N": {
              "name": "Karimnagar, PDJ Court Complex"
            }
          }
        },
        "4": {
          "name": "Khammam",
          "courtComplexes": {
            "1290043@6,17@N": {
              "name": "Madhira, JCJ Court Complex"
            },
            "1290045@13,14,16@N": {
              "name": "Satupally, SCJ Court Complex"
            },
            "1290048@1,2,3,4,15@N": {
              "name": "Khammam, PDJ Court Complex"
            }
          }
        },
        "5": {
          "name": "Mahabubnagar",
          "courtComplexes": {
            "1290056@1,3,4,5,15,21@N": {
              "name": "Mahabubnagar, PDJ Court Complex"
            },
            "1290064@6@N": {
              "name": "Jadcherla, JCJ Court Complex"
            }
          }
        },
        "6": {
          "name": "Medak",
          "courtComplexes": {
            "1290074@5@N": {
              "name": "Allahdurg, JCJ Court Complex"
            },
            "1290076@12,15,17,19@N": {
              "name": "Medak, PDJ Court Complex"
            },
            "1290079@10@N": {
              "name": "Narsapur, JCJ Court Complex"
            }
          }
        },
        "7": {
          "name": "Nalgonda",
          "courtComplexes": {
            "1290084@4,5,6,7@N": {
              "name": "Miryalaguda, V ADJ Court Complex"
            },
            "1290086@1,2,3,16,17,18@N": {
              "name": "Nalgonda, PDJ Court Complex"
            },
            "1290089@19@N": {
              "name": "Nidamanoor, JCJ Court Complex"
            },
            "1290092@15,22@N": {
              "name": "Nakrekal, JCJ Court Complex"
            },
            "1290095@12,23@N": {
              "name": "Devarakonda, JCJ Court Complex"
            }
          }
        },
        "8": {
          "name": "Nizamabad",
          "courtComplexes": {
            "1290096@2,3,8,18@N": {
              "name": "Bodhan, V ADJ Court Complex"
            },
            "1290098@1,5,9,13@N": {
              "name": "Nizamabad, PDJ Court Complex"
            },
            "1290102@10,11,12@N": {
              "name": "Armoor, SCJ Court Complex"
            }
          }
        },
        "9": {
          "name": "Rangareddy",
          "courtComplexes": {
            "1290105@24@N": {
              "name": "Maheshwaram, SCJ Court Complex"
            },
            "1290106@19,32,41@N": {
              "name": "Rajendra Nagar, ADJ Court Complex"
            },
            "1290111@22@N": {
              "name": "Hayathnagar, JCJcumXIV AMM Court Complex"
            },
            "1290112@1,2,3,5,6,31,43@N": {
              "name": "Rangareddy, PDJ Court Complex"
            },
            "1290114@11,25,42@N": {
              "name": "Chevella, ADJ Court Complex"
            },
            "1290115@36,37,38@N": {
              "name": "Kukatpally, ADJ-cum-Family Court"
            },
            "1290117@4,20,40@N": {
              "name": "Ibrahimpatnam,ADJ Court Complex"
            },
            "1290220@33,34,35@N": {
              "name": "Shadnagar, ADJ Court Complex"
            },
            "1290226@39@N": {
              "name": "Amangal, JCJ Court Complex"
            }
          }
        },
        "10": {
          "name": "Warangal",
          "courtComplexes": {
            "1290118@1,5,6@N": {
              "name": "Warangal, PDJ Court Complex"
            },
            "1290124@3,18@N": {
              "name": "Narsampet, JCJ Court Complex"
            }
          }
        },
        "13": {
          "name": "Bhadradri Kothagudem",
          "courtComplexes": {
            "1290142@1,2,3@N": {
              "name": "Kothagudem, PDJ Court Complex"
            },
            "1290177@5@N": {
              "name": "Yellandu, PJCJ Court Complex"
            },
            "1290186@6@N": {
              "name": "Bhadrachalam, JCJ Court Complex"
            },
            "1290187@7@N": {
              "name": "Manuguru, JCJ Court Complex"
            },
            "1290230@4@N": {
              "name": "Dammapeta, JCJ Court Complex"
            }
          }
        },
        "14": {
          "name": "Hanumakonda",
          "courtComplexes": {
            "1290201@4,5,6,7@N": {
              "name": "Hanumakonda, PDJ Court Complex"
            },
            "1290202@2@N": {
              "name": "Parkal, JCJ Court Complex"
            },
            "1290223@1@N": {
              "name": "Kazipet, JFCM Railway Court Complex"
            }
          }
        },
        "15": {
          "name": "Jagitial",
          "courtComplexes": {
            "1290137@1,3,4@N": {
              "name": "Jagitial, PDJ Court Complex"
            },
            "1290138@5@N": {
              "name": "Korutla, JCJ Court Complex"
            },
            "1290139@8,9@N": {
              "name": "Metpalli, SCJ Court Complex"
            },
            "1290140@7@N": {
              "name": "Dharmapuri, JCJ Court Complex"
            }
          }
        },
        "16": {
          "name": "Jangoan",
          "courtComplexes": {
            "1290143@1,2,3@N": {
              "name": "Jangoan, PDJ Court Complex"
            },
            "1370067@4@N": {
              "name": "Ghanpur, JCJ Court Complex"
            }
          }
        },
        "17": {
          "name": "Jayashankar Bhupalapally",
          "courtComplexes": {
            "1290144@1,2,3@N": {
              "name": "JS Bhupalapally, PDJ Court Complex"
            }
          }
        },
        "18": {
          "name": "Jogulamba Gadwal",
          "courtComplexes": {
            "1290145@1,2,3@N": {
              "name": "Jogulamba Gadwal, PDJ Court Complex"
            },
            "1290173@4@N": {
              "name": "Alampur, JCJ Court Complex"
            }
          }
        },
        "19": {
          "name": "Kamareddy",
          "courtComplexes": {
            "1290146@1,2,3,4@N": {
              "name": "Kamareddy, PDJ Court Complex"
            },
            "1290162@7@N": {
              "name": "Banswada, JCJ Court Complex"
            },
            "1290166@5@N": {
              "name": "Bichkunda, JCJ Court Complex"
            },
            "1290167@6@N": {
              "name": "Yellareddy, JCJ Court Complex"
            }
          }
        },
        "20": {
          "name": "Kumuram Bheem Asifabad",
          "courtComplexes": {
            "1290163@5,6,7@N": {
              "name": "Asifabad, PDJ Court Complex"
            },
            "1290168@4@N": {
              "name": "Sirpur, JCJ Court Complex"
            }
          }
        },
        "21": {
          "name": "Mahabubabad",
          "courtComplexes": {
            "1290147@1,2,3@N": {
              "name": "Mahabubabad, PDJ Court Complex"
            },
            "1290204@4@N": {
              "name": "Thorrur, JCJ Court Complex"
            }
          }
        },
        "22": {
          "name": "Mancherial",
          "courtComplexes": {
            "1290148@2@N": {
              "name": "Mancherial, PDJ Court Complex"
            },
            "1290170@1,7@N": {
              "name": "Mancherial, SCJ Court Complex"
            },
            "1290171@3@N": {
              "name": "Mancherial, Spl.JFCM Court Complex"
            },
            "1290172@8@N": {
              "name": "Luxettipet, JCJ Court Complex"
            },
            "1290175@5@N": {
              "name": "Bellampalli, JCJ Court Complex"
            },
            "1290176@6@N": {
              "name": "Chennur, JCJ Court Complex"
            }
          }
        },
        "23": {
          "name": "Medchal Malkajgiri",
          "courtComplexes": {
            "1290149@2,3,4@N": {
              "name": "Malkajgiri, PDJ Court Complex"
            },
            "1290217@12,13,14@N": {
              "name": "Kukatpally, ADJ Court Complex"
            },
            "1290218@1,5,6,16@N": {
              "name": "Medchal, ADJ Court Complex"
            },
            "1290219@11@N": {
              "name": "Athivelli, JCJ Court Complex"
            },
            "1370023@15@N": {
              "name": "PJCJ, LB Nagar"
            }
          }
        },
        "24": {
          "name": "Mulugu",
          "courtComplexes": {
            "1290150@3,4,5@N": {
              "name": "Mulugu, PDJ Court Complex"
            }
          }
        },
        "25": {
          "name": "Nagarkurnool",
          "courtComplexes": {
            "1290151@1,2,3,4@N": {
              "name": "Nagarkurnool, PDJ Court Complex"
            },
            "1290182@5@N": {
              "name": "Achampet, JCJ Court Complex"
            },
            "1290184@7,8@N": {
              "name": "Kalwakurthy, SCJ Court Complex"
            },
            "1290185@6@N": {
              "name": "Kollapur, JCJ Court Complex"
            }
          }
        },
        "26": {
          "name": "Narayanpet",
          "courtComplexes": {
            "1290152@1,2,3@N": {
              "name": "Narayanpet, PDJ Court Complex"
            },
            "1290225@4@N": {
              "name": "Kosgi, JCJ Court Complex"
            }
          }
        },
        "27": {
          "name": "Nirmal",
          "courtComplexes": {
            "1290153@1,3@N": {
              "name": "Nirmal, PDJ Court Complex"
            },
            "1290179@2@N": {
              "name": "Nirmal, SCJ Court Complex"
            },
            "1290180@4@N": {
              "name": "Bhainsa, JCJ Court Complex"
            },
            "1290183@5@N": {
              "name": "Khanapur JCJ Court Complex"
            }
          }
        },
        "28": {
          "name": "Peddapalli",
          "courtComplexes": {
            "1290154@1@N": {
              "name": "Peddpalli - PDJ Court Complex"
            },
            "1290209@2,4@N": {
              "name": "Peddpalli - SCJ Court Complex"
            },
            "1290210@5@N": {
              "name": "Godavarikhani - JCJ Court Complex"
            },
            "1290211@6,9@N": {
              "name": "Manthani - SCJ Court Complex"
            },
            "1290212@7@N": {
              "name": "Sulthanabad, JCJ Court Complex"
            },
            "1290213@8,10@N": {
              "name": "Godavarikhani, ADJ Court Complex"
            },
            "1290229@11@N": {
              "name": "Nandimyadaram, JCJ Court Complex"
            },
            "1370103@3@N": {
              "name": "Odela, JCJ Court Complex"
            }
          }
        },
        "29": {
          "name": "Rajanna Siricilla",
          "courtComplexes": {
            "1290155@1,2,3,4,5@N": {
              "name": "Rajanna Sircilla, PDJ Court Complex"
            },
            "1290207@4,5@N": {
              "name": "Vemulawada, SCJ Court Complex"
            }
          }
        },
        "30": {
          "name": "Sangareddy",
          "courtComplexes": {
            "1290156@1,2,3,4@N": {
              "name": "Sangareddy, PDJ Court Complex"
            },
            "1290188@5,6@N": {
              "name": "Zaheerabad, SCJ Court Complex"
            },
            "1290190@9@N": {
              "name": "Jinnaram, JCJ Complex"
            },
            "1290191@7@N": {
              "name": "Jogipet, JCJ Court Complex"
            },
            "1290192@8@N": {
              "name": "Narayankhed, JCJ Court Complex"
            }
          }
        },
        "31": {
          "name": "Siddipet",
          "courtComplexes": {
            "1290157@2,3,4@N": {
              "name": "Siddipet, PDJ Court Complex"
            },
            "1290193@5@N": {
              "name": "Gajwel, JCJ Court Complex"
            },
            "1290196@6@N": {
              "name": "Dubbak, JCJ Court Complex"
            },
            "1290198@1@N": {
              "name": "Husnabad, JCJ Court Complex"
            },
            "1370024@7@N": {
              "name": "Cherial, JCJ Court Complex"
            }
          }
        },
        "32": {
          "name": "Suryapet",
          "courtComplexes": {
            "1290158@1,2,3@N": {
              "name": "Suryapet, PDJ Court Complex"
            },
            "1290189@4,5,8@N": {
              "name": "Huzurnagar, ADJ Court Complex"
            },
            "1290194@7@N": {
              "name": "Thungathurthy, JCJ Court Complex"
            },
            "1290195@6,9@N": {
              "name": "Kodad, SCJ Court Complex"
            }
          }
        },
        "33": {
          "name": "Vikarabad",
          "courtComplexes": {
            "1290159@1,2,3@N": {
              "name": "Vikarabad, PDJ Court Complex"
            },
            "1290214@6@N": {
              "name": "Kodangal, JCJ Court Complex"
            },
            "1290215@5@N": {
              "name": "Parigi, JCJ Court Complex"
            },
            "1290216@4@N": {
              "name": "Tandur, JCJ Court Complex"
            }
          }
        },
        "34": {
          "name": "Wanaparthy",
          "courtComplexes": {
            "1290160@1,2,3@N": {
              "name": "Wanaparthy, PDJ Court Complex"
            },
            "1290174@4@N": {
              "name": "Atmakur, JCJ Court Complex"
            }
          }
        },
        "35": {
          "name": "Yadadri Bhuvanagiri",
          "courtComplexes": {
            "1290161@1,3,4@N": {
              "name": "Yadadri Bhuvanagiri, PDJ Cout Complex"
            },
            "1290197@7@N": {
              "name": "Choutuppal, JCJ Court Complex"
            },
            "1290199@5,8@N": {
              "name": "Ramannapet, JCJ Court Complex"
            },
            "1290200@6@N": {
              "name": "Alair, JCJ Court Complex"
            },
            "1370065@9@N": {
              "name": "Yadadri, JCJ Court Complex"
            }
          }
        }
      }
    },
    "30": {
      "name": "Goa",
      "districts": {
        "1": {
          "name": "North Goa",
          "courtComplexes": {
            "1300002@8@N": {
              "name": "Sattari at Valpoi Civil and Crim Ct"
            },
            "1300003@9@N": {
              "name": "Ponda, Civil and Criminal Court"
            },
            "1300004@6@N": {
              "name": "Mapusa, Dist and Session Court II"
            },
            "1300005@1@N": {
              "name": "Tiswadi, Civil and Criminal Court"
            },
            "1300006@2@N": {
              "name": "Mapusa,District and Session Court I"
            },
            "1300007@5@N": {
              "name": "Panaji, Goa, Civil and Criminal Ct"
            },
            "1300008@4@N": {
              "name": "Pernem,Civil and Criminal Court"
            },
            "1300009@10@N": {
              "name": "Mapusa, Fast Track Court"
            },
            "1300011@3@N": {
              "name": "Bicholim, Civil and Criminal Court"
            }
          }
        },
        "2": {
          "name": "South Goa",
          "courtComplexes": {
            "1300012@3@N": {
              "name": "Canacona, Civil and Criminal Court"
            },
            "1300013@6@N": {
              "name": "Margao, Civil and Criminal Court"
            },
            "1300014@5@N": {
              "name": "Vasco da Gama,Civil and Criminal Ct"
            },
            "1300015@2@N": {
              "name": "Sanguem, Civil and Criminal Court"
            },
            "1300016@1@N": {
              "name": "Margao, District and Sessions Ct"
            },
            "1300017@4@N": {
              "name": "Quepem, Civil and Criminal Court"
            }
          }
        }
      }
    },
    "33": {
      "name": "Ladakh",
      "districts": {
        "1": {
          "name": "Kargil",
          "courtComplexes": {
            "1330001@8,9,10@N": {
              "name": "District Court, Kargil"
            },
            "1330002@11,12@N": {
              "name": "Munsiff Court, Drass"
            },
            "1330004@4,5@N": {
              "name": "Munisff Court Zanskar"
            },
            "1330005@6,7@N": {
              "name": "Munsiff Court Sanku"
            }
          }
        },
        "2": {
          "name": "Leh",
          "courtComplexes": {
            "1330003@6,7,8@N": {
              "name": "District Court ,Leh"
            },
            "1330006@4,5@N": {
              "name": "Munsiff Court Nobra"
            }
          }
        }
      }
    },
    "34": {
      "name": "Nagaland",
      "districts": {
        "1": {
          "name": "Dimapur",
          "courtComplexes": {
            "1340003@1,2,3,4,6@Y": {
              "name": "District Court Complex Dimapur"
            }
          }
        },
        "2": {
          "name": "Kohima",
          "courtComplexes": {
            "1340002@1,2,3@Y": {
              "name": "District Court Complex Kohima"
            }
          }
        },
        "3": {
          "name": "Mokokchung",
          "courtComplexes": {
            "1340005@1,2,3@Y": {
              "name": "District Court Complex Mokokchung"
            }
          }
        },
        "4": {
          "name": "Wokha",
          "courtComplexes": {
            "1340006@1,2,3@Y": {
              "name": "District Court Complex Wokha"
            }
          }
        },
        "5": {
          "name": "Zunheboto",
          "courtComplexes": {
            "1340007@1,2@Y": {
              "name": "District Court Complex Zunheboto"
            }
          }
        },
        "6": {
          "name": "Phek",
          "courtComplexes": {
            "1340009@1,2,3@Y": {
              "name": "District Court Complex Phek"
            }
          }
        },
        "7": {
          "name": "Mon",
          "courtComplexes": {
            "1340011@1,2,3@Y": {
              "name": "District Court Complex Mon"
            }
          }
        },
        "8": {
          "name": "Longleng",
          "courtComplexes": {
            "1340008@1,2,3@Y": {
              "name": "District Court Complex Longleng"
            }
          }
        },
        "9": {
          "name": "Tuensang",
          "courtComplexes": {
            "1340010@1,2,3@Y": {
              "name": "District Court Complex Tuensang"
            }
          }
        },
        "11": {
          "name": "Peren",
          "courtComplexes": {
            "1340012@1,2,3@Y": {
              "name": "District Court Complex Peren"
            }
          }
        },
        "12": {
          "name": "Kiphire",
          "courtComplexes": {
            "1340013@1,2,3@Y": {
              "name": "District Court Complex Kiphire"
            }
          }
        }
      }
    },
    "35": {
      "name": "Puducherry",
      "districts": {
        "28": {
          "name": "Puducherry",
          "courtComplexes": {
            "1350244@2,3,4,5,6,15,16,17@N": {
              "name": "Integrated Courts, Puducherry"
            }
          }
        },
        "34": {
          "name": "Karaikal",
          "courtComplexes": {
            "1350321@1,3,5,6,7,8@N": {
              "name": "Combined Courts, Karaikal"
            }
          }
        },
        "35": {
          "name": "Mahe",
          "courtComplexes": {
            "1350319@1,2@N": {
              "name": "Sub Court Complex , Mahe"
            }
          }
        },
        "36": {
          "name": "Yanam",
          "courtComplexes": {
            "1350320@1@N": {
              "name": "Sub Court Complex, Yanam"
            }
          }
        }
      }
    },
    "36": {
      "name": "Arunachal Pradesh",
      "districts": {
        "1": {
          "name": "Lohit",
          "courtComplexes": {
            "1360001@1@N": {
              "name": "District and Sessions Court, Tezu"
            }
          }
        },
        "2": {
          "name": "Upper Subansiri",
          "courtComplexes": {
            "1360018@1@N": {
              "name": "JMFC-cum-Civil Court, Daporijo"
            }
          }
        },
        "3": {
          "name": "Papum Pare",
          "courtComplexes": {
            "1360003@1@N": {
              "name": "District and Sessions Court, Yupia"
            },
            "1360010@2@N": {
              "name": "CJM-cum-Civil Court, Yupia"
            },
            "1360011@3@N": {
              "name": "JMFC-cum-Civil Court, Yupia"
            }
          }
        },
        "4": {
          "name": "West Kameng",
          "courtComplexes": {
            "1360004@2@N": {
              "name": "District and Sessions Court,Bomdila"
            }
          }
        },
        "5": {
          "name": "Upper Siang",
          "courtComplexes": {
            "1360019@1@N": {
              "name": "JMFC-cum-Civil Court, Yingkiong"
            }
          }
        },
        "6": {
          "name": "East Siang",
          "courtComplexes": {
            "1360006@1@N": {
              "name": "District and Session Court,Pasighat"
            }
          }
        },
        "7": {
          "name": "West Siang",
          "courtComplexes": {
            "1360020@1@N": {
              "name": "CJM-cum-Civil Judge Court, Aalo"
            }
          }
        },
        "8": {
          "name": "Lower Subansiri",
          "courtComplexes": {
            "1360015@1@N": {
              "name": "CJM-cum-Civil Court, Ziro"
            }
          }
        },
        "9": {
          "name": "Tirap",
          "courtComplexes": {
            "1360022@1@N": {
              "name": "JMFC-cum-Civil Court, Khonsa"
            }
          }
        },
        "10": {
          "name": "Lower Dibang Valley",
          "courtComplexes": {
            "1360012@1@N": {
              "name": "CJM-cum-Civil Court, Roing"
            }
          }
        },
        "11": {
          "name": "Leparada",
          "courtComplexes": {
            "1360013@1@N": {
              "name": "A/District and Sessions Court,Basar"
            }
          }
        },
        "12": {
          "name": "Tawang",
          "courtComplexes": {
            "1360014@1@N": {
              "name": "JMFC-cum-Civil Court, Tawang"
            }
          }
        },
        "13": {
          "name": "East Kameng",
          "courtComplexes": {
            "1360016@1@N": {
              "name": "CJM-cum-Civil Court, Seppa"
            }
          }
        },
        "89": {
          "name": "Anjaw",
          "courtComplexes": {

          }
        },
        "90": {
          "name": "Siang",
          "courtComplexes": {

          }
        },
        "91": {
          "name": "Keyi Panyor",
          "courtComplexes": {

          }
        },
        "92": {
          "name": "Shi Yomi",
          "courtComplexes": {

          }
        },
        "93": {
          "name": "Bichom",
          "courtComplexes": {

          }
        },
        "94": {
          "name": "Kra Dadi",
          "courtComplexes": {

          }
        },
        "95": {
          "name": "Kamle",
          "courtComplexes": {

          }
        },
        "96": {
          "name": "Pakke Kessang",
          "courtComplexes": {

          }
        },
        "97": {
          "name": "Longding",
          "courtComplexes": {

          }
        },
        "98": {
          "name": "Kurung Kumey",
          "courtComplexes": {

          }
        },
        "99": {
          "name": "Dibang Valley",
          "courtComplexes": {

          }
        },
        "100": {
          "name": "Changlang",
          "courtComplexes": {

          }
        },
        "101": {
          "name": "Namsai",
          "courtComplexes": {

          }
        },
        "102": {
          "name": "Lower Siang",
          "courtComplexes": {

          }
        }
      }
    },
    "37": {
      "name": "Lakshadweep",
      "districts": {
        "1": {
          "name": "Lakshadweep",
          "courtComplexes": {
            "1370001@1@N": {
              "name": "District Court Kavaratti"
            },
            "1370002@2,3,4@N": {
              "name": "Court Complex Androth"
            },
            "1370003@5,6@N": {
              "name": "Court Complex Amini"
            }
          }
        }
      }
    },
    "38": {
      "name": "The Dadra And Nagar Haveli And Daman And Diu",
      "districts": {
        "1": {
          "name": "Diu",
          "courtComplexes": {
            "1310004@1@N": {
              "name": "Court Complex, Diu"
            }
          }
        },
        "2": {
          "name": "Daman",
          "courtComplexes": {
            "1310006@1@N": {
              "name": "Court Complex, Daman"
            }
          }
        },
        "3": {
          "name": "Silvassa",
          "courtComplexes": {
            "1320002@1@N": {
              "name": "Silvassa, District and Sessions Ct"
            }
          }
        }
      }
    }
  }
}